// 자동으로 만든 파일 — public/app/_play/ 의 조각을 고치고 node tools/build_parts.mjs 로 다시 만든다(이 파일을 직접 고치지 말 것)
(() => {
// 다른 스크립트가 쓰는 이름만 연다 — 나머지 이름은 이 함수 안에만 있다(조각은 ES 모듈 · tools/build_parts.mjs)
window.toast = toast; window.engineReq = engineReq; window.startPaid = startPaid; window.vaultKey = vaultKey; window.unlock = unlock; Object.defineProperty(window, "bgm", { get: () => bgm, configurable: true }); Object.defineProperty(window, "M", { get: () => M, configurable: true });
// 무비 한 편 — public/app/data/{번호}.json(tools/site_build.py · site_idle.py)을 읽어 무비6(무료)·유료2(유료) 동작을 인물 공통으로 돌린다.
// 사장님 9/25 「지금 만든 캐릭터들 전부 로컬 사이트에 올리고 실제 쓸 ui도 넣자」
// 유료(9/25): 「유료 결과 확인하기」 → 인물이 립싱크로 말함(자막 없음) → 음성이 끝나면 결과지가 올라옴 → 「다음 장」 → 같은 순서.
// 여는 말은 그 장을 처음 열 때만. 결과지는 자동으로 넘어가지 않고, 바로 전 장으로 가는 버튼이 있다.
// 9/26 사장님: 넘어갈 때 인물이 끊기지 않게(영상 절) · 장 번호 숫자 안내는 전부 지움 · 결과지를 받으면 풀이 전부를 보관함에(보관함 절).
const $ = (id) => document.getElementById(id);
const C = String(new URLSearchParams(location.search).get("c") || "1").padStart(2, "0");
const wait = (ms) => new Promise((r) => setTimeout(r, ms));
const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
// 풀이 글에 붙어 온 꼬리표(</advice> · </invoke> 같은 것)를 지운다 — 9/27 사장님 「가장 아래에 영어 뭐야」. 이미 저장된 글에도 쓴다.
const tidy = (s) => String(s ?? "").replace(/<\/?[A-Za-z_][\w:-]*[^>]*>/g, "").trim();
const pad = (n) => String(n).padStart(2, "0");
const ymd = (a) => `${a[0]}-${pad(a[1])}-${pad(a[2])}`;
let M = null;
const M바꿈 = (값) => (M = 값);   // 다른 조각이 바꿀 때(모듈은 가져온 이름에 직접 넣을 수 없다)
const bgm = typeof BGM !== "undefined" ? BGM : { start() {}, talk() {}, scene() {} };   // 배경음악(bgm.js, 9/27) — 없으면 조용히 건너뛴다

// 10/1 인터랙션(기획/119) — 눌림 · 등장 · 공개 · 떨림(사장님 「그렇게하자」 → 로컬에서 보시고 「올려」 — 모두에게 켠다). <html class="fx"> — 새 CSS 는 모두 .fx 아래(play.html · review.js),
// 새 동작(눌림 · 숫자 올리기 · 차례 · 떨림)은 fxOn() 일 때만. 「동작 줄이기」(prefers-reduced-motion)를 켠 사람에게는 모두 뺀다.
const FX = true;
document.documentElement.classList.add("fx");
const RMQ = window.matchMedia ? matchMedia("(prefers-reduced-motion: reduce)") : null;
const fxOn = () => FX && !RMQ?.matches;
const FXE = "cubic-bezier(.2,.7,.2,1)";   // 공통 곡선(결과 공개와 같다)
// 떨림은 결제 · 별점 · 선택 순간과 바퀴 칸 넘김만(안드로이드 · 앱 — 아이폰 브라우저는 지원 안 함)
const buzz = (ms = 10) => { if (!fxOn()) return; try { navigator.vibrate?.(ms); } catch { /* 떨림 없이 */ } };
// 7 눌림 — scale .97 0.12초 → 놓으면 0.18초에 돌아온다. 톡 짧게 눌러도 보이게 0.09초는 눌린 채 둔다.
// 단추마다 걸린 transform · transition(고른 선택지가 커지는 것 등)과 겹치지 않게 따로 떨어진 scale 값만 움직인다(Web Animations — 모르는 브라우저는 그대로).
function fxHold(el, prop, to) {
  const rest = prop === "scale" ? "1" : "0 0", t0 = performance.now(); let a;
  try { a = el.animate([{ [prop]: rest }, { [prop]: to }], { duration: 120, easing: FXE, fill: "forwards" }); } catch { return () => {}; }
  return () => setTimeout(() => { const s = getComputedStyle(el)[prop]; a.cancel(); try { el.animate([{ [prop]: s && s !== "none" ? s : to }, { [prop]: rest }], { duration: 180, easing: FXE }); } catch { /* 그대로 */ } }, Math.max(0, 90 - (performance.now() - t0)));
}
if (FX) {
  let fxUp = null;
  const rel = () => { fxUp?.(); fxUp = null; };
  addEventListener("pointerdown", (e) => {
    rel(); if (!fxOn() || e.button > 0) return;
    const b = e.target.closest?.("button");
    if (b && !b.disabled) fxUp = fxHold(b, "scale", ".97");
  }, { capture: true, passive: true });
  addEventListener("pointerup", rel, { capture: true, passive: true }); addEventListener("pointercancel", rel, { capture: true, passive: true });
}

const rgb = () => (getComputedStyle(document.documentElement).getPropertyValue("--glow") || "226,62,72").split(",").map((x) => +x.trim());
// 10/8 애플 기준 — 알림 글은 낭독된다(play.html #toast role=status). 긴 글(무슨 일 · 어떻게 하면 되는지)은 읽을 만큼 오래 둔다(2.2초 + 글자당 0.06초, 6초까지)
function toast(t) { const el = $("toast"); el.textContent = t; el.classList.add("on"); clearTimeout(toast.t); toast.t = setTimeout(() => el.classList.remove("on"), Math.min(6000, 2200 + String(t).length * 60)); if (/못|실패|오류/.test(t)) window.BGWATCH?.report("손님에게 보인 실패", `${M?.no ?? ""}번 질문 · ${t}`); }   // 10/7 감시(deploy/alerts.js)
// 10/1 코드 점검 — 홈으로 갈 때 기록을 새로 쌓지 않는다(안드로이드 앱에서 홈으로 간 뒤 뒤로 가기를 누르면 무비로 되돌아왔다).
// 홈에서 들어왔으면 뒤로 가고(홈이 그대로 되살아난다), 아니면 이 자리를 홈으로 바꾼다. 뒤로 가기가 안 먹으면 잠시 뒤 바꾼다.
// 10/2 점검 — 뒤로 가기 막이(아래) 위에 있으면 막이까지 한 번에 건너간다. 주소로 바로 들어온 때는 막이를 걷은 뒤(popstate) 홈으로 바꾼다 — 막이 밑 무비 자리가 기록에 남지 않게
let 나감 = "";   // goHome 이 기록을 옮기는 중 — "back"(홈으로 뒤로) · "replace"(막이를 걷고 홈으로 바꿈). 그동안의 popstate 는 받지 않는다
const homeURL = () => window.BGLANG?.link?.("/") || "/";
function goHome() {
  let fromHome = false;
  try { const r = new URL(document.referrer); fromHome = r.origin === location.origin && /^\/(index\.html)?$/.test(r.pathname); } catch { /* 주소로 바로 들어옴 */ }
  const g = history.state?.bg ? 1 : 0;
  // 10/8 점검 — 잠시 뒤 바꾸기는 2.5초 뒤(0.8초는 느린 폰에서 진짜 뒤로 가기와 겹쳤다)
  const t = setTimeout(() => location.replace(homeURL()), 2500); addEventListener("pagehide", () => clearTimeout(t), { once: true });
  if (!fromHome || history.length < 2 + g) {
    if (!g) { clearTimeout(t); location.replace(homeURL()); return; }
    나감 = "replace"; history.back(); return;
  }
  나감 = "back"; history.go(-1 - g);
}
$("home").onclick = goHome;
/* 10/2 점검 — 뒤로 가기(안드로이드 뒤로 · 아이폰 밀어서 뒤로)를 하면 무비 안 어느 화면에서든 이 화면을 떠났다.
   무료 결과 · 「결과 보기」 판 · 결과지 · 동의 창이 뜨면 기록을 하나(막이) 쌓아 두고, 뒤로 가기로 막이가 걷히면(popstate) 그 화면의 「뒤로」를 이 안에서 한다 —
   동의 창은 닫고, 결제 중이면 떠나지 않고 결제창만 닫고(coin.js — 앱 · 토스 결제창은 그쪽이 닫는다), 「결과 보기」 판은 무료 결과로,
   무료 결과 · 결과지(10/28 사장님 「결과지에서 뒤로 가기를 누르면 홈으로」)는 홈으로(goHome — 진짜 나가기). 아직 화면 안이면 막이를 다시 쌓는다.
   막이는 늘 하나다 — 있으면 그 자리에 바꿔 적기만 한다(replaceState). 결과지를 여는 중(moving)에 온 뒤로는 흘려보낸다 — 풀이 글을 기다리는 로딩 중이면 나간다(10/8). */
function 막이(v) {
  const s = { bg: v };
  try { if (history.state?.bg) history.replaceState(s, ""); else history.pushState(s, ""); } catch { /* 기록을 못 바꾸면 예전처럼 뒤로 가기는 떠난다 */ }
}
// 지금 맨 위 화면 — 결제 중 · 결과지 층(결제 뒤 결과지 · 오늘의 운세) · 「결과 보기」 판(결과지를 여는 중도) · 무료 결과
function 맨위() {
  if (window.BGPAY?.busy?.()) return "pay";
  if (document.querySelector(".bgk-layer")) return "result";
  if ($("paid").classList.contains("on")) return "paid";
  return $("verdict").classList.contains("on") ? "verdict" : null;
}
addEventListener("popstate", (e) => {
  if (나감 === "replace") { 나감 = "back"; location.replace(homeURL()); return; }
  if (나감 || e.state?.bg) return;                        // 나가는 중 · 앞으로 가기로 막이에 다시 올라옴
  const v = 맨위();
  if (!v || v === "verdict" || v === "result") { goHome(); return; }   // 무료 결과 · 결과지(또는 막이만 남고 화면은 닫힘 — 동의 창을 단추로 닫음 · 새로 고침 뒤) — 나간다
  if (v === "pay") window.BGPAY.closeWin?.();
  else if (!moving) {
    if ($("payBtn")) paidBack();                          // 「결과 보기」 판 — 무료 결과로
    else { goHome(); return; }                            // 무료 결과를 그린 적이 없다(결제 뒤 바로 결과지로 옴) — 나간다
  } else if ($("wloader")?.classList.contains("on")) { goHome(); return; }   // 10/8 점검 — 결과지를 여는 중 풀이 글을 기다리면(로딩 막이 · 홈 단추 숨김) 막이만 다시 쌓여 나갈 길이 없었다 — 나간다
  const w = 맨위(); if (w) 막이(w);
});
addEventListener("pageshow", (e) => { if (!e.persisted) return; 나감 = ""; const w = 맨위(); if (w) 막이(w); });   // 홈으로 갔다가 앞으로 가기로 되살아남 — 화면 안이면 막이를 다시
// 10/1 — 무료 결과를 내려 읽기 시작하면 판 맨 위를 검게 덮는다(play.html .verdict::before — 떠 있는 뒤로 · 소리 단추와 글자가 겹치지 않게)
{ const v = $("verdict"); v.addEventListener("scroll", () => v.classList.toggle("down", v.scrollTop > 8), { passive: true }); }

/* ── 영상 ──
   줄마다 영상 하나(바탕 립싱크를 줄마다 자른 것). 바탕은 대기 영상 720장면 한 바퀴(정재생+역재생) 위에 줄을 차례로 이어 만들었으므로
   줄마다 첫 장면 자리(is)·끝난 다음 장면 자리(ie)가 대기 영상의 자리와 같다(tools/site_idle.py).
   · 말이 끝나면 영상은 끝까지 돌고, 그 다음 장면부터 대기 영상(숨·눈 깜빡임)이 이어 돈다 — 멈춘 사진이 되지 않는다(사장님 9/25).
   · 기다리는 동안 대기 영상은 늘 앞으로만 흐른다(9/28 사장님 「지금 영상들 시작될때 … 되감기 되듯이 되는 현상」 → 비교 영상 보고 「오른쪽으로가자」).
     다음 줄 첫 장면(aim)에서 2초(FWD) 흘러가면 되돌지 않고, 둘째 대기 영상을 첫 장면 1초 전(BACK)에서 틀어 0.6초(XL)에 걸쳐 겹쳐 넘어간다 —
     두 영상 모두 앞으로 흐르는 채로 겹치고, 넘어가면 둘의 자리를 바꾼다. 전엔 ±2초를 오가며 절반은 거꾸로 재생됐다(되감기처럼 보인 곳).
     대기 영상 한 바퀴의 이음매(정재생 ↔ 역재생)에서는 천천히 느려졌다가 다시 빨라진다(9/27).
   · 다음 줄로 넘어갈 때 빨리 감거나 되감지 않는다(전엔 다음 줄 첫 장면까지 대기 영상을 2.5배로 빨리 감거나 되감았다 — 위 현상).
     대기 영상이 그 첫 장면에 이미 있거나 반 초 안에서 다가가는 중이면 닿은 순간 튼다(그림이 같아 끊기지 않는다). 아니면 짧게(0.35초) 겹쳐 넘긴다.
     겹칠 때는 새 줄 영상을 지금 보이는 얼굴 자리에 맞춰 두었다가(얼굴 자리 표 data/pose/{번호}.json — tools/pose_table.py) 0.7초에 걸쳐 제자리로 옮긴다 —
     두 얼굴이 겹쳐 보이거나 뒤로 튀지 않게(9/28 사장님 「근데 최대한 돌아가는게 안보이게는 못해?」).
   · 바로 이어지는 줄: 앞 줄 말이 끝나고(0.35초 뒤) 남은 꼬리가 0.6초 안이면 끝까지 돌고 이어 튼다(앞 줄 끝 = 다음 줄 첫 장면).
     꼬리가 길면 기다리지 않고 짧게 겹쳐 넘긴다(사장님 9/25 「그다음 대사가 진행되기까지 시간이 너무 길어」). 소리 나는 클립은 속도를 바꾸지 않는다 — 폰에서 소리가 빨라지거나 되풀이됐다(9/26).
   · 첫 장면이 먼 줄(건너뛴 시각 질문 · 값이 없어 건너뛴 장)은 겹쳐 흐리고, 자세가 바뀌는 C09 와 유료로 들어갈 때는 까맣게 내렸다 올린다
     (C09 는 겹치면 잔상이 생긴다 — 사장님 9/24). */
const stage = $("stage"), shade = stage.querySelector(".shade"), pool = new Map();
const FPS = 24, EASE = 10, SLOW = 0.25, XF = 0.35, FWD = 48, BACK = 24, XL = 0.6, GLIDE = 0.7;
// 이음매(방향이 바뀌는 자리)까지 d 장면 남았을 때 대기 영상 속도 — EASE 장면 안에서 SLOW 까지 부드럽게 줄었다가, 지난 뒤 같은 모양으로 다시 붙는다(소리 없는 영상만)
const ease = (d) => { const x = Math.min(1, Math.max(0, d) / EASE); return SLOW + (1 - SLOW) * x * x * (3 - 2 * x); };
const setRate = (v, r) => { if (Math.abs(v.playbackRate - r) > 0.02) v.playbackRate = r; };
const mod = (x) => { const P = M?.idleFrames || 720; return ((x % P) + P) % P; };   // 10/1 밤 — 한 바퀴 장 수는 데이터(idleFrames)에서(15초 대기 영상 720 · 40번 꽃 냉장고 13초)
// 10/1 밤 코드 리뷰 — mod 만 데이터를 보고 나머지는 720장(15초)으로 박혀 있었다. 한 바퀴가 다른 영상(40번 626장)은 그림 · 이음매 · 되돌기가 어긋난다. 모두 P(한 바퀴) · H(반 바퀴)로
const 바퀴 = () => M?.idleFrames || 720, 반바퀴 = () => 바퀴() / 2;
const U = (p) => (p < 반바퀴() ? p : 바퀴() - 1 - p);   // 그 자리의 그림(정재생 몇 번째 장면인가)
// 목소리 목록에 있는 줄의 자료는 음성 파일이다. 그림은 회상 영상이 맡고, 회상이 없으면 대기 사람 영상이 맡는다. 그 줄은 인물 mp4를 열지 않는다.
// 토스 번들은 같은 파일을 https://bamgwabi.com 절대주소로 넣어 둔다. 웹의 상대주소와 그 절대주소는 경로가 같으면 같은 자료다.
const mediaPath = (u) => {
  if (typeof u !== "string" || !u || /^(?:data|blob):/i.test(u)) return "";
  try { const x = new URL(u, document.baseURI || location.href); return x.pathname + x.search; } catch { return ""; }
};
const sameMedia = (a, b) => { const x = mediaPath(a), y = mediaPath(b); return !!x && x === y; };
const voiceUrl = (k) => (!RL.sets && window.BGVIDEOOPT?.voices?.[C]?.[k]) || "";
const clip = (k) => voiceUrl(k) || `${M.media}${k}.mp4`;
const voiceLine = (v) => sameMedia(v?.getAttribute?.("src"), voiceUrl(v?.dataset?.k));
// 9/29 이어 틀기 — 사장님 「2번만 진행해봐 …」 → 「다시 만드는 캐릭터 빼고 전부 새로운 방식으로 진행하자」 · 「줄이는 방법대로 진행도 해」.
// 그 인물에 media/{번호}/reel.json 이 있으면(tools/reel_build.py — 다시 만드는 다섯 명은 없다) 대사 영상을 줄마다 새 파일로 열지 않는다.
// 무료 줄 · 유료 줄을 따로 이어 붙인 묶음(reel-free · reel-paid)을 재생기 둘(RL.lanes)이 받으면서 틀며, 번갈아 그 줄 자리로 옮겨 간다.
// 유료 묶음은 결제해 들어갈 때만 건다(무료 묶음 끝에서 유료 줄까지 미리 받지 않게).
// (9/29 한 번만 받기(blob)도 해 봤으나 느린 통신에서 다 받을 때까지 시작이 2.3초 늦고, 그 사이 예전 길로 같은 영상을 또 받아 데이터가 거의 두 배가 됐다 — 뺐다.)
// 줄마다 첫 장면이 키프레임이라 옮기면 바로 서고, 줄 끝마다 끝 장면을 0.2초 이어 두어 줄 끝을 한 박자 늦게 알아채도 다음 줄 첫 장면이 비치지 않는다.
// 묶음을 아직 못 받았거나 못 받으면(또는 재생기 오류) 그 줄은 예전처럼 줄 파일을 따로 연다.
// (10/8 사장님 「쓸모 없는 코드는 … 지워버려」 — 비교용 주소 스위치 ?이음=0 과 쓰지 않던 칸 idleUrl · idleP 를 지웠다)
const RL = { sets: null, lanes: [], broken: false };
const lane = (v) => RL.lanes.includes(v);
const clipOf = (v) => (lane(v) && v._set && RL.sets?.[v._set]?.clips?.[v._k]) || null;
const T0 = (v) => clipOf(v)?.[0] ?? 0;                                                // 재생기에 걸린 줄의 시작 시각(묶음 안)
const ct = (v) => v.currentTime - T0(v);                                             // 그 줄 안에서 지난 시간(예전 요소는 currentTime 그대로)
const cdur = (v, L) => clipOf(v)?.[1] ?? (v.duration || L?.dur || 0);
const setOf = (k) => (RL.sets ? Object.keys(RL.sets).find((n) => RL.sets[n].clips?.[k]) : null);
const laneReady = (k) => { const n = setOf(k); return !!(n && RL.sets[n].url && !RL.broken); };   // 그 줄이 든 묶음을 받아 뒀으면 재생기로
const speechHead = (L) => L?.sub ? Math.max(0.001, (L.aa ?? 0) - 0.06) : 0.001;
const speechEnd = (L) => L?.ab ?? L?.sub?.[1] ?? 0;
const SPEECH_GAP = 0.08;
function seekClip(v) {                                                               // 재생기를 그 줄 첫 장면에 세운다
  const t = T0(v) + speechHead(M.lines[v._k ?? v.dataset.k]);
  if (Math.abs(v.currentTime - t) < 0.004 && !v.seeking && v.readyState >= 1) return (v._ready = Promise.resolve());
  v._ready = new Promise((r) => {
    const done = () => { clearTimeout(tm); v.removeEventListener("seeked", done); r(); }, tm = setTimeout(done, 1500);
    v.addEventListener("seeked", done);
  });
  v.currentTime = t; return v._ready;
}
function loadSet(n) { const x = RL.sets?.[n]; if (x && !x.url) x.url = M.media + x.file; return x?.url || null; }   // 그 묶음을 쓰기 시작한다(유료는 결제해 들어올 때)
function mkIdle(cls) { const v = document.createElement("video"); v.crossOrigin = "anonymous"; v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute("playsinline", ""); v.preload = "auto"; v.className = cls; return v; }
let idle = mkIdle("on"), idleB = mkIdle("");      // idle: 지금 보이는 대기 영상 · idleB: 앞으로만 흐르며 되돌아갈 때 겹쳐 올리는 둘째(같은 파일)
stage.insertBefore(idle, stage.firstChild); stage.insertBefore(idleB, idle.nextSibling);
const at = () => {
  const frames = M?.idleLoop?.frames;
  const i = Math.floor(idle.currentTime * FPS + 0.01);
  return frames?.length ? frames[i % frames.length] : mod(i);
};
function idleTime(p, frame = null) {
  const frames = M?.idleLoop?.frames;
  if (!frames?.length) return (p + 0.5) / FPS;
  if (frame == null) {
    const target = U(mod(p));
    frame = frames.reduce((best, value, i) => Math.abs(U(value) - target) < Math.abs(U(frames[best]) - target) ? i : best, 0);
  }
  return (frame + 0.5) / FPS;
}
let front = null, aim = null, reaching = false, freeze = false, handing = Promise.resolve(), xfading = null, POSE = null;   // front: 대기 영상 위에 보이는 클립 · aim: 기다리는 동안 머물 자리(다음 줄 첫 장면)
const aim바꿈 = (값) => (aim = 값);   // 다른 조각이 바꿀 때(모듈은 가져온 이름에 직접 넣을 수 없다)
const freeze바꿈 = (값) => (freeze = 값);   // 다른 조각이 바꿀 때(모듈은 가져온 이름에 직접 넣을 수 없다)
const POSE바꿈 = (값) => (POSE = 값);   // 다른 조각이 바꿀 때(모듈은 가져온 이름에 직접 넣을 수 없다)
let 쉬는중 = false;       // 10/2 — 마지막 결과지가 무대를 덮어 영상 · 로고를 쉬게 한 동안(쉼 · hover)
const 쉬는중바꿈 = (값) => (쉬는중 = 값);   // 다른 조각이 바꿀 때(모듈은 가져온 이름에 직접 넣을 수 없다)
const LIVE = new Set();   // 10/1 코드 점검 — 아직 끝나지 않은 줄(보이는 줄과, 위에 새 줄이 떠도 꼬리를 도는 앞 줄). 화면을 벗어나면 멈춘다(setAway)
// 첫 장면에서 FWD 장면 넘게 흘러가면 둘째 대기 영상을 aim - BACK 에서 틀어 XL 초에 걸쳐 겹쳐 올린다(둘 다 앞으로 흐른다). 다 올라오면 둘의 자리를 바꾼다.
let loopBan = 0;                                        // 둘째 대기 영상 틀기가 거절 · 늦으면 이때까지 다시 시도하지 않는다(9/28 폰에서 타로가 중간에 멈춤)
function loopBack() {
  // 10/1 — 대기 영상이 무대 밖에 있으면 겹치지 않는다(9/30~10/1 설명 판이 판 머리로 빌려 간 동안 무대 밖 요소 옆에 끼우다 오류로 이 고리가 멈췄다. 판은 이제 빌려 가지 않는다)
  if (xfading || aim == null || performance.now() < loopBan || idle.parentNode !== stage) return;
  const a = idle, b = idleB, x = (xfading = { b, done: null }); x.wait = new Promise((r) => (x.done = r));
  if (b.preload !== "auto") b.preload = "auto";                       // 10/2 — 둘째 대기 영상은 처음 겹칠 때 받기 시작한다(boot 에서는 preload none)
  stage.insertBefore(b, a.nextSibling); b.style.transition = "none"; b.classList.remove("on"); b.style.opacity = 0;
  b.currentTime = (mod(aim - BACK) + 0.5) / FPS; b.playbackRate = 1;
  const show = () => {
    if (xfading !== x) return; x.shown = true; clearTimeout(x.guard);
    b.style.transition = `opacity ${XL}s linear`; void b.offsetWidth; b.style.opacity = 1;
    x.t = setTimeout(() => {
      if (xfading !== x) return;
      a.pause(); a.style.transition = "none"; a.classList.remove("on"); a.style.opacity = "";
      b.classList.add("on"); b.style.transition = ""; b.style.opacity = "";
      idle = b; idleB = a; xfading = null; x.done();
    }, XL * 1000 + 40);
  };
  x.guard = setTimeout(() => { if (xfading === x && !x.shown) { stopLoopBack(); loopBan = performance.now() + 8000; } }, 1000);   // 1초 안에 안 뜨면 걷는다
  b.play().then(() => (b.readyState >= 2 ? show() : b.addEventListener("playing", show, { once: true }))).catch(() => { if (xfading === x) { stopLoopBack(); loopBan = performance.now() + 8000; } });
}
function stopLoopBack() {                             // 줄이 뜨거나 대기 영상 자리를 옮길 때 — 겹치던 둘째 영상을 걷는다
  const x = xfading; if (!x) return; clearTimeout(x.t); clearTimeout(x.guard); xfading = null;
  x.b.pause(); x.b.style.transition = "none"; x.b.style.opacity = 0; x.b.classList.remove("on"); x.done();
}
// 새 줄 영상을 지금 보이는 얼굴 자리(from)에 맞추는 변환 — 새 줄 첫 장면(to)의 얼굴을 from 자리로 옮긴 모양(화면 픽셀, object-fit: cover)
function clipPose(key, time) {
  const samples = POSE?.clips?.[key]; if (!samples?.length) return null;
  const first = samples.findIndex(sample => sample[0] >= time);
  if (first === 0) return samples[0][1];
  if (first < 0) return samples[samples.length - 1][1];
  const [ta, a] = samples[first - 1], [tb, b] = samples[first];
  const t = tb === ta ? 1 : Math.max(0, Math.min(1, (time - ta) / (tb - ta)));
  return a.map((value, i) => value + (b[i] - value) * t);
}
// 앞 클립이 지금 보이는 자리(대기 영상 장면 자리)와 얼굴 자리. 더빙을 기다리는 끝 자세(endPose)는 그 줄의 끝 장면
const tailOf = (p) => p.hold ? { at: p.L.ie, pose: clipPose(p.from, Infinity) } : { at: p.L.is + Math.round(ct(p.v) * FPS), pose: clipPose(p.k, ct(p.v)) };
function poseTf(v, from, to, key, previous = null) {
  const a = previous || POSE?.p?.[mod(from)], b = POSE?.heads?.[key] || POSE?.p?.[mod(to)]; if (!a || !b) return null;
  const bw = v.clientWidth || stage.clientWidth, bh = v.clientHeight || stage.clientHeight;
  const k = Math.max(bw / POSE.w, bh / POSE.h), ox = (bw - POSE.w * k) / 2, oy = (bh - POSE.h * k) / 2;
  const dx = (a[0] - b[0]) * k, dy = (a[1] - b[1]) * k, sc = a[2] / b[2], r = ((a[3] - b[3] + 540) % 360) - 180;
  if (![dx, dy, sc, r].every(Number.isFinite)) return null;
  if (Math.abs(dx) > bw * 0.05 || Math.abs(dy) > bh * 0.03 || sc < 0.95 || sc > 1.05 || Math.abs(r) > 3) return { jump: true };
  if (Math.hypot(dx, dy) < 0.4 && Math.abs(sc - 1) < 0.003 && Math.abs(r) < 0.2) return null;
  return { origin: `${(ox + b[0] * k).toFixed(1)}px ${(oy + b[1] * k).toFixed(1)}px`, tf: `translate(${dx.toFixed(2)}px,${dy.toFixed(2)}px) rotate(${r.toFixed(2)}deg) scale(${sc.toFixed(4)})` };
}
// 10/1 코드 점검 — 아이폰 크롬은 play() 답이 끝내 안 올 때가 있다(reach 와 같이) — 0.8초 넘게 기다리지 않는다(전엔 hover 가 붙잡혀 다시는 틀지 않았다)
const kick = (v) => Promise.race([Promise.resolve(v.play()).catch(() => {}), wait(800)]);
let payHold = false;   // 10/9 결제창이 열려 있는 동안(coin.js) — 화면은 그대로 보여도 대사를 다시 틀지 않는다
(function hover() {
  if (쉬는중) { requestAnimationFrame(hover); return; }   // 10/2 — 마지막 결과지가 무대를 덮은 동안은 쉰다(쉼)
  // 위에 클립이 없는데 대기 영상이 멈춰 있으면(브라우저가 소리 없는 영상을 쉬게 한 때 등) 다시 튼다 — 멈춘 사진이 되지 않게
  const 그림 = front && !voiceLine(front.v) ? front : null;   // 음성 파일은 화면이 아니다. 회상이 꺼지면 대기 사람 영상을 다시 돌린다
  const rest = window.BGMEMORY?.active ? null : !그림 ? idle : 그림.k === "C09loop" || 그림.hold ? 그림.v : null;   // 지금 기다리며 돌아야 하는 영상(대기 영상, 또는 C09 · 더빙을 기다리는 끝 자세)
  // 10/8 점검 — 오류 난 영상은 틀지 않는다(초당 60번 거절됐다). 대기 영상이 오류면(통신 끊김 등) 5초에 한 번 다시 받는다
  if (rest && rest.paused && rest.src && !rest.error && started && !reaching && !freeze && !hover.nudge && !payHold && document.visibilityState === "visible") { hover.nudge = true; kick(rest).then(() => { hover.nudge = false; }); }
  if (rest === idle && idle.error && idle.src && started && document.visibilityState === "visible" && performance.now() - (hover.reloadAt || 0) > 5000) { hover.reloadAt = performance.now(); idle.load(); }
  // 10/1 코드 점검 — 말하던 줄을 폰이 멈춘 때(전화 · 알림 · 다른 앱 소리)도 다시 튼다 — 전엔 대기 영상 · C09 끝 자세만 다시 틀어 줄이 멈춘 채 남았다(0.6초에 한 번까지)
  const talk = front && !front.over ? front : null;
  if (talk && talk.v.paused && !talk.v.ended && !talk.held && !hover.nudge && !payHold && document.visibilityState === "visible" && performance.now() - (hover.at || 0) > 600) { hover.nudge = true; hover.at = performance.now(); kick(talk.v).then(() => { hover.nudge = false; }); }
  // 대기 영상이 늦게 준비돼 전환이 실패했으면 다시 넘긴다 — 끝난 대사의 마지막 장면이 계속 덮고 있지 않게
  const back = M?.idleLoop && front?.over && !front.next && !front.posing && front.L.ie != null && (front.k !== "C09" || M.mode === "daily") ? front : null;
  if (back && !back.returning && !idle.error && started && !freeze && !payHold && document.visibilityState === "visible" && performance.now() - (hover.backAt || 0) > 600) { hover.backAt = performance.now(); handoff(back, back.L.ie); }
  if (!그림 && !reaching && !freeze && !idle.paused) {
    const p = at(), d = aim != null ? mod(p - aim) : 0;
    const P = 바퀴(), H = 반바퀴();
    setRate(idle, M.idleLoop && !M.idleLoop.pingPong ? 1 : ease(p < H ? Math.min(p, H - 1 - p) : Math.min(p - H, P - 1 - p)));
    if (!M.idleLoop && aim != null && !xfading && d >= FWD && d < H) loopBack();
  }
  if ((front?.k === "C09loop" || front?.hold) && front.v.duration > 0) {                // C09 끝 자세 꼬리(뒤로 → 앞으로 도는 영상)도 이음매에서 부드럽게 — 더빙을 기다리는 끝 자세(endPose)도 같게
    const t = ct(front.v), D = cdur(front.v);
    if (lane(front.v) && t >= D - 1 / 60) front.v.currentTime = T0(front.v) + 0.001;   // 이어 틀기 — 파일 하나라 그 줄 안에서만 되돈다
    setRate(front.v, 0.5 * ease(Math.min(t, Math.abs(t - D / 2), D - t) * FPS));
  }
  requestAnimationFrame(hover);
})();
// 대기 영상(소리 없음)이 s 자리에 있으면 true. 반 초(12장면) 안에서 다가가는 중이면(앞으로만 흐르므로 s 가 바로 앞) 제 속도로 닿기를 기다린다.
// 멀면 false — 빨리 감거나 되감아 쫓지 않는다(9/27 「순간 되감기하고 다시 바로 재생되는 느낌」). 그때는 얼굴 자리를 맞춰 짧게 겹쳐 넘긴다.
async function reach(s) {
  if (M.idleLoop) return false;                          // 연속 대기는 선택 뒤 목표 프레임을 기다리거나 찾아가지 않는다
  if (xfading) await Promise.race([xfading.wait, wait(1000)]);   // 겹쳐 넘어가는 중이면 다 넘어간 뒤에 본다(0.6초 안, 길어도 1초)
  if (idle.paused && !front) await Promise.race([idle.play().catch(() => {}), wait(800)]);   // 9/28 아이폰 크롬은 play() 답이 끝내 안 올 때가 있다 — 멈추지 않게
  if (idle.paused) return false;
  const where = () => { const d = mod(s - at()); return d <= 1 || d >= 바퀴() - 1 ? 1 : d <= 12 ? 0 : -1; };
  if (where() !== 0) return where() > 0;
  reaching = true;
  return new Promise((res) => {
    const t0 = performance.now();
    const done = (ok) => { reaching = false; res(ok); };
    const step = () => {
      const w = where();
      if (w !== 0) return done(w > 0);
      if (performance.now() - t0 > 1000) return done(false);
      setRate(idle, 1);
      requestAnimationFrame(step);
    };
    step();
  });
}
// 클립을 걷어 내고 대기 영상이 p 자리부터 이어 돈다(대기 영상이 그 장면을 띄운 뒤에 걷는다)
function handoff(c, p) {
  if (window.BGMEMORY?.active) {
    if (front === c) front = null;
    idle.pause(); c.v.classList.remove("on"); drop(c.k);
    return (handing = Promise.resolve());
  }
  if (M.idleLoop) {
    c.returning = true;
    return (handing = (async () => {
      stopLoopBack(); idle.pause();
      const seeked = new Promise((r) => {
        const done = () => { clearTimeout(timer); r(true); };
        const timer = setTimeout(() => { idle.removeEventListener("seeked", done); r(false); }, 1500);
        idle.addEventListener("seeked", done, { once: true });
        idle.currentTime = idleTime(p, c.L.idleReturn);
      });
      idle.playbackRate = 1; await kick(idle);
      const sought = await seeked;
      if (idle.error || idle.paused || idle.readyState < 2 || (!sought && idle.seeking)) return;
      if (idle.requestVideoFrameCallback) {
        const before = idle.currentTime;
        const displayed = await new Promise((r) => {
          const id = idle.requestVideoFrameCallback(() => { clearTimeout(timer); r(true); });
          const timer = setTimeout(() => { idle.cancelVideoFrameCallback?.(id); r(false); }, 1000);
        });
        if (!displayed && (idle.error || idle.paused || idle.seeking || idle.readyState < 2 || idle.currentTime === before)) return;
      }
      if (front !== c) return;
      front = null; idle.classList.add("on");
      c.v.style.transition = `opacity ${XF}s linear`; c.v.style.opacity = 0;
      await wait(XF * 1000 + 40);
      c.v.classList.remove("on"); c.v.style.transition = "none"; c.v.style.opacity = ""; drop(c.k);
    })().finally(() => { c.returning = false; }));
  }
  return (handing = new Promise((r) => {
    let done = false;
    const go = () => {
      if (done) return; done = true;
      idle.playbackRate = 1; idle.play().catch(() => {});
      if (front === c) { front = null; c.v.style.transition = "none"; c.v.classList.remove("on"); }
      setTimeout(() => drop(c.k), 60); r();
    };
    stopLoopBack(); idle.pause(); idle.currentTime = (p + 0.5) / FPS; idle.addEventListener("seeked", go, { once: true }); setTimeout(go, 400);
  }));
}

// 아이폰(사파리)은 소리 나는 영상을 사용자가 누른 순간에 한 번 튼 영상 요소만 나중에 스스로 틀 수 있다.
// 그래서 「소리 켜고 시작」을 누른 순간 요소 여러 개를 한꺼번에 풀어 두고(unlock), 새로 만들지 않고 돌려 쓴다.
const spare = [];
function mk() { const v = document.createElement("video"); v.crossOrigin = "anonymous"; v.playsInline = true; v.setAttribute("playsinline", ""); v.preload = "auto"; if (window.BGDUB?.on) v.muted = true; stage.insertBefore(v, shade); return v; }   // 10/9 외국어 화면 — 대사 영상은 처음부터 소리를 끈다(더빙이 낸다). crossOrigin — 토스에서 회상 캔버스가 이 영상을 그리게
function unlock(n) {
  const silent = "data:audio/mp4;base64,AAAAHGZ0eXBNNEEgAAACAE00QSBpc29taXNvMgAAAxZtb292AAAAbG12aGQAAAAAAAAAAAAAAAAAAAPoAAAAeAABAAABAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAACQXRyYWsAAABcdGtoZAAAAAMAAAAAAAAAAAAAAAEAAAAAAAAAeAAAAAAAAAAAAAAAAQEAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAACRlZHRzAAAAHGVsc3QAAAAAAAAAAQAAAHgAAAQAAAEAAAAAAbltZGlhAAAAIG1kaGQAAAAAAAAAAAAAAAAAAKxEAAAYrFXEAAAAAAAtaGRscgAAAAAAAAAAc291bgAAAAAAAAAAAAAAAFNvdW5kSGFuZGxlcgAAAAFkbWluZgAAABBzbWhkAAAAAAAAAAAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAAEoc3RibAAAAGpzdHNkAAAAAAAAAAEAAABabXA0YQAAAAAAAAABAAAAAAAAAAAAAQAQAAAAAKxEAAAAAAA2ZXNkcwAAAAADgICAJQABAASAgIAXQBUAAAAAAD6AAAAJ0QWAgIAFEghW5QAGgICAAQIAAAAgc3R0cwAAAAAAAAACAAAABgAABAAAAAABAAAArAAAABxzdHNjAAAAAAAAAAEAAAABAAAABwAAAAEAAAAwc3RzegAAAAAAAAAAAAAABwAAABUAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAUc3RjbwAAAAAAAAABAAADQgAAABpzZ3BkAQAAAHJvbGwAAAACAAAAAf//AAAAHHNiZ3AAAAAAcm9sbAAAAAEAAAAHAAAAAQAAAGF1ZHRhAAAAWW1ldGEAAAAAAAAAIWhkbHIAAAAAAAAAAG1kaXJhcHBsAAAAAAAAAAAAAAAALGlsc3QAAAAkqXRvbwAAABxkYXRhAAAAAQAAAABMYXZmNjEuNy4xMDAAAAAIZnJlZQAAADVtZGF03gIATGF2YzYxLjE5LjEwMAACMEAOARggBwEYIAcBGCAHARggBwEYIAcBGCAH";
  const warm = (v) => {
    const src = v.getAttribute("src"); v.pause(); v.src = silent; v.muted = false;   // 소리 없는 파일이라 소리를 켠 채 풀어 둔다 — 더빙을 끄는 스위치(dub.js)가 꺼지면 이 요소들이 한국어 소리를 낸다
    const p = v.play(); if (p) p.catch(() => {}); v.pause(); v.muted = !!window.BGDUB?.on;   // 10/9 외국어 화면은 대사 영상 소리를 켜지 않는다(소리는 더빙 요소 — 아래 arm)
    if (src) v.src = src; else v.removeAttribute("src"); v.load();
  };
  RL.lanes.forEach(warm);
  pool.forEach(warm);
  if (window.BGDUB?.on) window.BGDUB.arm(silent);   // 10/9 더빙 음성 요소도 이 누름 안에서 풀어 둔다
  // 10/8 점검 — 이미 n 개 있으면 새로 만들지 않는다(동의 창은 두 번 누른다 — 처음 누름 · 「동의하고 시작」).
  // 10/20 — 손님의 실제 누름 안에서만 부른다(09-boot 누름풀기 · service-agreement.js prepareSound). 누름 밖에서 만든 새 요소는 풀리지 않은 채 맨 위에 쌓여 먼저 꺼내져 아이폰 대사 소리가 꺼졌다
  for (let i = spare.length; i < n; i++) { const v = mk(); warm(v); spare.push(v); }
}
function vid(k) {
  let v = pool.get(k);
  if (!v && laneReady(k)) {                                // 이어 틀기 — 지금 보이는 줄의 재생기가 아닌 쪽을 그 줄 자리로 옮긴다(새 파일을 열지 않는다)
    const n = setOf(k);
    v = RL.lanes.find((x) => x !== front?.v && x._k == null) || RL.lanes.find((x) => x !== front?.v);
    if (v._k != null && v._k !== k) pool.delete(v._k);
    if (v._set !== n) { v._set = n; v.src = RL.sets[n].url; }   // 무료 → 유료로 넘어갈 때 한 번 바꿔 건다(받아 둔 blob 이라 바로)
    if (v.preload !== "auto") v.preload = "auto";            // 10/2 — 줄 자리로 옮긴 재생기는 끝까지 받아 둔다(full — 둘째 재생기는 metadata 로 시작했다)
    v._k = k; v.dataset.k = k; pool.set(k, v); v.pause(); seekClip(v); return v;
  }
  if (!v) { v = spare.pop() || mk(); v.dataset.k = k; v.src = clip(k); v.load(); pool.set(k, v); }
  else if (!lane(v) && !sameMedia(v.getAttribute("src"), clip(k))) { v.pause(); v.src = clip(k); v.load(); }
  return v;
}
function preload(k) {
  if (k && window.BGDUB?.on && M.lines[k]?.sub) dubFor(k);   // 10/9 더빙도 대사 영상과 함께 미리 받는다(묶음이면 아래에서 바로 돌아가므로 먼저)
  if (!k || (pool.has(k) && (lane(pool.get(k)) || sameMedia(pool.get(k).getAttribute("src"), clip(k)))) || (laneReady(k) && !RL.lanes.some((v) => v !== front?.v && v._k == null))) return;
  const v = vid(k); if (!lane(v)) ready(v).then(() => { if (pool.get(k) === v && front?.v !== v) seekClip(v); });
}   // 묶음을 받아 뒀으면 미리 열 것이 없다(틀 때 그 자리로 옮긴다) — 아직이면 예전처럼 줄 파일을 미리 연다
function drop(k) {
  const v = pool.get(k); if (!v || front?.v === v) return;
  pool.delete(k); v.pause(); v.classList.remove("on", "hold"); v.style.transition = "none"; v.loop = false;
  v.onended = v.onerror = null; v.defaultPlaybackRate = v.playbackRate = 1; v.style.transform = v.style.transformOrigin = "";
  if (lane(v)) { if (v._k === k) v._k = null; return; }   // 이어 틀기 재생기는 파일을 그대로 두고 다음 줄 자리로 옮겨 쓴다
  v.removeAttribute("src"); v.load(); spare.push(v);   // 반 속도 C09loop 요소 · 얼굴 맞춤 변환을 다른 줄이 물려받지 않게
}
function ready(v) {                                       // 첫 장면이 풀려 있어야 바로 띄울 수 있다
  if (lane(v) && v._ready) return v._ready;                // 이어 틀기 — 그 줄 자리로 옮기기가 끝나면
  if (v.readyState >= 2 && !v.error) return Promise.resolve();
  return new Promise((r) => {
    let n = 0, last = -1, still = performance.now();
    const stop = () => { clearInterval(t); v.removeEventListener("loadeddata", ok); v.removeEventListener("error", onErr); };
    const ok = () => { if (v.readyState >= 2 && !v.error) { stop(); r(); } };
    const reload = () => { if (n >= 3) { stop(); r(); return; } n++; still = performance.now(); try { v.load(); } catch { /* 다시 걸 수 없으면 다음 확인 */ } };
    const onErr = () => reload();
    const t = setInterval(() => {
      if (v.readyState >= 2 && !v.error) return ok();
      const e = v.buffered.length ? v.buffered.end(v.buffered.length - 1) : 0;
      if (e !== last) { last = e; still = performance.now(); }
      else if (performance.now() - still > 8000) reload();
    }, 250);
    v.addEventListener("loadeddata", ok); v.addEventListener("error", onErr);
  });
}

/* 줄 하나를 튼다. 소리가 끝나면(숨소리까지 끝난 뒤 0.2초) 풀리고 — 그때 고르기·결과지가 뜬다 — 영상은 끝까지 돈 뒤 대기 영상으로 넘어간다.
   소리가 나는 클립은 속도를 절대 바꾸지 않는다 — 폰(사파리)은 속도를 바꾸는 순간 이미 낸 소리를 다시 내거나 빠르게 낸다
   (사장님 9/26 「초반에 엄청 빠르게 음성이 재생되다가 다시 되돌아」 · 「대사 반복 나오는데」). 줄 사이 기다림을 줄이는 빨리 감기는 소리 없는 대기 영상에서만 한다.
   how: cut(대기 영상이 이 줄 첫 장면 그림에 닿은 순간 바로) · fade(겹쳐 흐리며) · dip(까맣게 내렸다 올리며) */
// 받는 동안 바이트가 늘면 계속 기다린다. 8초 동안 늘지 않거나 오류면 다시 건다. 세 번을 넘겨도 안 되면 그때 넘긴다.
function full(v, L) {
  const enough = () => {
    if (v.error) return false;
    if (v.readyState >= 4) return true;
    const a = T0(v) + speechHead(L), b = T0(v) + cdur(v, L) - 0.05; if (!(b > a)) return v.readyState >= 2;
    for (let i = 0; i < v.buffered.length; i++) if (v.buffered.start(i) <= a + 0.05 && v.buffered.end(i) >= b) return true;
    return false;
  };
  if (enough()) return Promise.resolve();
  return new Promise((r) => {
    let last = -1, still = performance.now(), n = 0;
    const tick = () => {
      if (enough()) return r();
      const e = v.buffered.length ? v.buffered.end(v.buffered.length - 1) : 0, now = performance.now();
      if (e !== last) { last = e; still = now; }
      if ((v.error || now - still > 8000) && n < 3) { n++; still = now; try { v.load(); } catch { /* 다음 확인 */ } }
      else if (n >= 3 && (v.error || now - still > 8000)) return r();
      setTimeout(tick, 200);
    };
    tick();
  });
}
// 10/9 — 외국어 화면의 줄 더빙(영상 시간에 맞춘 판)을 받는다 → { src, segs }. 끊기면 받을 때까지 다시 받는다(dub.js). 목록에 없거나 서버가 없다고 하면 null — 그래도 한국어 소리는 켜지 않는다.
async function dubFor(k) {
  const info = await window.BGDUB.saju(C, k);
  const src = info && await window.BGDUB.load(info.url);
  return src ? { src, segs: info.segs } : null;
}
async function play(k, { sub = true, how = null, next = null, soon = false } = {}) {
  // 10/8 Skip — 이 줄은 틀지 않는다. 10/20 — 이 줄 요소도 내려놓는다(첫 줄 첫 장면을 깔아 둔 C02 가 「on」인 채 남아, 첫 줄 전에 Skip 하면 입력 내내 대기 영상 위에 멈춘 인물이 덮였다)
  const bye = () => { drop(k); return { k, over: true, end: Promise.resolve(), stop() {} }; };
  if (SKIP.on && !soon) return bye();   // soon — 오프닝 스킵이 붙는 질문 음성은 SKIP.on 이어도 튼다(끄면 칸만 뜨고 말이 통째로 빠졌다)
  if (front && !front.over) front.next = true;
  if (front) (front.src || front).taken = true;           // 10/9 더빙을 기다리던 끝 자세(endPose)는 대기 영상으로 넘기지 않고 이 줄이 잇는다
  const L = M.lines[k] || {}, v = vid(k), s = L.is == null ? null : L.is + Math.round(speechHead(L) * FPS);
  const dubP = window.BGDUB?.on && L.sub ? dubFor(k) : null;   // 10/9 더빙 — 영상을 받는 동안 같이 받는다. 둘 다 준비돼야 줄을 시작한다
  // soon — 오프닝 스킵이 질문 음성으로 바로 붙을 때. 줄 전체를 받을 때까지 기다리지 않고, 말 시작 장면이 보이면 바로 튼다.
  //   skipped() 와 겨루지 않는다 — 스킵 직후 SKIP.on 이면 말 시작으로 옮기기도 전에 풀려, 앞 줄 시각에서 바로 칸이 떴다.
  if (soon) { await ready(v); await seekClip(v); await handing; }
  else await Promise.race([(async () => { await ready(v); await seekClip(v); await full(v, L); await handing; })(), skipped()]);
  const dub = dubP ? (soon ? await dubP : await Promise.race([dubP, skipped()])) : null;
  if (SKIP.on && !soon) return bye();
  const prev = front;
  if (!how) {
    if (s == null) how = "fade";
    else {
      if (prev && !prev.over) {                           // 앞 줄은 말이 끝나고 조용한 꼬리를 도는 중
        const s1 = speechEnd(prev.L), lag = s1 + SPEECH_GAP - ct(prev.v);
        if (lag > 0) await Promise.race([wait(lag * 1000), skipped()]);   // 폰은 소리가 화면보다 늦게 나온다 — 소리 끝난 지 0.35초는 지나서 넘긴다. 10/9 Skip — 이 기다림 동안 앞 영상이 말을 잇지 않게
        if (SKIP.on) return bye();
        if (!prev.over) {
          const left = cdur(prev.v, prev.L) - ct(prev.v);
          if (prev.L.ie != null && U(prev.L.ie) === U(s) && left <= SPEECH_GAP) { prev.next = true; await Promise.race([prev.end, skipped()]); if (SKIP.on) return bye(); how = "cut"; }   // 꼬리가 짧다 — 끝까지 돌고 이어서
          else how = "fade";                                                                                               // 꼬리가 길다 — 빨리 감지 않고 짧게 겹친다
        }
      }
      if (!how && prev?.hold && front === prev) how = "fade";   // 10/9 더빙을 기다리던 끝 자세에서 — 한국어에서 앞 줄 끝에 잇는 것과 같게 얼굴 자리를 맞춰 짧게 겹친다
      if (!how) {
        await Promise.race([handing, skipped()]);
        if (SKIP.on) return bye();
        if (speechHead(L) > 0.001) how = "fade";
        else { const near = await Promise.race([reach(s), skipped().then(() => null)]); if (SKIP.on) return bye(); how = near ? "cut" : "fade"; }
      }
    }
  }
  const bl = $("black");
  const tail = prev && prev.L.is != null ? tailOf(prev) : null;
  const before = tail ? tail.at : at();
  const match = !window.BGMEMORY?.active && poseTf(v, before, s, k, tail?.pose ?? null);
  if (how === "cut" && prev && match && !soon) how = "fade";   // 10/9 스킵으로 붙는 질문 음성은 겹치지 않고 그 말 시작 장면으로 바로 붙는다
  const joining = how === "fade" && match?.jump && !(prev?.hold && front === prev) && !window.BGDUB?.on;   // 끝 자세에서 이을 때 · 외국어 더빙 중에는 검게 덮지 않고 겹쳐 넘긴다
  if (joining) {
    LOG?.push({ k, how: "pose-join", t: Math.round(performance.now()) });
    bl.style.transition = "opacity .14s linear"; bl.style.opacity = 1; await wait(160);
    if (prev) prev.stop();
    const result = start(k, v, L, "cut", sub, next, dub, soon);
    requestAnimationFrame(() => { bl.style.transition = "opacity .24s linear"; bl.style.opacity = 0; });
    return result;
  }
  if (how === "dip") { bl.style.transition = "opacity .3s linear"; bl.style.opacity = 1; await wait(330); if (prev) prev.stop(); }
  const r = start(k, v, L, how, sub, next, dub, soon);
  if (how === "dip") requestAnimationFrame(() => { bl.style.transition = "opacity .5s linear"; bl.style.opacity = 0; });
  return r;
}
const LOG = new URLSearchParams(location.search).has("debug") ? (window.__reel = []) : null;   // ?debug — 넘어갈 때마다 대기 영상 그림과 클립 첫 그림을 적는다(점검용)
if (LOG) { const p0 = idle.pause.bind(idle); idle.pause = () => { LOG.push({ k: "idle.pause", how: new Error().stack.split("\n").slice(2, 4).map((x) => x.trim().split(" ")[1]).join("<"), t: Math.round(performance.now()) }); p0(); }; }
function start(k, v, L, how, sub, next, dub, soon) {
  if (SKIP.on && !soon) { drop(k); return Promise.resolve({ k, over: true, end: Promise.resolve(), stop() {} }); }   // 10/8 Skip — 영상을 받는 사이 건너뛰었다 — 틀지 않고 요소를 내려놓는다(play bye 와 같게). soon 은 질문 음성이라 튼다
  freeze = false;                                         // 첫 줄이 뜨면 대기 영상 붙잡기를 푼다(runFree)
  LOG?.push({ k, how, idle: idle.paused ? null : U(at()), front: front ? `${front.k}@${Math.round(ct(front.v) * FPS)}` : null, s: L.is != null ? U(L.is) : null, t: Math.round(performance.now()) });
  return new Promise((res) => {
    const c = { k, v, L, over: false, next: false, dub: null }, prev = front;
    if (prev && !prev.over) prev.next = true;              // 앞 줄은 끝나도 대기 영상으로 넘기지 않는다(이 줄이 위에 뜬다)
    front = c; aim = L.ie ?? null; LIVE.add(c);
    stage.insertBefore(v, shade);
    v.loop = false; v.muted = !!window.BGDUB?.on; v.defaultPlaybackRate = v.playbackRate = 1;   // 소리 나는 줄은 늘 제 속도. 10/9 외국어 화면은 영상 소리를 처음부터 끝까지 끈다 — 소리는 더빙만(한국어로 되돌리지 않는다)
    // 10/9 더빙을 이 영상의 시계에 묶는다 — 영상이 실제로 돌면(playing) 소리를 영상 시각에 맞춰 함께 틀고, 멈추면 함께 멈춘다(dub.js bind). 화면 갱신에 기대지 않는다
    const dh = dub ? (c.dub = window.BGDUB.bind(v, () => ct(v), dub.src, dub.segs)) : null;
    // 10/9 더빙이 영상보다 길 줄 — 끝 자세 영상을 미리 받아 둔다(endPose). 10/20 — .at() 은 아이폰 15.0~15.3 에 없다(던져서 줄이 멈췄다)
    const hk = holdOf(k), 끝자세놓기 = () => { if (hk) drop(hk); };   // 10/20 — 끝 자세로 넘어가지 않고 끝나면(다음 줄이 바로 뜸 · C09 · 회상 중 · 더빙이 이미 끝남 · 멈춤) 미리 받은 끝 자세 영상을 내려놓는다(pool 에 남아 받기를 잡고 있었다)
    if (dh && hk && dub.segs[dub.segs.length - 1][1] > (L.dur || 0) - 0.4) preload(hk);
    // s1: 실제 소리 끝(숨소리까지, tools/site_audible.py). 이 클립은 처음부터 끝까지 제 속도로만 돈다.
    const [a0, b] = L.sub || [0, 0], s1 = speechEnd(L);
    const a = Math.max(0, Math.min(a0, L.va ?? a0) - 0.1);   // 9/28 「자막이 말하는 시점보다 늦게 나온다」 — 실제 말소리 시작(va, site_audible)보다 0.1초 먼저
    const cueAt = L.sub ? s1 + SPEECH_GAP : Infinity, fade = how === "fade" ? 0.12 : 0;
    // 겹쳐 넘길 때 새 줄을 지금 보이는 얼굴 자리에 맞춰 둔다(앞 줄 꼬리 또는 대기 영상의 지금 자리 → 이 줄 첫 장면)
    const tail = prev && prev.L && prev.L.is != null && prev.k !== "C09loop" ? tailOf(prev) : null;
    const from = !fade || L.is == null ? null : tail ? tail.at : !prev ? at() : null;
    const alignment = from == null ? null : poseTf(v, from, L.is + Math.round(speechHead(L) * FPS), k, tail?.pose ?? null);
    const al = alignment?.jump ? null : alignment;
    v.style.transformOrigin = al ? al.origin : ""; v.style.transform = al ? al.tf : "";
    if (!prev) stopLoopBack();
    const talkA = (L.aa ?? a) - 0.3, talkB = s1 + 0.1;       // 배경음악은 소리가 나기 조금 전에 내려가고 소리가 끝나면 올라온다
    let raf = 0, cued = false, shown = false;
    const cue = () => { if (!cued) { cued = true; res(c); } };
    // 10/9 더빙이 한국어보다 길면 더빙 소리가 끝난(ended) 뒤에 다음 줄로 넘긴다. 넘긴 줄은 더빙을 놓는다
    // soon — 앞 줄 시각이 그대로면(스킵 직후 말 시작으로 아직 안 옮김) t 가 이미 말 끝을 지나 칸이 바로 떴다. 그 자리에서는 넘기지 않는다.
    const due = (t) => { if (soon && t > cueAt + 0.3) return; if (t >= cueAt && !(c.dub && !c.dub.ended)) { c.dub = null; cue(); } };
    // 10/9 더빙 줄은 화면 갱신이 멈춰도(창이 가려짐) 영상 시각 알림(timeupdate) · 더빙 끝으로 줄 끝 · 다음 줄 넘김을 본다
    const poke = () => {
      if (c.over) return;
      const t = ct(v);
      if (lane(v) && t >= cdur(v, L) - 1 / 60) { v.pause(); finish(); return; }
      due(t);
    };
    if (dh) { v.addEventListener("timeupdate", poke); dh.done.then(poke); }
    const reveal = () => {
      if (shown) return; shown = true;
      v.style.transition = fade ? `opacity ${fade}s linear${al ? `, transform ${GLIDE}s cubic-bezier(.2,.7,.2,1)` : ""}` : "none";
      // 음성 파일에는 그릴 트랙이 없다. 그림이 있는 줄은 회상이 위에 있어도 올려 둔다. 회상이 걷히면 그 줄이 그대로 보인다.
      if (!voiceLine(v)) { void getComputedStyle(v).opacity; v.classList.add("on"); if (al) v.style.transform = "none"; }
      if (soon) {
        const t0 = T0(v) + speechHead(L);
        if (Number.isFinite(t0) && Math.abs((v.currentTime || 0) - t0) > 0.15) { try { v.currentTime = t0; } catch { /* 다음 확인 */ } }
        const bl = $("black"); bl.style.transition = "opacity .12s linear"; bl.style.opacity = 0;
      }   // 10/9 스킵 — 질문 음성 장면이 뜨면 가림막을 걷는다. 앞 줄 시각에 서 있으면 말 시작으로 옮긴다
      if (!hid) c.wake();                                   // 10/8 점검 — 끝 지킴 시계는 영상이 실제로 뜬 때부터(받는 데 걸린 시간만큼 줄을 일찍 끊지 않게)
      setTimeout(() => {
        if (prev && prev.v !== v) { prev.stop(); prev.v.classList.remove("on"); drop(prev.k); }
        if (front !== c) return;
        preload(next);
        if (voiceLine(v) && !window.BGMEMORY?.active) { idle.classList.add("on"); if (idle.paused && idle.src && !idle.error) idle.play().catch(() => {}); }
        else idle.pause();
      }, fade * 1000 + 80);
    };
    const tick = () => {
      if (c.over) return;
      const t = ct(v);
      if (lane(v) && t >= cdur(v, L) - 1 / 60) { v.pause(); finish(); return; }   // 이어 틀기 — 파일이 계속 이어지므로 이 줄 끝에서 멈춘다(뒤에 끝 장면 0.2초가 이어져 있다)
      const ds = dh && !dh.blocked, talking = ds && dh.line() >= 0;   // 10/9 더빙 줄 자막은 더빙 소리 시각으로(말하는 동안). 소리를 못 틀었으면(아이폰이 막음) 한국어 시각
      if (front === c) {
        if (ds) { if (sub && L.text && talking) showSub(L.text); else hideSub(); }
        else if (sub && L.text && L.sub && t >= a && t <= b + 0.3) showSub(L.text); else hideSub();
        bgm.talk((t >= talkA && t <= talkB) || talking);
      }
      due(t);
      raf = requestAnimationFrame(tick);
    };
    c.end = new Promise((r) => (c.ended = r));             // 이 클립이 끝나 넘겨진 때(바로 이어지는 줄이 끝까지 돌기를 기다릴 때 쓴다)
    const finish = () => {
      if (c.over) return; c.over = true; LIVE.delete(c); cancelAnimationFrame(raf); clearTimeout(c.guard); v.removeEventListener("timeupdate", poke);
      const pass = () => { c.dub = null; cue(); bgm.talk(false); };   // 10/9 영상은 먼저 끝나도 더빙이 남아 있으면 그때까지 다음 줄을 기다린다. 넘긴 뒤에는 이 줄이 다음 줄 소리를 끄지 않는다
      if (!shown) c.dub?.stop();
      if (c.dub && !c.dub.ended) {
        c.dub.release();                                  // 10/9 영상이 이 줄 끝에 닿았다 — 더빙은 혼자 끝까지 돌고, ended 가 오면 넘긴다
        c.dub.done.then(pass);
        if (front === c) c.dub.done.then(() => { if (!c.next) hideSub(); });   // 10/9 영상이 먼저 끝나도 더빙이 말하는 동안은 자막을 둔다. 다음 줄이 이미 위에 있으면 건드리지 않는다
      } else {
        pass();
        if (front === c) hideSub();
      }
      // 10/1 코드 점검 — 이 줄이 끝내 안 떴으면(영상 오류 · 못 받음) 앞 줄을 여기서 걷는다 — 앞 줄은 이 줄이 뜰 때만 걷혀서 마지막 장면이 화면에 멈춘 채 남았다.
      // 이 줄도 멈춰 두어 늦게 받아져도 넘어간 뒤에 떠서 소리 나지 않게 한다.
      if (!shown) {
        v.removeEventListener("playing", reveal); v.pause();
        if (prev && prev.v !== v && prev.v !== front?.v) { prev.stop(); prev.v.classList.remove("on"); drop(prev.k); }
        if (soon) { const bl = $("black"); bl.style.transition = "opacity .2s linear"; bl.style.opacity = 0; }   // 10/9 스킵 — 질문 장면이 끝내 안 뜨면 가림막만 남지 않게
      }
      if (c.next) { c.dub?.stop(); 끝자세놓기(); return c.ended(); }                          // 다음 줄이 바로 위에 뜬다
      if (L.ie == null || (k === "C09" && M.mode !== "daily")) { 끝자세놓기(); hold(c); return c.ended(); }       // C09: 끝 자세로 꼬리를 앞뒤로 돈다
      if (c.dub && !c.dub.ended && !window.BGMEMORY?.active && endPose(c)) return c.ended();      // 10/9 더빙이 아직 말하는 중 — 대기 영상으로 넘기지 않고 끝 자세를 붙잡는다
      끝자세놓기(); handoff(c, L.ie).then(c.ended);
    };
    c.stop = () => { c.dub?.stop(); v.removeEventListener("timeupdate", poke); if (!c.over) { c.over = true; LIVE.delete(c); c.next = true; cancelAnimationFrame(raf); clearTimeout(c.guard); 끝자세놓기(); cue(); c.ended(); } v.pause(); };
    v.onended = finish; v.onerror = finish;
    // 끝 신호가 안 오면 영상 길이 + 5초 뒤 넘어간다. 10/1 코드 점검 — 이 시계는 벽시계라 화면을 벗어난 동안은 세워 두고(park) 돌아오면 남은 길이 + 5초로 다시 건다(wake · setAway)
    const arm = (s) => { clearTimeout(c.guard); c.guard = setTimeout(finish, s * 1000); };
    c.park = () => clearTimeout(c.guard);
    c.wake = () => { if (!c.over) arm(Math.max(0, cdur(v, L) - ct(v)) + 5); };
    arm((L.dur || 8) + 5);
    const go = (c.go = () => {
      const attempt = (left) => v.play().catch((e) => {
        if (c.over || e?.name === "AbortError") return;
        if (e?.name === "NotAllowedError") { v.muted = true; v.play().catch(() => {}); return; }
        if (left > 0) setTimeout(() => attempt(left - 1), 500);
      });
      attempt(4);
    });
    if (v.error) { finish(); return; }                       // 10/1 코드 점검 — 틀기 전에 이미 오류가 난 클립(onerror 를 걸기 전에 났다) — 기다리지 않고 넘긴다
    // 10/8 점검 — 화면이 숨은 동안 불리면 틀지 않고 멈춰 둔다(돌아오면 setAway 가 틀고 시계를 다시 건다). 전엔 지킴 시계가 흘러 기록 줄 · 물음 줄이 아무도 못 들은 채 넘어갔다
    const run = () => { if (hid) { c.held = true; c.park(); } else go(); };
    if (v.readyState >= 2) { reveal(); run(); } else { v.addEventListener("playing", reveal, { once: true }); run(); }
    raf = requestAnimationFrame(tick);
  });
}
// C09 가 끝난 자세(팔짱 등)는 대기 영상에 없다 — 말이 끝난 뒤 꼬리를 앞뒤로 도는 영상(C09loop)을 그 마지막 장면 위에 이어 붙인다.
// 꼬리가 짧아 그 영상이 없는 인물은 마지막 장면을 천천히 당겨 보인다.
function hold(c) {
  if (!c.L.loop) { c.v.classList.add("hold"); return; }
  const lv = vid("C09loop"), lc = { k: "C09loop", v: lv, L: { ie: null }, over: true, next: true, stop() { lv.pause(); } };
  lv.muted = true; lv.loop = !lane(lv); if (lane(lv)) seekClip(lv); else lv.currentTime = 0; lv.style.transition = "none"; stage.insertBefore(lv, shade);
  lv.defaultPlaybackRate = lv.playbackRate = 0.5;   // 9/27 「초단위로 좌우로 왔다갔다」 — 끝 자세 꼬리(짧으면 1.7초)를 앞뒤로 도는 영상이라 반 속도로 천천히(소리 없음)
  const on = () => { if (front !== c) return; lv.classList.add("on"); front = lc; setTimeout(() => { c.v.classList.remove("on"); drop(c.k); }, 80); };
  lv.play().then(() => (lv.readyState >= 2 ? on() : lv.addEventListener("playing", on, { once: true }))).catch(() => c.v.classList.add("hold"));
}
/* 10/9 더빙이 대사 영상보다 길 때(외국어 화면) — 기다리는 동안 대기 영상으로 넘기면 대기 영상이 흐른 만큼 자세가 바뀌어 다음 줄 첫 장면과 어긋났고,
   자세 맞추기의 검은 가림막(pose-join)이 걸렸다(사장님이 실제로 봄). 대신 그 줄의 끝 입 다문 구간을 앞뒤로 도는 영상(hold/{줄}.mp4 — tools/dub_hold.py,
   사장님이 승인한 「3판」과 같은 늘이기)을 끝 장면 위에 이어 틀어 자세를 붙잡고, 더빙이 끝나면 다음 줄이 한국어처럼 끝 자세에서 잇는다.
   다음 줄이 곧 오지 않으면(고르기 · 입력 칸) 더빙이 끝나고 0.4초 뒤 대기 영상으로 넘긴다 — 한국어에서 영상이 끝난 때와 같다. 끝 자세 영상이 없는 줄은 예전처럼 넘긴다. */
const holdOf = (k) => (window.BGDUB?.hold?.("saju", C, k) ? `hold/${k}` : null);
function endPose(c) {
  const hk = holdOf(c.k); if (!hk) return false;
  const hv = vid(hk), hc = { k: hk, v: hv, L: c.L, from: c.k, src: c, hold: true, over: true, next: true, dub: c.dub, stop() { hv.pause(); } };
  hv.muted = true; hv.loop = true; hv.style.transition = "none"; hv.style.transform = hv.style.transformOrigin = "";
  if (hv.currentTime > 0.05) hv.currentTime = 0;
  stage.insertBefore(hv, shade); c.posing = true;          // posing — 끝 장면에 멈춘 채 끝 자세 영상을 기다리는 동안 hover 가 대기 영상으로 넘기지 않게
  const on = () => { if (front !== c) { if (front?.v !== hv) drop(hk); return; } hv.classList.add("on"); front = hc; setTimeout(() => { c.v.classList.remove("on"); drop(c.k); }, 80); };
  hv.play().then(() => (hv.readyState >= 2 ? on() : hv.addEventListener("playing", on, { once: true }))).catch(() => {});
  c.dub.done.then(() => setTimeout(() => {
    c.posing = false;
    if (c.taken || SKIP.on) return;
    if (front === hc) handoff(hc, c.L.ie);
    else if (front === c) { hv.removeEventListener("playing", on); drop(hk); handoff(c, c.L.ie); }   // 끝 자세 영상이 끝내 안 떴다 — 끝 장면에서 바로 넘긴다
  }, 400));
  return true;
}
// 위에 보이는 클립을 걷어 내고 대기 영상을 s 자리부터 돌린다(유료로 들어갈 때 — 까맣게 내렸다 올린다)
let entering = Promise.resolve();
function toIdle(s) {
  const f = front; front = null; aim = s; stopLoopBack();
  return (entering = (async () => {
    const bl = $("black"); bl.style.transition = "opacity .3s linear"; bl.style.opacity = 1; await wait(330);
    if (f) { f.stop(); f.v.classList.remove("on"); drop(f.k); }
    idle.currentTime = idleTime(s ?? at()); idle.playbackRate = 1; idle.play().catch(() => {});
    await wait(120); bl.style.transition = "opacity .6s linear"; bl.style.opacity = 0;
  })());
}
/* 10/1 코드 점검 — 화면을 벗어나면(다른 앱 · 다른 탭 · 화면 잠금 · 전화) 줄 영상과 대기 영상을 멈추고 줄 지킴 시계를 세운다.
   지킴 시계는 벽시계라 숨은 동안 흘러, 돌아오면 말하던 줄을 끊고 넘어갔다. 이어 틀기 재생기는 rAF(숨으면 안 돈다)로만 줄 끝에서 멈춰
   숨은 동안 다음 줄 소리까지 흘러갔다(데스크톱). 돌아오면 멈춘 줄을 이어 틀고 시계를 남은 만큼 다시 건다 — 대기 영상 · C09 끝 자세는 hover 가 다시 튼다.
   배경음악 · 효과음은 bgm.js · sfx.js 가 맡는다. 결과지 서버 보관은 이때 바로 보낸다(flushVault). */
let hid = false;
function setAway(h) {
  const next = (typeof h === "boolean" ? h : document.visibilityState === "hidden") || payHold;
  if (next === hid) return; hid = next;
  if (hid) {
    stopLoopBack(); idle.pause(); if (front?.k === "C09loop" || front?.hold) front.v.pause();
    LIVE.forEach((c) => { c.park(); if (!c.v.paused) { c.held = true; c.v.pause(); } });   // 10/9 더빙은 영상이 멈추면 함께 멈추고, 다시 돌면 영상 시각에 맞춰 함께 돈다(dub.js bind)
  } else LIVE.forEach((c) => { if (c.held) { c.held = false; c.go(); } c.wake(); });
}
document.addEventListener("visibilitychange", () => { const h = document.visibilityState === "hidden"; setAway(h); if (h) flushVault(true); });
addEventListener("pagehide", () => { setAway(true); flushVault(true); });
addEventListener("pageshow", (e) => { if (e.persisted) setAway(document.visibilityState === "hidden"); });
// 10/9 결제창(화면 안 시트 · 작은 창)은 페이지를 숨기지 않는다 — 여는 동안 대사 영상을 멈춰 더빙도 같이 멈추고, 닫으면 잇는다(coin.js bamgwabi:payhold)
addEventListener("bamgwabi:payhold", (e) => { payHold = !!e.detail; setAway(document.visibilityState === "hidden"); });
function showSub(t) {
  t = window.BGLANG?.t(t) ?? t;
  if ($("choices").classList.contains("on") || $("ask").classList.contains("on")) { hideSub(true); return; }
  const s = $("sub"); if (s.textContent !== t) s.textContent = t; if (!s.classList.contains("on")) { s.style.transition = ""; s.classList.add("on"); } }
// 10/27 리뷰 — 바로 숨길 때(질문 · 고르기 칸이 뜰 때)는 이미 사라지는 중인 자막(대사 끝 hideSub 의 0.15초)도 끊는다 — 그 잠깐 두 대화창이 포개졌다
function hideSub(immediate = false) { const s = $("sub"); if (immediate) s.style.transition = "none"; if (s.classList.contains("on")) { if (!immediate) s.style.transition = ""; s.classList.remove("on"); } }
/* 10/8 사장님 「오프닝,엔딩 스킵이라고 생각하면 좋을것같네 끝인사를 스킵하고 무료결과페이지로 갈수있다거나」 · 「skip로 버튼 넣어」 ·
   「화살표는 지워도 될듯」 — 오프닝(첫 질문 음성이 시작되기 전)과 엔딩(마지막 답 뒤 무료 결과가 뜨기 전)에만 오른쪽 아래(자막 밑)에 「Skip」을 띄운다.
   10/9 사장님 「스킵을 누르면 질문 음성이 시작되는 시점으로」 · 「화면이 바로 이동」 — 오프닝은 질문 칸이 아니라 그 질문 말의 시작 장면으로 바로 붙고,
   누르는 순간에 지금 영상을 멈추고 걷는다(페이드를 기다리는 동안 입은 계속 움직였다). 엔딩은 남은 인사를 건너뛰고 결과로 간다.
   구간은 질문 음성이 시작될 때(03-input) · 무료 결과가 뜰 때(05-free) 닫힌다. where — "voice" 면 질문 음성으로 붙는다. */
const SKIP = { on: false, waits: [], where: null };
const skipped = () => new Promise((r) => (SKIP.on ? r() : SKIP.waits.push(r)));   // 건너뛰면 풀린다(영상 받기를 기다리는 줄)
function skipZone(open, where = null) { SKIP.on = false; SKIP.waits.length = 0; SKIP.where = open ? where : null; $("skip").hidden = !open; }
// 10/9 — 스킵을 누른 그 순간에 소리와 그림을 같이 끊는다. 더빙만 끄면 영상 속 입이 몇 초 더 움직였다.
function cutFront(f) {
  if (!f) return;
  if (front === f || (f.src && front === f.src)) front = null;
  for (const c of (f.src && f.src !== f ? [f, f.src] : [f])) {
    c.dub?.stop();
    if (!c.v) continue;
    c.v.muted = true; c.v.pause(); c.v.style.transition = "none"; c.v.classList.remove("on");
  }
  if (!f.over && typeof f.stop === "function") f.stop();
}
$("skip").onclick = () => {
  if (SKIP.on || $("skip").hidden) return;
  const where = SKIP.where;
  SKIP.on = true; $("skip").hidden = true; hideSub(true); bgm.talk(false); SKIP.waits.splice(0).forEach((r) => r());
  const f = front;
  cutFront(f);
  if (where === "voice") {   // 질문 음성 줄이 바로 잇는다 — 대기 영상으로 내리지 않고, 그 장면이 뜰 때까지 까맣게 가린다
    const bl = $("black"); bl.style.transition = "none"; bl.style.opacity = 1;
    handing = Promise.resolve(); freeze = false; return;
  }
  if (window.BGMEMORY?.active) return;   // 장면 기억 안에서는 그 자리에 멈춘 채로 둔다(이미 끊었다)
  if (f?.hold) { handoff(f, f.L.ie); return; }   // 10/9 더빙을 기다리던 끝 자세 — 대기 영상으로 이어 내린다
  if (!f || f.over) { freeze = false; idle.play().catch(() => {}); return; }   // 첫 줄을 받는 중이면 붙잡아 둔 대기 영상을 푼다
  toIdle(f.L?.ie ?? null);
};
/* ── 고르기: 판 없이 글자만, 고르면 빛난 뒤 넘어간다(사장님 9/24) ── */
function pickFrom(layer, qEl, box, qText, labels, pre = -1) {   // pre — 계정에 저장된 전에 고른 쪽(밑줄을 그어 둔다, me.js)
  return new Promise((res) => {
    qEl.textContent = qText; qEl.classList.remove("gone"); box.innerHTML = "";
    labels.forEach((label, i) => { const b = document.createElement("button"); b.type = "button"; b.className = i === pre ? "choice was" : "choice"; b.textContent = label; b.onclick = () => done(i, b); box.appendChild(b); });
    // 10/8 애플 기준(기획/130) — 선택지가 뜬 뒤 0.5초는 누름을 받지 않는다(말이 끝나 이야기는 멈춰 있다 — 대기 영상의 숨 · 눈 깜빡임은 9/25 결정대로 돈다)
    hideSub(true); skipZone(false); layer.classList.add("on"); let picked = false; const shownAt = performance.now();
    function done(i, btn) {
      if (picked || performance.now() - shownAt < 500) return; picked = true; SFX.tap(); buzz();   // 10/1 인터랙션 16 — 고르는 순간 짧게 떨림
      box.querySelectorAll(".choice").forEach((el) => el.classList.add(el === btn ? "picked" : "gone")); qEl.classList.add("gone");
      // 9/28 사장님 「선택지에서 무엇을 선택하면 바로 영상이 재생이 되는데 내가 선택한 버튼이 늦게 사라져서 자막과 겹치는 현상」 —
      // 바로 이어지는 선택지(early)는 고른 단추가 0.9초 남아 다음 영상 자막과 겹쳤다. 짧게 빛난 뒤 곧 흐려지고 0.5초에 판을 걷는다(자막은 판이 걷힌 뒤 — showSub).
      // 10/28 사장님 「선택하면 영상이 바로 재생이 되어야 하는데 대기 영상처럼 가만히 있는 부분이 굉장히 많았어」 — 고른 단추를 0.5초(바로 이어지는 선택지) · 0.9초 보여 준 뒤에야
      //   다음 줄을 불러 고를 때마다 1~3초 대기 영상만 돌았다(38번 실측). 고르는 순간 다음으로 넘기고(res) 판은 0.35초 뒤에 걷는다 — 자막은 판이 떠 있는 동안 뜨지 않는다(showSub).
      //   그사이 같은 판에 다음 물음이 떴으면(단추가 판에서 빠짐) 그 판은 걷지 않는다
      setTimeout(() => btn.classList.add("gone"), 180);
      res(i);
      setTimeout(() => { if (btn.isConnected) layer.classList.remove("on"); }, 350);
    }
  });
}
function choose(q) {   // 10/2 — 반응 줄은 물음 줄을 다 받은 뒤에 받는다(runFree). 고른 줄은 틀 때(play → vid) 받는다
  return pickFrom($("choices"), $("qtext"), $("opts"), M.lines[q.q].text, q.opts.map((o) => o[0])).then((i) => {
    const k = q.opts[i][1]; q.opts.forEach((o) => { if (o[1] !== k) setTimeout(() => drop(o[1]), 1500); }); return k;
  });
}
function askConcern() {
  return new Promise((resolve) => {
    const layer = $("ask"), box = $("askBody"), title = $("askq");
    title.textContent = "지금 가장 마음에 걸리는 일을 적어 주세요"; title.classList.remove("gone");
    box.innerHTML = '<form class="concern-form"><textarea maxlength="500" rows="4" aria-label="지금 내 고민" aria-describedby="concern-note" placeholder="무슨 일이 있었고, 무엇을 알고 싶은지 적어 주세요"></textarea><p class="concern-count" aria-live="polite"></p><p class="concern-note" id="concern-note">다음으로 넘어가면 수정할 수 없으니, 고민과 궁금한 점을 정확히 적어 주세요.</p><button class="choice" type="submit" disabled>다음</button></form>';
    const form = box.firstElementChild, field = form.querySelector("textarea"), count = form.querySelector(".concern-count"), go = form.querySelector("button");
    field.value = input.concern || "";
    const value = () => field.value.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, "").trim().normalize("NFC");
    const update = () => { const n = value().length; go.disabled = n < 3 || n > 500; count.textContent = `${field.value.length} / 500`; };
    field.oninput = update; update();
    hideSub(true); skipZone(false); layer.classList.add("on");
    form.onsubmit = async (e) => {
      e.preventDefault(); if (go.disabled) return;
      input.concern = value(); go.disabled = true; SFX.tap(); buzz();
      layer.classList.remove("on"); await wait(500); box.innerHTML = ""; resolve();
    };
  });
}
const askPick = (line, labels, pre) => pickFrom($("ask"), $("askq"), $("askBody"), line, labels, pre);

/* ── 날짜·시각 바퀴: 칸 없이 숫자만, 가운데 줄이 고른 값(대본 「날짜 바퀴」) ── */
// 9/28 사장님 「12월에서 위로 더 올리면 1월로 가지게 하고 59분에서 위로 가면 00분으로 가지게」 — loop 바퀴(월 · 일 · 시 · 분)는 끝없이 돈다.
// 같은 값을 일곱 벌 이어 붙이고 가운데 벌에서 시작한다. 돌리기가 멈추면(0.18초 동안 스크롤 없음 · 손가락을 뗀 뒤) 가운데 벌의 같은 값 자리로 조용히 옮긴다 —
// 한 벌 길이의 배수만큼 옮기므로 보이는 글자는 그대로다. 년도는 돌지 않는다(끝에서 멈춤).
function colOf(values, fmt, def, loop = false) {
  const c = document.createElement("div"); c.className = "col";
  const L = values.length, K = loop ? 7 : 1, MID = loop ? 3 : 0;
  c.innerHTML = '<div class="pad"></div>' + Array.from({ length: L * K }, (_, i) => `<div>${fmt(values[i % L])}</div>`).join("") + '<div class="pad"></div>';
  const items = [...c.children].slice(1, -1);
  const at = () => Math.min(items.length - 1, Math.max(0, Math.round(c.scrollTop / 44)));
  // 10/1 인터랙션(기획/119) 8 — 칸이 넘어갈 때마다 아주 짧게 떨리고(안드로이드), 돌리기가 멈추면 가운데 숫자가 살짝 커진다(.fxset — play.html).
  // 떨림은 값이 바뀔 때만(돌림 바퀴를 가운데 벌로 옮기는 것 · 기본값을 넣는 것은 조용히). 돌리기 시작하면 원래 크기로.
  let seen = null, tickAt = 0, quiet = false, big = null, selected = null, markFrame = 0;
  const mark = () => {
    const i = at(), next = items[i];
    if (selected !== next) { selected?.classList.remove("sel"); next?.classList.add("sel"); selected = next; }
    const v = i % L; if (seen != null && v !== seen && !quiet) { c._moved?.(); if (performance.now() - tickAt > 40) { tickAt = performance.now(); buzz(8); } } seen = v;   // 10/2 — 손으로 돌려 값이 바뀌면 바퀴에 알린다(_moved)
    if (big && big !== items[i]) { big.classList.remove("fxset"); big = null; }
  };
  const jump = (top) => {                                  // 스냅이 끼어들지 않게 잠깐 끄고 옮긴다
    c.style.scrollSnapType = "none"; c.scrollTop = top; quiet = true; mark(); quiet = false;
    setTimeout(() => { c.style.scrollSnapType = ""; }, 60);
  };
  let endT = 0, touching = false, moving = false;
  const recenter = () => { if (!loop || touching) return; const i = at(); if (Math.floor(i / L) !== MID) jump((MID * L + (i % L)) * 44); };
  const settle = () => { if (touching || !fxOn() || c.parentNode?.classList.contains("unset")) return; const el = items[at()]; if (el && el !== big) { big?.classList.remove("fxset"); big = el; el.classList.add("fxset"); } };   // 가운데 벌로 옮긴 뒤에 키운다
  const later = () => {
    moving = true; clearTimeout(endT);
    endT = setTimeout(() => {
      const before = c.scrollTop; recenter();
      if (c.scrollTop !== before) return;   // 가운데로 옮기면 스크롤이 한 번 더 오고, 그 멈춤이 moving 을 끈다
      settle(); moving = false;
    }, 180);
  };
  c._moving = () => touching || moving;
  c._rest = () => new Promise((ok) => {
    const start = Date.now();
    const wait = () => { if (!c._moving() || Date.now() - start > 2000) { ok(); return; } setTimeout(wait, 40); };
    wait();
  });
  c.addEventListener("scroll", () => { if (!markFrame) markFrame = requestAnimationFrame(() => { markFrame = 0; mark(); }); later(); }, { passive: true });
  c.addEventListener("touchstart", () => { touching = true; }, { passive: true });
  c.addEventListener("touchend", () => { touching = false; later(); }, { passive: true });
  c.addEventListener("touchcancel", () => { touching = false; later(); }, { passive: true });
  items.forEach((el, j) => (el.onclick = () => { c._moved?.(); c.scrollTo({ top: j * 44, behavior: "smooth" }); }));
  c._set = () => { jump((MID * L + Math.max(0, values.indexOf(def))) * 44); later(); };   // 기본값 자리로(돌림 바퀴는 가운데 벌). 10/1 — 멈춘 값처럼 살짝 키운다
  c._get = () => values[at() % L];
  c._to = (v) => { const i = at(); c.scrollTo({ top: (i - (i % L) + Math.max(0, values.indexOf(v))) * 44, behavior: "smooth" }); };   // 그 값 자리로 옮긴다(지금 벌 안에서)
  return c;
}
const range = (a, b) => Array.from({ length: b - a + 1 }, (_, i) => a + i);
// 10/2 점검 — blank: 기본값이 지어낸 값(상대 · 헤어진 날 · 저장 안 된 본인 값 · 시각 찾기의 해)이면 아무것도 고르지 않은 채로 띄운다 —
// 숫자를 흐리게 · 가운데 줄 없이 두고 「다음」은 직접 값을 누르거나 돌릴 때까지 꺼 둔다(기본값이 말없이 넘어가지 않게). wide — 아래 단추를 「다음」과 같은 크기로
function askWheel(line, cols, extra, check, { blank = false, wide = false, err = "" } = {}) {   // check — 「다음」을 누를 때 고른 값을 본다. 탈이 있으면 그 까닭을 돌려준다(알리고 넘어가지 않는다) · err — 처음부터 보일 오류(엔진이 날짜를 받지 않음)
  return new Promise((res) => {
    const layer = $("ask"), qEl = $("askq"), box = $("askBody");
    qEl.textContent = line; qEl.classList.remove("gone"); box.innerHTML = "";
    const w = document.createElement("div"); w.className = "wheel"; cols.forEach((c) => w.appendChild(c));
    const hl = document.createElement("i"); hl.className = "hl"; w.appendChild(hl); box.appendChild(w);
    // 10/8 애플 기준 — 오류는 사라지는 알림 대신 바퀴 바로 밑에 남긴다(3-화면글-점검 32)
    const er = document.createElement("p"); er.className = "werr"; er.setAttribute("role", "alert"); er.textContent = err; box.appendChild(er);
    const go = document.createElement("button"); go.type = "button"; go.className = "choice go"; go.textContent = "다음";   // 10/27 — 「다음」은 밝은 단색 알약(play.html .choice.go)
    let alt = null; if (extra) { alt = document.createElement("button"); alt.type = "button"; alt.className = wide ? "choice" : "choice small"; alt.textContent = extra; }
    // 10/2 사장님 「이거 이상하지? 배치부터 다시해」 — 시각 찾기 해 바퀴(wide): 바퀴를 세 칸으로 줄이고 「다음」 · 「잘 모르겠어요」를 한 줄에 둔다(둘이 세로로 쌓여 바퀴가 얼굴 한가운데로 올라갔다)
    if (wide && alt) { w.classList.add("short"); const pair = document.createElement("div"); pair.className = "pair"; pair.append(alt, go); box.appendChild(pair); }
    else { box.appendChild(go); if (alt) box.appendChild(alt); }
    if (blank) { w.classList.add("unset"); go.disabled = true; }
    cols.forEach((c) => (c._moved = () => { if (!w.classList.contains("unset")) return; w.classList.remove("unset"); go.disabled = false; }));
    hideSub(true); skipZone(false); layer.classList.add("on"); cols.forEach((c) => c._set());   // 뜨자마자 기본값을 넣고(그리기 신호가 늦어도) 조금 뒤 한 번 더
    const shownAt = performance.now();   // 10/8 — 뜬 뒤 0.5초는 누름을 받지 않는다(pickFrom 과 같다)
    setTimeout(() => cols.forEach((c) => { if (c.scrollTop === 0) c._set(); }), 150);
    let done = false;
    const finish = (val, btn) => {
      if (done || performance.now() - shownAt < 500) return; done = true; SFX.tap(); buzz();   // 10/1 인터랙션 16
      w.classList.add(val ? "picked" : "gone");
      [go, alt].forEach((b) => { if (b) b.classList.add(b === btn ? "picked" : "gone"); }); qEl.classList.add("gone");
      setTimeout(() => w.classList.add("gone"), 180);
      res(val);   // 10/28 — 고르기(pickFrom)와 같게 누르는 순간 다음으로 넘기고 판은 뒤에 걷는다(같은 판에 다음 물음이 떴으면 걷지 않는다)
      setTimeout(() => { if (go.isConnected) layer.classList.remove("on"); }, 350);
    };
    go.onclick = () => {
      if (done) return;
      if (performance.now() - shownAt < 500) return;
      const run = () => {
        if (done) return;
        const v = cols.map((c) => c._get()), bad = check?.(v, cols);
        if (bad) { er.textContent = bad; buzz(20); return; }
        er.textContent = "";
        finish(v, go);
      };
      if (cols.some((c) => c._moving?.())) { Promise.all(cols.map((c) => c._rest?.() ?? null)).then(run); return; }
      run();
    };
    if (alt) alt.onclick = () => finish(null, alt);
  });
}
// 10/1 코드 점검 — 날짜 바퀴는 어느 달이든 1~31일이 다 있고 따로 보지 않아(2월 30일 · 오늘 뒤 · 생일보다 앞선 헤어진 날) 엔진이 나중에 막았다 —
// 「다음」에서 보고 그 자리에서 고치게 한다. 없는 날은 그달 끝 날로 옮겨 두고 알린다. 오늘은 엔진 풀이 기준일과 같은 한국 날짜.
// 10/1 코드 점검 — 풀이 기준일(referenceDate, REF). 엔진은 「올해 · 이번 달」을 이 날로 셈한다(안 보내면 부를 때마다 그날). 풀이를 시작할 때(runFree) 한 번 정해
// 그 풀이의 모든 요청(무료 재료 · 목차 · 값 · 주문 · 유료 재료 · 풀이 글)에 같은 값을 싣는다(engineReq — 이어 보기는 적어 둔 요청에서 되살린다).
// 서버는 이 날을 요청해시에 넣어 산 풀이를 뒷날로 옮겨 쓰지 못하게 하고, 새 주문은 오늘 · 어제 날만 받는다(deploy/pay.js 기준일맞나).
// 이 기기 시계가 틀려도 서버 날짜로 — 인물 데이터를 받을 때 응답의 Date 머리로 차이(SKEW)를 잰다(못 읽으면 이 기기 시계).
let SKEW = 0, REF = null;
const REF바꿈 = (값) => (REF = 값);   // 다른 조각이 바꿀 때(모듈은 가져온 이름에 직접 넣을 수 없다)
const kstOf = (t) => new Date(t + 9 * 3600000).toISOString().slice(0, 10);
const noteClock = (r) => { const t = Date.parse(r?.headers?.get?.("Date") || ""); if (t > 0) SKEW = t - Date.now(); };
const todayKst = () => REF || kstOf(Date.now() + SKEW);
const dateCheck = (after) => ([y, m, d], cols) => {   // after — 이 날들보다 앞서면 안 된다(헤어진 날: 두 사람 생일)
  const last = new Date(y, m, 0).getDate();
  if (d > last) { cols[2]._to(last); return `${m}월은 ${last}일까지예요`; }
  const s = ymd([y, m, d]);
  if (s > todayKst()) return "오늘 이후 날짜는 선택할 수 없어요";
  if ((after || []).some((x) => x && s < ymd(x))) return "두 사람의 생일 이후 날짜를 선택해 주세요";
  return null;
};
const askDate = (line, y0, y1, def, extra, after, blank = false, check = dateCheck(after), err = "") => askWheel(line, [colOf(range(y0, y1), (v) => v + "년", def[0]), colOf(range(1, 12), (v) => v + "월", def[1], true), colOf(range(1, 31), (v) => v + "일", def[2], true)], extra, check, { blank, err });
const askTime = (line, def, extra, blank = false) => askWheel(line, [colOf(range(0, 23), (v) => pad(v) + "시", def[0], true), colOf(range(0, 59), (v) => pad(v) + "분", def[1], true)], extra, undefined, { blank });   // extra — 바퀴 밑 작은 단추(생시 필수 질문의 「태어난 시간 찾기」)

// 10/9 사장님 「고객이 … 생년월일을 선택하는건데 어떻게 저런오류가 나와?」 — 예전엔 날짜 바퀴가 어느 달이든 1~31일을 다 보여 양력 2월 30일 · 4월 31일 ·
//   평년 2월 29일을 고를 수 있었고 엔진이 거절했다(「생년월일을 1990-05-17 처럼 적어 주세요」). 윤달도 그해 그 달에 없는데 물어 거절됐다.
//   이제 양력 · 음력을 먼저 묻고, 일 칸은 고른 해 · 달에 실제로 있는 날만 보인다. 윤달은 그해 그 달이 윤달일 때만 묻는다.
// 음력 달 길이 · 윤달(1940~2050) — 엔진(사주엔진 src/manseryeok-fork.js, lunar-data 의 LUNAR_DATA)을 그대로 옮겼다. 뜻도 같다:
//   윤달 = 값 & 15(0 이면 없음) · 윤달 길이 = 값 & 65536 ? 30 : 29 · m월 길이 = 값 & (65536 >> m) ? 30 : 29
const LUNAR0 = 1940, LUNAR = [54432,120998,46736,22224,75188,9680,37584,53938,43344,54615,46240,46416,87381,19888,9648,99699,21168,43448,26960,27296,44710,43856,19296,43748,42352,21104,29283,55632,27479,22176,39632,19925,19168,42208,54484,53840,54680,46400,54944,103846,38320,18864,43444,42160,45690,27216,27968,46934,11104,38320,19317,18800,25776,29859,59984,28056,23248,11104,38629,37600,51552,59732,54432,55888,30034,22208,43959,9680,37584,51893,43344,46240,111779,46416,21977,19360,42416,21877,21168,43344,47444,27296,44368,27474,19296,42726,42352,21104,27237,55600,23200,46755,38608,19195,19168,42192,118998,53840,54560,56645,46752,38608,21938,18864,42359,42160,45648,111189,27968,44448,84835];
const leapOf = (y) => (LUNAR[y - LUNAR0] ?? 0) & 15;
const lunarDays = (y, m, leap) => { const v = LUNAR[y - LUNAR0]; if (v == null) return 30; return leap ? (v & 65536 ? 30 : 29) : (v & (65536 >> m) ? 30 : 29); };
const daysIn = (cal, y, m, leap = false) => cal === "lunar" ? lunarDays(y, m, !!(leap && leapOf(y) === m)) : new Date(y, m, 0).getDate();
// 생년월일 바퀴 — 해 · 달을 돌려 멈추면 일 칸을 그달 날 수로 다시 만든다(고른 날이 그달 끝을 넘으면 끝 날로).
// 음력 윤달이면 평달 · 윤달 중 고른 쪽의 날 수만 보인다(긴 쪽을 보여 짧은 쪽에 없는 날을 고르면 엔진이 거절했다).
function askBirthDate(line, y0, y1, def, blank, cal, savedLeap = false) {
  const dayCol = (n, d) => colOf(range(1, n), (v) => v + "일", Math.min(d, n), true);
  let leap = !!savedLeap, leapPicked = cal === "lunar" && !!savedLeap;
  let n = daysIn(cal, def[0], def[1], leap);
  const cols = [colOf(range(y0, y1), (v) => v + "년", def[0]), colOf(range(1, 12), (v) => v + "월", def[1], true), dayCol(n, def[2])];
  const asked = askWheel(line, cols, undefined, (v) => (cal === "lunar" && leapOf(v[0]) === v[1] && !leapPicked ? "평달인지 윤달인지 골라 주세요" : null), { blank });
  const box = $("askBody"), row = document.createElement("div"); row.className = "pair";
  const plain = document.createElement("button"), leapBtn = document.createElement("button");
  plain.type = leapBtn.type = "button"; plain.className = leapBtn.className = "choice small";
  plain.textContent = "평달"; leapBtn.textContent = "윤달"; row.append(plain, leapBtn);
  const go = [...box.querySelectorAll("button")].find((b) => b.textContent === "다음");
  go?.before(row);
  const paint = () => {
    const show = cal === "lunar" && leapOf(cols[0]._get()) === cols[1]._get();
    row.style.display = show ? "" : "none";
    plain.classList.toggle("picked", show && leapPicked && !leap);
    leapBtn.classList.toggle("picked", show && leapPicked && leap);
  };
  const refit = () => {
    paint();
    const m = daysIn(cal, cols[0]._get(), cols[1]._get(), leap);
    if (m === n || !cols[2].isConnected) return;
    const old = cols[2], next = dayCol(m, old._get()); next._moved = old._moved; n = m;
    old.replaceWith(next); cols[2] = next; next._set();
  };
  const choose = (next) => {
    leap = next; leapPicked = true;
    const w = row.closest(".wheel");
    if (w?.classList.contains("unset")) { w.classList.remove("unset"); if (go) go.disabled = false; }
    refit();
  };
  plain.onclick = () => choose(false); leapBtn.onclick = () => choose(true); paint();
  cols.slice(0, 2).forEach((c) => { let t = 0; c.addEventListener("scroll", () => { clearTimeout(t); t = setTimeout(refit, 220); }, { passive: true }); });
  // 10/27 리뷰 — 달을 돌린 직후(일 칸을 다시 만들기 전) 누르면 옛 칸의 31일을 읽어 4월 31일 같은 없는 날이 갔다 — 그 달 마지막 날로 맞춘다
  return asked.then((date) => { if (date) { date.leap = cal === "lunar" && leapOf(date[0]) === date[1] && leap; date[2] = Math.min(date[2], daysIn(cal, date[0], date[1], date.leap)); } return date; });
}
// 같은 대기 영상에서 달력을 고른다.
async function askBirth(line, def, blank, saved) {
  const layer = $("ask");
  try {
    for (;;) {
      layer.classList.add("say");
      $("askq").setAttribute("aria-live", "polite");
      const cal = ["solar", "lunar"][await askPick("양력인가요, 음력인가요?", ["양력", "음력"], saved ? +(saved.calendarType === "lunar") : -1)];
      layer.classList.remove("say");
      const date = await askBirthDate(line, 1940, +todayKst().slice(0, 4), def, blank, cal, !!(saved?.isLeapMonth));   // 10/8 점검 — 마지막 해는 기기 시계 대신 풀이 기준일(서버 날짜)
      layer.classList.add("say");
      const birthCalendar = { birthDate: ymd(date), calendarType: cal };
      if (cal === "lunar") birthCalendar.isLeapMonth = leapOf(date[0]) === date[1] && !!date.leap;
      try {
        const r = await askEngine("birth-calendar", birthCalendar);
        if (!/^\d{4}-\d{2}-\d{2}$/.test(r.birthDate || "")) throw new Error("생년월일을 확인하지 못했어요. 다시 선택해 주세요");
        if (r.birthDate > todayKst()) throw new Error("오늘 이후 날짜는 선택할 수 없어요");
        return { date: r.birthDate.split("-").map(Number), birthCalendar };
      } catch (e) {   // 10/9 사장님 「애초에 이걸 빼버려」 — 바퀴 밑 빨간 오류 문구는 띄우지 않는다
        // 10/27 리뷰 — 통신 끊김 · 서버 오류 · 오늘 이후 날짜까지 말없이 삼켜, 손님은 까닭 없이 같은 질문만 되풀이했다. 알림 한 줄로 알린다
        toast(/오늘 이후/.test(e?.message || "") ? "오늘 이후 날짜는 선택할 수 없어요" : "생년월일을 확인하지 못했어요. 잠시 뒤 다시 선택해 주세요");
        def = date; blank = false; saved = birthCalendar;
      }
      finally { layer.classList.remove("on"); }
    }
  } finally { layer.classList.remove("say"); }
}

/* ── 입력: 대본의 asks·ui 를 그대로 따른다 ──
   상대 생일은 「몰라요」 없이 꼭 받는다(사장님 9/26 「몰라요는 빼고 생일 꼭 받게 해」 — 엔진이 상대 생일 없이는 풀지 못해 오류로 막혔다).
   대본 ui 에 「몰라요」가 있어도 띄우지 않는다. 태어난 시각의 「모름」은 그대로 둔다. */
const input = {};
// 9/28 본인 정보 — 사장님 「… 그 계정으로 다시 사주나 타로를 볼 때 생년월일이나 태어난시가 기존에 골랐던 걸로 선택이 되있게끔」 →
// 「궁합은 본인만 저장하고 상대방은 저장하지마 그리고 서버 저장으로 가고 지침 변경해」. 계정에 저장된 본인 값(me.js · deploy/me.js)을 미리 골라 둔다 —
// 생년월일 · 시각 바퀴는 그 값에 맞춰진 채 뜨고(「다음」만 누르면 된다), 성별 · 모름/알아요는 전에 고른 쪽에 밑줄이 그어져 있다(눌러서 고른다).
// 입력이 끝나면 본인 칸만 계정에 남긴다(로그인했을 때만 — 서버가 가린다). 상대(그 사람 · 첫 번째 · 두 번째 사람)와 헤어진 날은 미리 고르지도 남기지도 않는다.
// (토스 로그인으로 받던 성별 · 생년월일 자동 입력은 9/28 사장님 「토스도 단순하게 가자」로 뺐다 — 토스판도 이 길을 쓴다.)
async function loadMe() {
  const p = await Promise.race([window.BGME?.load?.() ?? null, wait(2500).then(() => null)]).catch(() => null);
  const calendar = p?.birthCalendar || (p?.birthDate ? { birthDate: p.birthDate, calendarType: "solar" } : null);
  const d = /^(\d{4})-(\d{2})-(\d{2})$/.exec(calendar?.birthDate || ""), t = /^(\d{2}):(\d{2})$/.exec(p?.birthTime || "");
  return { birth: d ? [+d[1], +d[2], +d[3]] : null, calendar, time: t ? [+t[1], +t[2]] : null, known: d ? !!t : null, sex: p?.sex === "female" ? 0 : p?.sex === "male" ? 1 : -1 };
}
async function runInputs() {
  const meP = loadMe();   // 10/9 — 계정 값을 받는 동안 질문 음성을 막지 않는다(스킵 직후 화면이 그 기다림만큼 늦었다)
  const keys = M.flow.inputs;
  const jumped = SKIP.on && SKIP.where === "voice";   // 오프닝 스킵 — 질문 칸이 아니라 이 질문 말의 시작으로 붙는다
  skipZone(false);   // 질문 음성이 시작되면 스킵은 여기까지(칸이 뜰 때까지 켜 두면 이 말이 통째로 건너뛰어졌다)
  let ME = null, cut = jumped;
  let 내시각물음 = false;   // 10/8 점검 — 본인 태어난 시각을 물었나(묻지 않는 흐름은 계정의 시각을 그대로 둔다 — 아래 save)
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i], L = M.lines[k];
    if (!L) continue;   // 10/8 감시 점검 — 질문 자료에 없는 줄은 건너뛴다(예전에는 L.asks 에서 던져 무비가 첫 입력에서 멈췄다)
    const asks = L.asks || "", ui = L.ui || "", line = L.text;
    const other = /그 사람|첫 번째/.test(asks), third = /두 번째/.test(asks);
    preload(keys[i + 1] ?? M.flow.record?.[0]); await play(k, cut ? { how: "cut", soon: true } : {}); cut = false;   // 10/28 — 마지막 입력 뒤 첫 대사(기록 줄)도 미리 받는다(38번 헤어진 날 「다음」 뒤 1.7초 대기 영상)
    ME ??= await meP;
    globalThis.BGEV?.("input", { q: M.engineId, d: i + 1 });   // 10/22 손님 흐름 단계 — 몇 번째 입력 칸이 보였나(입력값은 보내지 않는다)
    if (asks === "성별") input.sex = ["여성", "남성"][await askPick(line, ["여성", "남성"], ME.sex)];
    // 10/2 점검 — 상대 · 헤어진 날 · 저장 안 된 본인 생일은 아무것도 고르지 않은 채로(blank — 돌리기 전에는 「다음」이 꺼져 있다). 저장된 본인 값(ME)은 그대로 미리 골라 둔다
    else if (/헤어진 날/.test(asks)) { const Y = +todayKst().slice(0, 4); input.breakup = await askDate(line, 2000, Y, ymd([Y, 2, 14]) > todayKst() ? [Y - 1, 2, 14] : [Y, 2, 14], undefined, [input.me, input.second], true); }   // 10/1 — 기본값도 오늘 뒤가 아니게. 10/8 점검 — 해는 기기 시계 대신 풀이 기준일
    else if (/생년월일/.test(asks)) {
      const who = third ? "third" : other ? "second" : "me";
      const birth = await askBirth(other && isTest() ? "그 사람의 생일을 골라 주세요." : line, third ? [1995, 6, 20] : other ? [1994, 11, 2] : ME.birth ?? [1996, 3, 12], who !== "me" || !ME.birth, who === "me" ? ME.calendar : null);
      input[who] = birth.date; input[who + "Birth"] = birth.birthCalendar;
    } else if (/태어난 시/.test(asks)) {
      // 10/2 점검 — 시각이 꼭 있어야 하는 질문인데 대본 ui 에 「모름 없음」이 빠지면(10 · 12 · 25번) 「모름」을 골라 엔진에서 막혔다.
      // 데이터의 requires.birthTime(엔진 질문 정의와 같은 값 — 필수는 본인 시각만)도 본다
      const mine = !third && !other, must = ui.includes("모름 없음") || (mine && M.requires?.birthTime === true), def = third ? [7, 30] : other ? [18, 20] : ME.time ?? [9, 40];
      // 본인 시각에만 「시각 찾기」. 10/28 사장님 「그냥 시각 찾기 없이 가고」 — 시각 찾기 물음 영상(T_…)이 없는 질문(53 · 54 법당도령)은 시각 찾기 없이
      const find = mine && input.me && Object.keys(M.lines).some((x) => x.startsWith("T_"));
      if (find) 시각물음미리받기();
      const blank = !(mine && ME.time);                                    // 10/2 — 저장된 본인 시각이 아니면 고르지 않은 채로
      let t = null, guess = false;
      if (must) {
        // 시각이 꼭 있어야 하는 질문(생시 필수 일곱) — 「모름」이 없다. 바퀴 밑 「시각 찾기」로 찾은 시각으로만 넘어가고, 못 찾으면 바퀴로 돌아온다.
        for (;;) {
          const v = await askTime(line, def, find ? "태어난 시간 찾기" : undefined, blank);
          if (v) { t = v; break; }
          const g = await findTime(); if (g) { t = g; guess = true; break; }
        }
      } else {
        // 10/3 — 본인은 알아요 · 시간 찾기만, 상대는 모름 · 알아요. 시간 찾기에 실패하면 선택으로 돌아온다
        const optionalMine = mine && ["life.self", "life.concern"].includes(M.engineId);
        for (;;) {
          const pick = await askPick(line, find ? (optionalMine ? ["알아요", "몰라요", "태어난 시간 찾기"] : ["알아요", "태어난 시간 찾기"]) : ["몰라요", "알아요"], mine && ME.known != null ? (find ? (ME.known ? 0 : -1) : +ME.known) : -1);
          if (pick === (find ? 0 : 1)) { t = await askTime(line, def, undefined, blank); break; }
          if (!find || (optionalMine && pick === 1)) break;
          const g = await findTime(); if (!g) continue;
          t = g; guess = !!g; break;
        }
      }
      if (mine) { input.meGuess = guess; 내시각물음 = true; }
      if (third) input.thirdTime = t; else if (other) input.secondTime = t; else input.meTime = t;
    }
  }
  // 찾은 시각(추정)은 계정에 「태어난 시각」으로 남기지 않는다 — 다음에 볼 때 아는 시각처럼 미리 골라지면 안 된다
  // 10/8 점검 — 시각을 묻지 않는 흐름(심리 테스트 92 · 93 · 94 · 96)이 계정의 태어난 시각을 null 로 덮었다. 묻지 않았으면 불러온 값(ME.time) 그대로
  ME ??= await meP;
  const 시각 = 내시각물음 ? (input.meTime && !input.meGuess ? input.meTime : null) : ME.time;
  if (input.me && input.sex) window.BGME?.save?.({ birthDate: ymd(input.me), birthCalendar: input.meBirth, birthTime: 시각 ? `${pad(시각[0])}:${pad(시각[1])}` : null, sex: input.sex === "남성" ? "male" : "female" });
}

/* ── 태어난 시각 찾기(9/30 사장님 「내 시각을 적을 때 버튼을 추가하고 모르는 사람들은 이걸 진행하는거지 여기에는 음성은 없어」) ──
   인물 음성 없이 글로 묻는다(대기 영상은 그대로 돈다). 물음과 계산은 엔진 /time-guess(사주엔진 src/time-guess.js) —
   옛 생시 추정법(잠버릇 · 얼굴형 · 가마) · 가장 좋았던 해와 힘들었던 해 · 성격 둘로 열두 시각 후보 가운데 가장 잘 맞는 것을 고른다(추정).
   둘이 비슷하면 둘을 보이고 고르게 한다. 찾지 못하면(엔진 오류 · 후보 없음) false — 부르는 쪽이 고르기로 돌아간다.
   10/1 사장님 「태어난 시각을 거의 모든 사주가 묻잖아? … 그걸 전체적으로 다 적용해」 — 로컬에서만 보이던 조건(TIME_FIND)을 빼고 모든 질문의 본인 시각 칸에 둔다. */
// 10/2 점검 — 후보는 엔진 칸 경계 그대로(「오전 5시 29분 ~ 7시 28분」) 보였다. 옛 시각 이름과 반 시간 단위 어림으로 — 「묘시 · 오전 5시 반~7시 반 무렵」.
// 엔진 답의 branch(시지) · from · to(칸 끝) 로 만든다. 없으면 엔진 label 그대로
function 때말(m) {
  m = ((Math.round(m / 30) * 30) % 1440 + 1440) % 1440;
  const h = Math.floor(m / 60);
  return { 낮밤: h === 0 ? "밤" : h < 12 ? "오전" : h === 12 ? "낮" : h < 21 ? "오후" : "밤", 말: `${h % 12 || 12}시${m % 60 ? " 반" : ""}` };
}
function 시각말(p) {
  const 분 = (t) => (/^\d{2}:\d{2}$/.test(t || "") ? +t.slice(0, 2) * 60 + +t.slice(3) : null), a0 = 분(p?.from), b0 = 분(p?.to);
  if (window.BGLANG?.locale && window.BGLANG.locale!=='ko' && a0!=null && b0!=null) {
    const fmt=new Intl.DateTimeFormat(window.BGLANG.locale,{hour:'numeric',minute:'2-digit',timeZone:'UTC'});
    const time=minutes=>fmt.format(new Date(Date.UTC(2000,0,1,0,Math.round(minutes/30)*30)));
    // 10/7 번체 중국어 — 시진 이름을 앞에(「卯時・約上午5:30至上午7:30」, 용어집 4-5)
    if(/^zh-/.test(window.BGLANG.locale))return `${p?.branch?`${window.BGLANG.branch?.(p.branch) ?? p.branch}時・`:''}約${time(a0)}至${time(b0)}`;
    return window.BGLANG.locale==='ja'?`${time(a0)}〜${time(b0)}ごろ`:`About ${time(a0)}–${time(b0)}`;
  }
  if (!p?.branch || a0 == null || b0 == null) return p?.label || "";
  const a = 때말(a0), b = 때말(b0);
  return `${p.branch}시 · ${a.낮밤} ${a.말}~${a.낮밤 === b.낮밤 ? "" : b.낮밤 + " "}${b.말} 무렵`;
}
async function findTime() {
  $("ask").classList.add("say");
  try { return await findTimeAsk(); } finally { $("ask").classList.remove("say"); }
}
const 찾기질문 = () => (Object.prototype.hasOwnProperty.call(M, "timeFinderQuestionId") ? M.timeFinderQuestionId : M.engineId);   // 10/8 점검 — Object.hasOwn 은 아이폰 iOS 15.3 이하 · 크롬 93 미만에 없다
// 10/28 — 「태어난 시간 찾기」를 누르면 엔진에서 물음을 받아 오는 1.5~3초 동안 대기 영상만 돌았다(38번 실측). 시각 칸이 뜰 때 물음을 미리 받고 첫 물음 영상도 받아 둔다
let 미리물음 = null;
function 시각물음미리받기() {
  const birthDate = ymd(input.me), questionId = 찾기질문(), key = `${birthDate}|${questionId}`;
  if (미리물음?.key === key) return;
  const p = askEngine("time-guess", { birthDate, questionId, referenceDate: todayKst() });
  p.then((r) => { const q = r?.questions?.[0]; if (q && M.lines[`T_${q.id}`]) preload(`T_${q.id}`); }, () => {});
  미리물음 = { key, p };
}
async function findTimeAsk() {
  const birthDate = ymd(input.me);
  const questionId = 찾기질문();
  const 묻기 = () => askEngine("time-guess", { birthDate, questionId, referenceDate: todayKst() });
  let qs = null;
  try { qs = (await (미리물음?.key === `${birthDate}|${questionId}` ? 미리물음.p.catch(묻기) : 묻기())).questions; } catch { toast("지금은 태어난 시간을 찾을 수 없어요"); return false; }   // 10/1 밤 질문마다 다른 일곱(엔진 time-guess.js)
  const answers = {};
  // 10/1 밤 사장님 「그렇게해」 — 인물이 직접 묻는다: 질문마다 그 대기 영상 위에 립싱크한 물음 줄(데이터 lines 의 T_{물음 id}, tools/time_finder_site_1001.py).
  // 글씨도 인물이 하는 말 그대로(「화가 나면 보통 어떻게 해요?」). 줄이 아직 없는 질문은 예전처럼 음성 없이 글로만 묻는다.
  const line = (q) => (q && M.lines[`T_${q.id}`] ? `T_${q.id}` : null);
  if (line(qs?.[0])) preload(line(qs[0]));
  for (let n = 0; n < (qs || []).length; n++) {
    const q = qs[n], k = line(q), text = k ? M.lines[k].text : q.q;
    if (k) { $("ask").classList.remove("say"); if (line(qs[n + 1])) preload(line(qs[n + 1])); await play(k); }
    else $("ask").classList.add("say");
    // 10/2 점검 — 해 물음은 올해에 맞춰진 채 떴다. 고르지 않은 채로 띄우고 「잘 모르겠어요」를 「다음」과 같은 크기로
    // 10/28 사장님 「내 시각 찾기에 모르겠어요가 왜 있는 거야 애초에 항목에서 지워버리고」 — 해 바퀴의 「잘 모르겠어요」를 뺐다(보기의 모름은 엔진 time-guess.js 에서 뺌)
    if (q.years) { const v = await askWheel(text, [colOf(range(q.years[0], q.years[1]), (y) => y + "년", Math.max(q.years[0], q.years[1] - 1))], undefined, undefined, { blank: true, wide: true }); answers[q.id] = v ? v[0] : null; }
    else if (Array.isArray(q.opts) && q.opts.length) { const i = await askPick(text, q.opts.map((o) => o[0])); answers[q.id] = q.opts[i]?.[1] ?? null; }   // 10/8 — 고를 것이 없는 물음은 건너뛴다(예전에는 던져 시간 찾기에서 멈췄다)
  }
  $("ask").classList.add("say");
  let r = null;
  try { r = await askEngine("time-guess", { birthDate, answers, questionId, referenceDate: todayKst() }); } catch { toast("지금은 태어난 시간을 찾을 수 없어요"); return false; }
  if (!r?.picks?.length) return false;
  const i = await askPick("가능성이 높은 시간이에요", r.picks.map(시각말));   // 10/1 사장님 문구(하나든 둘이든 같은 말)
  const hm = /^(\d{1,2}):(\d{2})$/.exec(r.picks[i]?.time || "");   // 10/8 — 시각이 없는 후보면 찾지 못한 것으로(부르는 쪽이 고르기로 돌아간다)
  return hm ? [+hm[1], +hm[2]] : false;
}

/* ── 엔진(로컬 개발 서버가 사주엔진 워커를 바로 부른다 — vite.config.js localEngine) ── */
function person(date, time, sex) { const p = { birthDate: ymd(date), sexForLuck: sex }; if (time) p.birthTime = `${pad(time[0])}:${pad(time[1])}`; else p.timeUnknown = true; return p; }
// 9/30 이별 새 질문 셋(37 · 38 · 39) — 무비에서 고른 답(C04 · C05 · C07 · C08 → 반응 영상 열쇠)이 무료 갈래를 가른다(엔진 free-axes.js 고름).
// 엔진은 질문이 받지 않는 선택 답이 오면 막으므로 이 셋에만 싣는다.
const PICK_Q = new Set(["breakup.letgo", "breakup.forgetwhen", "breakup.ifstayed", "life.self", "life.concern"]);
// 10/1 밤 심리 테스트(데이터 engineId 「test.…」 — deploy/testmat.js) — 결제 · 잠그기 · 글쓰기 · 보관함은 사주와 같은 길, 요청만 테스트 꼴
const isTest = () => /^test\./.test(M?.engineId || "");
function engineReq() {
  // 10/8 감시 점검 — 생년월일이 비면 ymd 가 「reading '0'」으로 던졌다(새벽 3:49 화면 오류). 무슨 일인지 알 수 있는 말로 던진다 — 부르는 쪽(결과 열기)은 이 말을 보이거나 그 칸만 건너뛴다
  if (!Array.isArray(input.me)) throw new Error("생년월일 정보가 없어요. 처음부터 다시 봐 주세요");
  const me = input.sex === "남성" ? "male" : "female", other = me === "female" ? "male" : "female";
  if (isTest()) {   // 생년월일 · 성별 · 고른 답(1 · 2 · 3)만 — 시각은 쓰지 않는다(기획/116 세 기둥)
    const r = { questionId: M.engineId, first: { birthDate: ymd(input.me), sexForLuck: me }, answers: input.answers || [] };
    if (input.second) r.second = { birthDate: ymd(input.second), sexForLuck: other };
    if (REF) r.referenceDate = REF;
    return r;
  }
  const r = { questionId: M.engineId, first: person(input.me, input.meTime, me), choices: {} };
  if (input.second) r.second = person(input.second, input.secondTime, other);
  if (input.third) r.third = person(input.third, input.thirdTime, other);
  if (input.breakup) r.breakupDate = ymd(input.breakup);
  if (input.lastContact) r.choices = { lastContact: input.lastContact };
  if (PICK_Q.has(M.engineId) && input.picks) r.choices = { ...input.picks };
  if (M.engineId === "life.concern") {
    const concern = String(input.concern || "").trim().normalize("NFC");
    if (concern.length < 3 || concern.length > 500) throw new Error("고민은 3자부터 500자까지 적어 주세요");
    r.concern = concern;
  }
  if (REF) r.referenceDate = REF;   // 10/1 코드 점검 — 이 풀이의 기준일(풀이를 시작할 때 정한 한 값)
  return r;
}
// 10/1 코드 점검 — 답이 끝내 안 오면(엔진 · 통신이 멈춤) 30초 뒤 오류로 끝낸다(전엔 무료 · 유료 재료를 영영 기다려 화면이 멈췄다). 통신 오류도 한국어로 알린다.
const ENGINE_MS = 30000;
function askEngine(path, req, ms = ENGINE_MS) {
  const ac = typeof AbortController === "function" ? new AbortController() : null, tm = ac && setTimeout(() => ac.abort(), ms);
  // 9/28 결제 — 결제한 주문번호(영수증)를 싣는다(payment.js · deploy/pay.js). 결제를 켜기 전에는 빈 머리다.
  return fetch("/api/engine/" + path, { method: "POST", headers: { "Content-Type": "application/json", ...(window.BGPAY?.head() || {}) }, body: JSON.stringify(req), signal: ac?.signal }).then(async (r) => {
    const j = await r.json().catch(() => null);
    // 10/8 — 서버 상태 번호(「오류 503」)와 합쇼체 대신 무슨 일 · 어떻게 하면 되는지(3-화면글-점검 1 · 2)
    if (!r.ok || !j) throw new Error(j?.error || "풀이를 불러오지 못했어요. 잠시 뒤에 다시 눌러 주세요"); return j;
  }, () => { throw new Error(ac?.signal.aborted ? "응답이 늦어지고 있어요. 잠시 뒤에 다시 시도해 주세요" : "인터넷 연결이 끊겼어요. 연결을 확인하고 다시 눌러 주세요"); }).finally(() => clearTimeout(tm));   // 10/8 점검 — 30초 시간 초과는 끊김이 아니다
}

/* ── 풀이 글(9/27) ──
   /api/write 가 엔진 재료로 풀이 글을 쓴다(로컬 = vite.config.js localWriter, bamgwabi.com = deploy/worker.js → 사장님 맥의 tools/writer_runner.mjs).
   답은 줄마다 JSON 하나 — 장마다 끝나는 대로 온다. 글이 안 오면(맥이 안 붙음 · 실패) 화면은 엔진 문장 그대로 보인다. */
// live · all · pend — 도는 글쓰기 수 · 그중 산 장 전부를 쓰는 수 · 장마다 쓰는 수(10/1 코드 점검 — 몇 장만 다시 쓸 수 있게 장마다 센다)
const WR = { free: null, freeState: "idle", freeRun: 0, ch: {}, partial: {}, conclusion: null, live: 0, all: 0, pend: {}, tries: 0, retryT: 0, acs: new Set() };   // acs — 지금 받는 연결들(앱으로 돌아오면 걷고 다시 붙는다)
async function writeStream(kind, onPart, parts, req = engineReq()) {   // parts — 그 장 번호만(다시 시도 · 빠진 장 — 이미 읽은 장은 다시 쓰지 않는다)
  if (window.BGENTRY) await window.BGENTRY.bind(req);
  const ac = new AbortController(), tm = setTimeout(() => ac.abort(), 320000); WR.acs.add(ac);   // 10/20 서버 결제 작업의 끝 줄(300초 — saving)보다 뒤에 끊는다(먼저 끊으면 그 줄을 놓쳐 실패로 그렸다)
  return fetch("/api/write", { method: "POST", headers: { "Content-Type": "application/json", ...(window.BGPAY?.head() || {}) }, body: JSON.stringify({ kind, req, ...(window.BGENTRY ? { includeBasic: true } : {}), ...(kind === "paid" ? { cardsStream: true } : {}), ...(parts ? { parts } : {}) }), signal: ac.signal }).then(async (r) => {
    if (!r.ok || !r.body) { const e = new Error("글쓰기 " + r.status); e.status = r.status; throw e; }
    const rd = r.body.getReader(), dec = new TextDecoder(); let buf = "";
    for (;;) {
      const { value, done } = await rd.read(); if (done) break;
      buf += dec.decode(value, { stream: true });
      // 10/8 점검 — 읽지 못한 줄만 넘긴다. 그리는 쪽 오류까지 삼켜 글이 안 보여도 몰랐다 — 감시로 알린다
      for (let k; (k = buf.indexOf("\n")) >= 0; ) {
        const ln = buf.slice(0, k).trim(); buf = buf.slice(k + 1); if (!ln) continue;
        let m; try { m = JSON.parse(ln); } catch { continue; }
        try { onPart(m); } catch (e) { window.BGWATCH?.report("풀이 그리기 실패", `${M?.no ?? ""}번 질문 · ${kind} · ${e?.message || e}`); }
      }
    }
  }).finally(() => { clearTimeout(tm); WR.acs.delete(ac); });
}
// 10/1 밤 사장님 「무료 결과 품질이 왜 이래?」 — 맥이 바빠 글을 못 받으면 결과 칸에 글 없이 제목 · 표만 남았다.
// 못 받으면 한 번 더 쓰고(그동안 로딩은 그대로), 그래도 못 받으면 유료 장처럼 「풀이 글을 가져오지 못했어요 · 다시 시도」를 보인다.
const 영구실패 = (status) => status >= 400 && status < 500 && status !== 408 && status !== 429;
const 다시간격 = (n) => Math.min(60000, [5000, 10000, 30000, 60000][Math.min(n, 3)]);
function startFreeWrite(req = engineReq()) {
  if (window.BGENTRY) { WR.freeState = 'wait'; if (!WR.all) startPaidWrite(); return; }   // 결제 뒤 바로 온 손님 — 1번 항목 글은 유료 글쓰기가 같이 쓴다
  clearTimeout(WR.freeRetryT);
  const my = ++WR.freeRun; WR.freeState = "wait";
  let failed = false;
  // 탭이 열려 있는 동안 늦춰 다시 쓴다. 4xx(408·429 제외)만 멈춘다. 「다시 시도」는 그대로 둔다.
  const fail = (e) => {
    if (my !== WR.freeRun || failed) return;
    failed = true; WR.freeState = "fail"; paintFree();
    if (영구실패(e?.status)) { window.BGWATCH?.report("무료 풀이 글 실패", `${M?.no ?? ""}번 질문`); return; }
    const n = WR.freeTries = (WR.freeTries || 0) + 1;
    if (n === 3) window.BGWATCH?.report("무료 풀이 글 실패", `${M?.no ?? ""}번 질문`);
    WR.freeRetryT = setTimeout(() => { if (my === WR.freeRun) startFreeWrite(req); }, 다시간격(n - 1));
  };
  writeStream("free", (m) => { if (my !== WR.freeRun || m.part !== "free") return; if (m.out) { WR.free = m.out; WR.freeTries = 0; WR.freeState = "ok"; paintFree(); } else fail(); }, undefined, req)
    .catch((e) => fail(e)).finally(() => { if (my === WR.freeRun && WR.freeState === "wait") fail(); });
}
document.addEventListener("click", (e) => { if (e.target.closest?.("[data-freerew]")) { startFreeWrite(); paintFree(); } });   // 무료 글 「다시 시도」
function wrFreeHtml() {
  if (WR.freeState === "ok" && WR.free) return `<p class="alead">${esc(tidy(WR.free.answer))}</p>${WR.free.cards.map((t) => `<p class="ac">${esc(tidy(t))}</p>`).join("")}`;
  // 9/27 밤 「풀이 중 로딩을 넣자」 — 도는 고리와 글(유료 장의 로딩과 같은 모양)
  if (WR.freeState === "fail") return '<article class="card wfail"><p>풀이 글을 가져오지 못했어요.</p><button type="button" class="rew" data-freerew>다시 시도</button></article>';   // 유료 장과 같은 칸 · 같은 말
  return WR.freeState === "wait" ? '<div class="wload" role="status"><i class="lw-mini" aria-hidden="true"></i><span>풀이를 준비하고 있어요</span></div>' : "";   // 10/8 고리 대신 작은 로고 기다림(logo-wait.js)
}
function paintFree() { const el = document.getElementById("wrFree"); if (el) { el.innerHTML = wrFreeHtml(); } 결과지갱신(); 기다림풀기(); }   // 10/28 — 결제 뒤 결과지 층도 다시 그린다
// 10/9 사장님 「첫 장 미리 쓰기를 결제 화면 열 때로」 — 무료를 쓸 때 함께 쓰던 유료 첫 장을 결제 화면이 열릴 때 쓴다(coin.js buy).
//   같은 풀이는 한 번만 보낸다. 서버도 이미 쓴 · 쓰는 중인 첫 장은 다시 쓰지 않는다(deploy/writer-hub.js first)
let prewrote = "";
window.BGPREWRITE = () => {
  let req; try { req = engineReq(); } catch { return; }
  const k = JSON.stringify(req); if (k === prewrote) return; prewrote = k;
  fetch("/api/write", { method: "POST", headers: { "Content-Type": "application/json", ...(window.BGPAY?.head() || {}) }, body: JSON.stringify({ kind: "first", req }), keepalive: true })
    .then((r) => r.body?.cancel()).catch(() => { prewrote = ""; });
};
function startPaidWrite(parts) {   // parts — 그 장들만(없으면 산 장 전부)
  const ps = parts ? [...new Set(parts)] : null;
  if (!WR.live) WR.t0 = performance.now();                // 10/2 — 로딩 막대가 기다린 시간으로 찬다(몫때)
  WR.writeStatus = 0;
  WR.live++; clearTimeout(WR.retryT);                     // 빠진 장을 쓰거나 다시 쓰면 글쓰기가 겹칠 수 있다 — 장마다 다 끝나야 「끝」
  if (ps) ps.forEach((p) => { WR.pend[p] = (WR.pend[p] || 0) + 1; }); else WR.all++;   // 10/8 점검 — 「다시 시도」를 눌러도 보이던 앞부분 글(partial)은 지우지 않는다
  refresh();
  let 저장중 = false;
  // 10/20 — 글 없이 온 장 줄(error)은 실패가 아니다. 서버 작업(deploy/paidjobs.js)은 그 장 줄에 saving 표시를 싣고 그 장을 다시 써서 이 흐름으로 보내며,
  //   서버 작업이 없는 손님 흐름은 흐름이 끝난 뒤 rewriteLater 가 그 장을 다시 쓴다. 그래서 그 줄로 「못 받았어요 · 다시 시도」를 그리지 않고 쓰는 중으로 둔다 —
  //   10/28 — 결과지 층은 글이 올 때까지 늘 「쓰는 중」(06-paid 상태). 전엔 그 줄을 장 실패(chErr)로 쳐서 서버가 곧 다시 쓰는 장을 실패로 그렸다
  writeStream("paid", (m) => {
    // 10/20 서버 결제 작업이 300초에 화면 연결만 끝낼 때(saving — 서버는 계속 써서 보관함에 남긴다) — 실패가 아니라 이어 받는다(아래 finally)
    if (m.done && m.saving) { 저장중 = true; if (!WR.저장알림) { WR.저장알림 = 1; toast("남은 풀이는 완성되면 보관함에서 볼 수 있어요"); } return; }
    if (m.part === 'free') {
      if (m.out) { WR.free = m.out; WR.freeState = 'ok'; paintFree(); }
      return;
    }
    if (m.part === "conclusion") {
      if (!m.out?.answer) return;
      WR.conclusion = m.out;
      if (MAT) saveVault();
      결과지갱신(); 기다림풀기(); return;
    }
    if (typeof m.part !== "number") return;
    if (m.out?.partial) {
      if (!WR.ch[m.part]) { WR.partial[m.part] = m.out; 결과지갱신(); 기다림풀기(); }
      return;
    }
    if (!m.out) return;
    WR.ch[m.part] = m.out; delete WR.partial[m.part];
    WR.tLast = performance.now();
    chapterText();
  }, ps).catch((e) => { WR.writeStatus = e?.status || 0; }).finally(() => {
    WR.live--; if (ps) ps.forEach((p) => { WR.pend[p]--; }); else WR.all--;
    // 10/20 saving 으로 끝났으면 바로 다시 붙어 남은 글을 이어 받는다 — 실패로 그리지 않고(그동안 장은 「쓰는 중」), 다시 쓰기 횟수에도 세지 않는다
    const 남은장 = 저장중 && !WR.live ? needParts() : [];
    if (저장중 && !WR.live && (남은장 === null || 남은장.length || !WR.conclusion || (window.BGENTRY && !WR.free))) startPaidWrite(남은장?.length ? 남은장 : undefined);
    if (window.BGENTRY && !WR.live && !WR.free) { WR.freeState = 'fail'; paintFree(); }
    refresh();
    if (!WR.live) rewriteLater();                         // 10/8 점검 — 흐름이 끊겨 못 받은 장은 조금 뒤 다시 쓴다(사장님 「모든 문제점 싹 다 잡아」)
  });
}
const writing = (idx) => !WR.ch[idx] && (WR.all > 0 || WR.pend[idx] > 0);   // 그 장의 글을 쓰는 중인가
// 10/14 코드 리뷰 — 더 기다려도 글이 오지 않는다: 쓰는 중이 아니고, 세 번 다시 썼거나 영구 실패(4xx — rewriteLater 가 다시 쓰지 않는다)
const 쓰기멈춤 = () => !WR.live && (WR.tries >= 3 || 영구실패(WR.writeStatus));
// 10/28 사장님 「결제 확인이 끝내 거절되는 경우? 다시시도로 바꿔」 — 서버가 글쓰기를 거절했다(4xx — 다시 받아도 같다). 결과지는 그 쪽에 「다시 시도」를 보인다(06-paid 상태)
const 거절됨 = () => !WR.live && 영구실패(WR.writeStatus);
const readable = (idx) => !!(WR.ch[idx] || (WR.partial[idx]?.answer && WR.partial[idx]?.cards?.length));
/* 10/1 사장님 「화면이 블러 처리되고 결과지는 올라오면 안되고 로고를 사용해서 뭔가 로딩을 만들어야지」 · 「로딩이 끝나면 그 시점에 맞춰서 결과지가 올라와야지」
   글이 아직이면 결과지(유료 장 · 무료 결과)를 올리지 않고, 화면을 흐리게 한 채 가운데 움직이는 로고(drawMark)로 기다린다.
   글이 오거나 · 못 받거나 · 5분이 지나면 그 순간 로딩이 걷히고 결과가 올라온다(못 받은 장은 그 칸의 「다시 시도」). 10/1 밤 허브 기한 5분에 맞춰 2분 30초 → 5분. */
const 기다림 = new Set();
function 글기다리기(된다, ms = 300000) {
  if (된다()) return 로딩끝();
  return new Promise((ok) => { const w = { 된다, ok }; 기다림.add(w); setTimeout(() => { if (기다림.delete(w)) ok(); }, ms); }).then(로딩끝);
}
/* 10/8 사장님 「물의 양이 게이지 역할을 하는건데 왜 꽉 안 찼는데 시작이 되는거야?」 — 로딩이 떠 있었으면 물을 끝까지 채우고 → 달이 내려와 로고가 되고 → 「톡」 한 뒤에 풀린다.
   그 전에는 결과 · 영상 · 다음 화면이 시작되지 않는다(글기다리기 · 결과기다리기가 이것을 기다린다). 로딩이 안 떴으면 바로 */
let 끝내는중 = false;
async function 로딩끝() {
  if (!로딩갈래 || !$("wloader")?.classList.contains("on")) return;
  로딩갱신(true); 끝내는중 = true;
  try { await window.BGWAIT?.done($("markL")); } finally { 끝내는중 = false; }
}
function 기다림풀기() { 로딩갱신(); for (const w of [...기다림]) if (w.된다()) { 기다림.delete(w); w.ok(); } }
/* 10/1 사장님 「10초에 한번씩 바뀌는게 아니라 단계마다 변하게 하자 그래야 진행도를 알지」 — 로딩 문구와 막대는 실제로 지난 단계만 보인다:
   유료 재료(계산)가 오기 전 「사주를 계산하고 있어요」 → 계산이 끝나고 글을 쓰는 동안 「풀이 글을 쓰고 있어요」 → 장이 하나씩 끝날 때마다 「6개 항목 중 2개 완료」와 막대.
   무료는 계산이 끝난 뒤에 열리므로 「풀이 글을 쓰고 있어요」 한 단계. 글이 다 오면 「풀이를 펼칠게요」를 잠깐 보이고 걷힌다. */
let 로딩갈래 = null;   // "paid" | "free"
/* 10/2 점검 — 막대가 끝난 장 수만 세어 첫 장이 올 때까지(30~60초) 6%에 멈춰 있었다. 기다린 시간으로 채운다 —
   다음 장 몫을 40초쯤에 거의 채우고(점점 느리게 — 그 장이 와야 끝까지) 장이 끝날 때마다 그 자리로 맞춘다. 다 오기 전에는 100%가 되지 않는다(로딩 동안 0.7초마다 다시 잰다). */
const 장기다림 = 18000;   // 다음 장 몫을 1 - e^(-t/τ) 로 — 40초에 약 89%
function 몫때(끝, 모두) {
  if (!모두) return 0;
  const t0 = Math.max(WR.t0 || 0, WR.tLast || 0), dt = t0 ? performance.now() - t0 : 0;
  return Math.min(0.99, (끝 + 0.95 * (1 - Math.exp(-dt / 장기다림))) / 모두);
}
function 로딩말() {
  if (로딩갈래 === "free") return { 말: "풀이 글을 쓰고 있어요", 몫: 0.5 };   // 10/1 밤 사장님 「유료결과 로딩창과 무료결과 로딩창이 다른거야?」 — 무료도 같은 막대(계산 끝 · 글 쓰는 중 = 절반, 글이 오면 끝까지)
  if (!MAT) return { 말: "사주를 계산하고 있어요", 몫: 몫때(0, (M.paid?.chapters || []).length || 6) };
  const 장들 = CH.length ? CH : buildCH(MAT), 끝 = 장들.filter((c) => WR.ch[c.idx]).length;
  // 10/2 점검 — 세는 말은 다른 화면(유료 6개 항목 · 볼 수 없는 항목)과 같이 「항목」(전엔 「6장 중 2장 끝」)
  return { 말: 끝 ? `풀이 글을 쓰고 있어요 · ${장들.length}개 항목 중 ${끝}개 완료` : "풀이 글을 쓰고 있어요", 몫: !장들.length ? 0 : 끝 >= 장들.length ? 1 : 몫때(끝, 장들.length) };
}
function 로딩갱신(마지막) {
  const L = $("wloader"); if (!L || !L.classList.contains("on") || !로딩갈래 || (끝내는중 && !마지막)) return;   // 10/8 — 마무리(가득 채우기 · 로고)부터 걷기까지는 「풀이를 펼칠게요」 그대로
  const P = L.querySelector("p"), m = 마지막 ? { 말: "풀이를 펼칠게요", 몫: 1 } : 로딩말();
  if (P.textContent !== m.말) { P.classList.add("swap"); setTimeout(() => { P.textContent = m.말; P.classList.remove("swap"); }, 250); }
  // 10/8 로고 기다림(logo-wait.js) — 진행은 그릇에 차오르는 물 높이로만(사장님 「그냥 밑에 게이지는 빼」). 유료는 실제 몫, 무료는 기다린 시간으로. 글이 다 오면 가득 채우고 달이 내려와 로고가 된다
  if (마지막) window.BGWAIT?.done($("markL")); else if (로딩갈래 === "paid") window.BGWAIT?.set($("markL"), m.몫);
}
function 로딩(on, 갈래 = "paid", 즉시 = false) {
  const L = $("wloader"); if (!L) return;
  // 10/1 밤 코드 리뷰 — 로딩 창은 흐려져 숨을 뿐이라(display 그대로) 로고가 숨은 뒤에도 매 장면 그려졌다(아이폰 GPU · 배터리). 걷힌 뒤 멈추고, 다시 뜨면 이어 돌린다
  clearInterval(로딩.t);
  const mk = $("markL"), W = window.BGWAIT;
  if (!on) {   // 10/8 — 마무리 움직임(로고가 되고 「톡」)이 끝난 뒤에 걷는다. 그사이 다시 뜨면 걷지 않는다
    로딩갈래 = null;
    (W ? W.finished(mk) : Promise.resolve()).then(() => { if (로딩갈래) return; L.classList.remove("on"); setTimeout(() => { if (!L.classList.contains("on")) W?.stop(mk); }, 500); });
    return;
  }
  if (갈래 === "paid") 로딩.t = setInterval(() => 로딩갱신(), 700);   // 10/2 — 기다린 시간만큼 물이 찬다(몫때)
  로딩갈래 = 갈래; const m = 로딩말(), P = L.querySelector("p");
  P.textContent = m.말; P.classList.remove("swap");
  // 10/28 사장님 「결과지로 넘어갈때 순간적으로 캐릭터 얼굴이 왜 보이는거고?」 — 덮개가 서서히(.45초) 뜨는 사이 흐림 없는 인물 영상이 비쳤다. 결제 뒤 첫 로딩은 바로 덮는다(06-paid paidSetup)
  if (즉시) { L.style.transition = "none"; L.classList.add("on"); void L.offsetWidth; L.style.transition = ""; } else L.classList.add("on");
  W?.go(mk); if (갈래 === "paid") W?.set(mk, m.몫);
  if (WR.all || WR.live) 메일칸();   // 10/14 — 결제 뒤 풀이를 쓰는 동안의 로딩(무료 결과 기다림 포함)에는 비회원 이메일 칸
}
async function 결과기다리기(promise, 갈래 = "free") {
  const timer = setTimeout(() => 로딩(true, 갈래), 150);
  try { return await promise; } finally { clearTimeout(timer); await 로딩끝(); 로딩(false); }   // 10/8 — 떠 있었으면 물을 끝까지 채우고 로고가 된 뒤에 걷는다
}
// 10/1 코드 점검 — 풀이 글을 못 받은 장(글 쓰는 맥이 안 붙음 · 시간 초과 · 그 장만 실패)은 이 탭이 열려 있는 동안 조금씩 늦춰 세 번까지 다시 쓴다(유료 글쓰기가 끝날 때 — startPaidWrite).
// 10/28 사장님 「로딩창이 뜨게 한다고 했잖아」 — 결과지에 「다시 시도」는 없다. 그동안 그 쪽은 「풀이를 쓰고 있어요」(06-paid 상태).
const REWRITE = [10000, 30000, 90000];
function needParts() {   // 글이 없는 산 장(풀 수 없는 장 빼고). 재료가 아직 없으면 null — 그때는 전부 다시 쓴다
  const src = CH.length ? CH : MAT ? buildCH(MAT) : null;
  return src && src.filter((c) => !WR.ch[c.idx]).map((c) => c.idx);
}
// 장 말고 빠진 글 — 최종 결론 · 결제 뒤 바로 온 손님(BGENTRY)의 1번 항목 글(같은 결제 작업이 쓴다 — 다시 붙으면 써 둔 것을 다시 보낸다)
const 끝빔 = () => !WR.conclusion || (window.BGENTRY && !WR.free);
// 10/8 점검 — 10/3~10/6 라이브 고침에서 부르는 줄이 빠져 아무도 부르지 않던 것을 되살렸다(startPaidWrite 끝)
function rewriteLater() {
  clearTimeout(WR.retryT);
  const need = needParts();
  // 10/28 코드 리뷰 — 결과지에 실패 칸이 없어져(늘 「쓰는 중」) 최종 결론만 빠져도 알린다(전엔 빠진 장이 있을 때만 — 결론만 못 받은 손님은 알림 없이 계속 로딩)
  const 빠짐 = need?.length || (need && 끝빔());
  const 알리기 = () => { WR.알림 = 1; window.BGWATCH?.report("유료 풀이 글 실패", `${M?.no ?? ""}번 질문 · 못 받은 장 ${need.length}개${끝빔() ? " · 최종 결론/1번 항목 빠짐" : ""}`); };
  if (영구실패(WR.writeStatus)) {
    if (!WR.live && 빠짐 && !WR.알림) 알리기();
    return;
  }
  if (!WR.live && WR.tries >= 3 && 빠짐 && !WR.알림) 알리기();   // 세 번 넘겨도 탭이 열려 있으면 60초 간격으로 계속
  if (WR.live || (need && !need.length && !끝빔())) return;
  const wait = Math.min(60000, REWRITE[Math.min(WR.tries, REWRITE.length - 1)]);
  WR.retryT = setTimeout(() => { WR.tries++; if (!WR.live) { const n = needParts(); if (!n || n.length) startPaidWrite(n || undefined); else if (끝빔()) startPaidWrite([]); } }, wait);
}
// 10/8 점검 — 예전에는 글쓰기가 하나라도 돌면(WR.live — 이어 보기의 결론만 쓰기 포함) 건너뛰어, 쓰는 도중 새로 고친 비회원의 남은 장이 영영 안 써졌다.
//   산 장 전부를 쓰는 중(WR.all)일 때만 건너뛰고, 그 밖에는 지금 쓰고 있지 않은 빠진 장만 쓴다
function fillMissing() { if (WR.all) return; const n = needParts()?.filter((i) => !(WR.pend[i] > 0)); if (n?.length) startPaidWrite(n); }   // 재료가 오면 — 빠진 장이 있으면 그 장만 쓴다(이어 보기 · 앞 글쓰기 실패)
// 10/28 사장님 「백그라운드로 계속 유지가 되고 있으면 안 되는 거야?」 — 풀이는 서버 결제 작업이 앱과 상관없이 끝까지 쓴다(deploy/paidjobs.js).
//   앱을 나가면 폰이 이 화면을 얼리고 받는 연결을 끊거나 멈춰 둘 수 있다. 10초 넘게 나갔다 돌아오면 빠진 글이 있을 때 그 연결을 걷고 바로 다시 붙는다(서버가 써 둔 글을 다시 보낸다 — writer-hub /paid/join)
let 나간때 = 0;
document.addEventListener("visibilitychange", () => {
  if (document.hidden) { 나간때 = Date.now(); return; }
  const 오래 = 나간때 && Date.now() - 나간때 >= 10000; 나간때 = 0;
  const need = 오래 ? needParts() : null;   // 재료가 없으면(결제 전) 할 일이 없다
  if (!need || (!need.length && !끝빔())) return;
  WR.acs.forEach((ac) => ac.abort()); clearTimeout(WR.retryT);
  startPaidWrite(need.length ? need : []);
});
// 글쓰기가 시작 · 끝날 때 — 글이 없는 쪽만 「쓰는 중」이 바뀐다(결과지 층은 글이 바뀐 쪽만 다시 그린다 — sheet.js update)
const refresh = () => { 결과지갱신(); 기다림풀기(); };
function chapterText() {                                      // 장의 글이 오면 보관함에 남기고 결과지 층의 그 쪽을 바꿔 끼운다
  if (MAT) saveVault();
  결과지갱신(); 기다림풀기();
}

/* ── 무료 갈래와 결제(캔버스 v1 「갈래와 결제」) ── */
const LOCK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8f8794" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"></rect><path d="M8 11V8a4 4 0 0 1 8 0v3"></path></svg>';
function pillars(p) {
  return `<div class="pp">${(p.사주표 || []).map((c) => `<div><small>${esc(String(c.자리 || "").replace("태어난 ", ""))}</small>${c.위 && c.아래 ? `<span class="g">${esc(window.BGLANG?.stem(c.위.글자) ?? c.위.글자)}<br>${esc(window.BGLANG?.branch(c.아래.글자) ?? c.아래.글자)}</span><span class="e">${esc(c.위.기운)} · ${esc(c.아래.기운)}</span>` : `<span class="g split">갈림</span><span class="e">${esc((c.갈림 || []).map((x) => (window.BGLANG?.stem(x.위.글자) ?? x.위.글자) + (window.BGLANG?.branch(x.아래.글자) ?? x.아래.글자)).join(" / "))}</span>`}</div>`).join("")}</div>`;
}
// 10/27 점검 — 빠진 항목 목록을 통째로 옮기면 사전에 없어 한국어로 남았다. 항목을 하나씩 옮긴 뒤 묶어 틀에 넣는다(보관함 src/Result.jsx 시각줄과 같다)
function 시각없음(xs) {
  const tr = (s) => window.BGLANG?.t?.(s) ?? s, 쉼 = /^(ja|zh-)/.test(window.BGLANG?.locale || "") ? "、" : ", ";
  return tr("태어난 시간이 없어 볼 수 없는 항목: ${0}").replace("${0}", () => xs.map(tr).join(쉼));
}
function renderFree(fm) {
  const a = fm.무료축 || {}, t = a.type;
  const people = (fm.사람들 || []).map((p) => `<div class="who2"><b>${esc(p.누구)}</b>${pillars(p)}<p class="fiv">다섯 기운 ${esc(p.다섯기운한줄 || p.다섯기운까닭 || "")}</p>${p.일간 ? `<p class="fiv"><span>일간</span> ${esc(window.BGLANG?.stem(p.일간.글자) ?? p.일간.글자)}${window.BGLANG?.locale === "en" ? " " : ""}<span>${esc(p.일간.기운)}</span> — <span>${esc(p.일간.그림)}</span></p>` : ""}</div>`).join("");
  /* 9/27 밤 — 엔진은 계산만, 풀이는 풀이 글(기획/106). 엔진이 쓴 문장(본바탕의 결 · 두 사람 사이 한 줄과 뜻 · 까닭 목록 · 시각 안내)은 보이지 않는다.
     값(사주 표 · 다섯 기운 · 본바탕 글자 · 갈래 이름 · 까닭 자리 수)과 풀이 글만 보인다. */
  const miss = fm.시각 && !fm.시각.모두아는가 && fm.시각.빠진자리?.length ? `<p class="vnote">${esc(시각없음(fm.시각.빠진자리))}</p>` : "";
  const toc = (fm.잠긴목차 && fm.잠긴목차.length ? fm.잠긴목차 : M.paywall?.chapters || []);
  // 세 사람 질문(흔들림 2 가희)은 첫 번째·두 번째 사람과의 짝이 따로 온다(무료축.both)
  // 10/1 코드 점검 — 근거 수(evidenceCount)는 숫자로만 넣는다(엔진 값이 거르지 않고 HTML 에 들어갔다)
  const body = a.both
    ? [["첫 번째 사람과", a.both.second], ["두 번째 사람과", a.both.third]].filter(([, b]) => b).map(([lab, b]) => `<div class="vsec"><h3>${lab}</h3><h1 class="vname" style="font-size:30px;margin-top:4px">${esc(b.type?.name || "")}</h1></div>`).join("")
    : `<h1 class="vname">${esc(t ? t.name : "태어난 시간에 따라 달라져요")}</h1>
   ${a.missing ? `<p class="vline">${esc(a.missing)}</p>` : ""}
   <div class="wrt" id="wrFree">${wrFreeHtml()}</div>
   ${Number(a.evidenceCount) > 0 ? `<div class="vev"><span class="dots" aria-hidden="true"><i></i><i></i><i></i></span><span>${window.BGLANG?.locale === "ja" ? "理由" : /^zh-/.test(window.BGLANG?.locale) ? "依據" : "근거"} <b>${Number(a.evidenceCount)}${window.BGLANG?.locale === "ja" ? "つ" : /^zh-/.test(window.BGLANG?.locale) ? " 項" : "가지"}</b></span></div>` : ""}`;
  $("vpanel").innerHTML = `<div class="vtag"><i></i><span>${esc(a.axis || M.free?.axis || "")}</span></div>
   ${body}
   ${a.both ? `<div class="wrt" id="wrFree">${wrFreeHtml()}</div>` : ""}
   ${people ? `<div class="vsec"><h3>사주 명식</h3>${people}${miss}</div>` : ""}
   <div class="hr"></div>
   <div class="tocl">목차</div>
   <ul class="toc">${toc.map((x) => `<li><span>${esc(x)}</span>${LOCK}</li>`).join("")}</ul>
   <button type="button" class="pay" id="payBtn"><span>${window.BGPAY ? "구매하기" : "결과 보기"}</span></button>`;   // 9/28 코인 — 값 글씨 없이(coin.js 가 값을 붙인다). 10/2 점검 — 처음엔 「구매하기」(「결과보기」는 이미 샀거나 결제가 꺼진 때만 — coin.js label)
  // 9/28 코인 — 결과보기를 누르면 고른 장만큼 코인을 쓰고 연다(coin.js). 결제를 켜기 전에는 예전처럼 바로 startPaid
  // 10/1 코드 점검 — 풀이 글을 쓰는 맥이 안 붙어 있으면 사지 않는다(사고 나서 글이 안 왔다). 결제창은 누른 순간에만 열 수 있어(페이앱 · 아이폰 소리)
  // 누를 때 묻지 않고 무료 결과를 그릴 때 미리 물어 둔다(askMac). 안 붙어 있었으면 알리고 다시 물어 둔다. 묻기가 안 되면 막지 않는다.
  $("payBtn").onclick = () => {
    buzz(15);   // 10/1 인터랙션 16 — 결제 단추를 누른 순간
    if (!macOk && !window.BGPAY?.menu?.()?.샀나) { toast(macMsg()); askMac(); return; }   // 10/8 점검 — 이미 산 손님은 받아 둔 글을 볼 수 있게 지나간다
    return window.BGPAY ? window.BGPAY.buy() : startPaid();
  };
  askMac();
  fxSweep(window.BGPAY?.paint());
  markNope();
}
// 10/1 인터랙션(기획/119) 10 — 「구매하기」 단추가 값을 달고 처음 나타날 때 빛이 한 번 스친다(.fxsweep — play.html). 단추가 다 떠오른 뒤, 이 화면에서 한 번만.
let fxSwept = false;
function fxSweep(p) {
  if (!fxOn() || fxSwept || !p?.then) return;
  p.then(async () => {
    const b = $("payBtn"); if (fxSwept || !b || b.disabled || !b.querySelector(".cn")) return;   // 값 글씨(.cn — coin.js)가 붙은 때만
    fxSwept = true;
    await Promise.race([Promise.all((b.getAnimations?.() || []).map((a) => a.finished)), wait(2600)]).catch(() => {});   // 무료 결과 판이 떠오르는 동안은 기다린다
    if (!b.isConnected) return;
    b.classList.add("fxsweep"); setTimeout(() => b.classList.remove("fxsweep"), 1200);
  }).catch(() => {});
}
// 10/2 — /api/writer/status 는 { mac, ready, until? } (deploy/worker.js — ready 는 맥의 사용 한도에 걸린 동안 false, until 은 풀리는 때 ms). ready 로 막는다(없으면 예전처럼 mac)
let macOk = true, macUntil = 0;
const askMac = () => fetch("/api/writer/status", { cache: "no-store" }).then((r) => (r.ok ? r.json() : null)).then((j) => { macOk = (j?.ready ?? j?.mac) !== false; macUntil = Number(j?.until) || 0; }, () => { macOk = true; });
function macMsg() {   // 풀리는 때가 24시간 안이면 그 시각(한국 시간)을 알린다
  const left = macUntil - Date.now();
  if (!(left > 0 && left < 864e5)) return "지금은 풀이 글을 쓸 수 없어요. 잠시 뒤에 다시 해 주세요";
  const d = new Date(macUntil + 9 * 3600000), h = d.getUTCHours(), m = d.getUTCMinutes();
  return `지금은 풀이 글을 쓸 수 없어요. ${h < 12 ? "오전" : "오후"} ${h % 12 || 12}시${m ? ` ${m}분` : ""} 이후에 다시 해 주세요`;
}
// 무료 결과 목차에서 풀 수 없는 장을 미리 빨갛게 — 값은 받지 않고 장마다 풀리나만 묻는다(/api/pay/chapters, deploy/pay.js). 사기 전에 알 수 있게.
// 목차 밑 까닭 한 줄 — 태어난 시각 탓만 · 그 밖만 · 둘 다
const nopeNote = (nope) => {
  const t = nope.filter((c) => c.시각).length;
  return !t ? "빨간색 항목은 이번 풀이에서 볼 수 없어요."
    : t === nope.length ? "태어난 시간 정보가 없어서 빨간색 항목은 볼 수 없어요. 태어난 시간을 넣으면 볼 수 있어요."
    : "빨간색 항목은 이번 풀이에서 볼 수 없어요. 그중에는 태어난 시간을 넣으면 볼 수 있는 항목도 있어요.";
};
function markNope() {
  fetch("/api/pay/chapters", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ req: engineReq() }) })
    .then((r) => (r.ok ? r.json() : null)).then((j) => {
      const ul = document.querySelector("#vpanel .toc");
      if (!ul || !Array.isArray(j?.장들)) return;
      const lis = [...ul.children], nope = j.장들.filter((c) => !c.있음);
      for (const c of nope) {
        const li = lis.find((x) => (window.BGLANG?.sourceText(x.firstElementChild) ?? x.firstElementChild?.textContent) === c.제목) || lis[c.i];
        if (!li || li.classList.contains("nope")) continue;
        li.classList.add("nope"); li.insertAdjacentHTML("beforeend", "<small>볼 수 없음</small>");
      }
      if (nope.length && !document.getElementById("tocNope")) ul.insertAdjacentHTML("afterend", `<p class="tocnope" id="tocNope">${esc(nopeNote(nope))}</p>`);
    }).catch(() => {});
}
function renderErr(msg) {
  window.BGWATCH?.report("무료 결과를 못 받음", `${M?.no ?? ""}번 질문 · ${msg || ""}`);   // 10/7 감시(deploy/alerts.js)
  $("vpanel").innerHTML = `<div class="vtag"><i></i><span>${esc(M.free?.axis || "풀이")}</span></div><p class="verr">${esc(msg)}</p><button type="button" class="cta" id="freeAgain">다시 시도</button>`;
  // 10/1 코드 점검 — 무료 결과를 못 받았을 때 그 자리에서 다시 묻는다(전엔 오류 글만 남아 막혔다). 풀이 글도 못 받았으면 다시 쓴다
  $("freeAgain").onclick = async (e) => {
    e.currentTarget.disabled = true;
    if (WR.freeState === "fail") startFreeWrite();
    let fm = null, err = null;
    try { fm = await 결과기다리기(askEngine("free-material", engineReq())); } catch (x) { err = x.message; }
    if (fm) renderFree(fm); else renderErr(err);
  };
}

/* ── 무료 결과가 열리는 순간(사장님 9/26 「무료결과 나올때랑 가장 마지막 요약 결과 나올때 뭔가 아무런 효과도 없고 효과음도 없으니까 몰입감이 안생기네」)
   무료: 화면이 1.1초 동안 어두워지며 바람 소리가 차오르고 → 쿵 · 종소리와 함께 빛줄이 번지며 갈래 이름이 모여 떠오른다(play.html .reveal · .verdict.enter).  ── */
const REVEAL = 1.1;   // play.html 의 애니메이션 시각과 맞춘다
// 9/28 사장님 「지금 만든 걸로 사주에서도 쓸수있는건 적용하자」 — 타로 효과음(tarot/sfx, 기획/109) 중 무료 결과 울림을 같이 쓴다
const PSFX = { reveal: ["tarot/sfx/reveal.m4a"] };
const loadSfx = () => { try { SFX.load(PSFX); } catch { /* 소리 없이 */ } };
async function revealFree(render) {
  skipZone(false);   // 10/8 Skip — 무료 결과가 뜨면 엔딩 구간을 닫는다
  const rv = $("reveal"); rv.classList.remove("hit"); rv.classList.add("on");
  SFX.reveal(REVEAL);
  await wait(REVEAL * 1000);
  if (WR.freeState === "wait") { 로딩(true, "free"); await 글기다리기(() => WR.freeState !== "wait"); 로딩갱신(true); await wait(650); 로딩(false); await wait(220); }   // 10/1 — 무료 풀이 글이 오는 그 순간 결과가 떠오른다
  SFX.play("reveal", { level: 0.22, wet: true });   // 쿵 · 종과 같이 신비로운 울림을 얇게
  setTimeout(() => bgm.scene("idle"), 700);
  render();
  const v = $("verdict"); v.classList.remove("enter"); v.scrollTop = 0; void v.offsetWidth; v.classList.add("on", "enter"); rv.classList.add("hit");
  막이("verdict");   // 10/2 점검 — 뒤로 가기 막이(goHome 위 주석)
}
/* 10/2 점검 — 결과지가 무대를 다 덮은 동안에도 대기 영상 · 이어 틀기 재생기 · 로고 그림이 돌았다(배터리). 결과지 층이 뜨면 멈춘다(hover 도 쉰다 — 06-paid 결과지열기) */
function 쉼() {
  쉬는중바꿈(true);
  stopLoopBack();
  [idle, idleB, ...RL.lanes].forEach((v) => { try { v.pause(); } catch { /* 그대로 */ } });
  if (front && front.over) front.v.pause();
  ["mark", "mark2", "markL"].forEach((id) => $(id)?._markStop?.());
}

async function runFree() {
  REF바꿈(kstOf(Date.now() + SKEW));                                                              // 10/1 코드 점검 — 이 풀이의 기준일을 여기서 한 번 정한다(engineReq)
  idle.play().catch(() => {}); loadSfx(); bgm.start(M.no, M.room); window.BGMEMORY?.wake();     // 대사 요소 · 효과음 · 대기 · 회상 영상은 손님이 누른 그 순간에 이미 풀었다(09-boot 누름풀기 — 여기는 누름 밖에서도 돈다). 10/2 사장님 「배경음이 늦게 시작되는것같은데」 — 첫 줄 뒤로 미루던 곡(later)을 되돌려 누른 순간 받는다
  $("gate").style.display = "none";
  $("black").style.transition = "none"; $("black").style.opacity = 1;
  const first = M.flow.intro[0] || M.flow.inputs[0] || "C02", v0 = vid(first);
  if (lane(v0)) seekClip(v0); else v0.currentTime = 0; v0.style.transition = "none"; v0.classList.add("on");   // 첫 줄 첫 장면을 깔아 두고 까만 막을 걷는다
  // 9/27 사장님 「캐릭터 눌러서 들어가면 바로 튀는 현상 … 얼굴이 튀는 게 보이잖아 처음부터」 — 아이폰은 아직 재생 안 한 영상의 첫 장면을 그리지 않아,
  // 첫 줄이 시작될 때까지 뒤에서 돌던 대기 영상이 비쳐 보이다가 첫 줄 첫 장면으로 튀었다. 그래서 첫 줄이 시작될 때까지 대기 영상을 첫 줄 첫 장면 그림에 세워 둔다.
  freeze바꿈(true); idle.pause(); idle.currentTime = idleTime(M.lines[first]?.is ?? 0);
  // 10/2 점검 — 첫 말까지 3초가 걸렸다(까만 막 0.9초 + 걷기 1.5초 + 0.6초). 0.3초 + 0.8초로 줄여 2초 안에 첫 말이 나오게
  await wait(300);
  $("black").style.transition = "opacity .8s"; $("black").style.opacity = 0; await wait(800 + 100);
  skipZone(true, "voice"); preload(M.flow.inputs?.[0]);   // 10/8 Skip — 오프닝. 10/9 — 누르면 첫 질문 음성이 시작되는 장면으로 바로 붙는다(그 줄은 미리 받아 둔다)
  for (const [i, k] of M.flow.intro.entries()) { await play(k, { how: k === first ? "cut" : null, next: M.flow.intro[i + 1] }); bgm.go?.(); }   // 10/2 — 배경음악은 첫 줄이 끝난 뒤 받는다(느린 통신에서 첫 줄과 다투지 않게)
  await runInputs();
  if (M.mode === "daily") return runDaily();
  // 선택지를 고르는 동안 무료 풀이를 쓴다(9/24 결정). 고른 답이 무료 갈래를 가르는 질문(PICK_Q)은 마지막 답을 고른 바로 뒤에 부른다 — 그 반응 줄과 C09 동안 쓴다.
  const late = PICK_Q.has(M.engineId) || isTest();
  // 10/22 심리 테스트도 웹 · 안드로이드는 1,000원 · 토스는 990원 — 다른 유료 풀이처럼 영상 뒤 결제. 아이폰 앱 안에서는 무료(서버 deploy/pay.js 앱판 · prices.js 무료테스트 와 같은 갈래)
  const deferred = !!window.BGAFTER?.enabled && (!isTest() || !/BamgwabiApp\//.test(navigator.userAgent || ""));
  let freeP = null;
  const askFree = () => { if (freeP || (deferred && !window.BGENTRY)) return; const req = engineReq(); freeP = (async () => { await window.BGENTRY?.bind(req); return askEngine("free-material", req); })(); freeP.catch(() => {}); startFreeWrite(req); };   // 입력을 구매에 연결한 뒤 기본 재료도 같은 구매 권한으로 받는다
  if (!late && !window.BGENTRY) askFree();
  for (const [i, k] of M.flow.record.entries()) { await play(k, { next: M.flow.record[i + 1] || M.flow.questions[0]?.q }); }
  const qs = M.flow.questions;
  if (qs.length) {
    if (front && !front.over) front.next = true;
    await handing;
    await window.BGMEMORY?.enter(front?.v || idle, () => preload(qs[0].q));
  }
  for (let i = 0; i < qs.length; i++) {
    // 10/2 점검 — 반응 줄 셋을 물음 줄과 함께 받아 느린 통신에서 물음 줄이 늦었다. 물음 줄을 다 받은 뒤에 받는다
    preload(qs[i].q); let qp;
    const question = () => { qp = play(qs[i].q); afterFull(qs[i].q, () => qs[i].opts.forEach((o) => preload(o[1]))); };
    await window.BGMEMORY?.next(qs[i].q, question);
    if (!qp) question();
    await qp;
    if (M.engineId === "life.concern" && qs[i].q === "C04") await askConcern();
    const r = await choose(qs[i]);
    if (M.engineId === "breakup.reunion" && qs[i].q === "C04") input.lastContact = { R1_me: "me", R1_them: "them", R1_faded: "faded" }[r];
    if (isTest()) (input.answers ||= [])[i] = qs[i].opts.findIndex((o) => o[1] === r) + 1;   // 10/1 밤 심리 테스트 — ① ② ③
    if (late) (input.picks ||= {})[qs[i].q] = r;
    if ((late || window.BGENTRY) && i === qs.length - 1) askFree();
    if (i === qs.length - 1) skipZone(true);   // 10/8 Skip — 엔딩(마지막 답의 반응 줄 · 끝인사 → 무료 결과)
    await play(r, { next: i + 1 < qs.length ? qs[i + 1].q : "C09" });
  }
  if (!freeP) askFree();
  if (!qs.length) skipZone(true);   // 고르기가 없는 질문은 끝인사부터 엔딩
  if (M.lines.C09?.loop) preload("C09loop");
  if (deferred) window.BGAFTER.ready.then(() => window.BGAFTER.prepare(engineReq())).catch(() => {});   // 10/16 — 끝인사가 나오는 동안 결제 안내를 미리 불러 둔다(after-video.js)
  bgm.scene("c09");
  globalThis.BGEV?.("closing", { q: M.engineId });   // 10/22 손님 흐름 단계 — 끝인사
  if (window.BGMEMORY?.active) {
    let result;
    // 10/8 Skip — 건너뛰었으면 끝인사는 소리 없이 틀어 장면 기억에서 돌아오는 전환만 마친다(전환은 돌아갈 영상이 움직여야 끝난다)
    await window.BGMEMORY.leave(vid("C09"), () => { result = SKIP.on ? (() => { const v = vid("C09"); v.muted = true; v.classList.add("on"); v.play().catch(() => {}); })() : play("C09", { how: "cut" }); });
    await result;
  } else await play("C09", { how: "dip" });                      // 자세가 바뀌는 몸짓이라 겹치지 않고 까맣게 내렸다 올린다(겹치면 잔상 — 사장님 9/24)
  if (deferred) {
    skipZone(false);
    // 10/20 — 결제 안내를 이 화면에 못 열면(after-video.js 를 못 받음 · 저장소가 막힌 브라우저에서 sessionStorage 가 던짐) 거절이 그대로 새어 끝인사 장면에서 멈췄다. 같은 구매 안내 화면으로 보낸다
    window.BGAFTER.cover = (on) => (on ? 로딩(true, "paid", true) : 로딩(false));   // 10/28 — 결제 뒤 덮개는 이 화면의 큰 로딩(결과지가 열릴 때까지 이어진다 — 06-paid openPaid)
    try { await window.BGAFTER.ready; await window.BGAFTER.open(engineReq()); }
    catch { location.assign(`/app/purchase.html?target=${encodeURIComponent(location.pathname + location.search)}&lang=${encodeURIComponent(window.BGLANG?.locale || "ko")}`); return; }
    askFree();
  }
  // 10/22 — 결제를 마친(영상 뒤 결제) · 구매번호를 들고 온(먼저 산 구매) 진행은 옛 무료 결과 판(#verdict · 구매 단추)을 그리지 않고 바로 산 결과지로 간다(입력 연결은 결제 확인 BGPAY.paint 가 먼저 한다).
  //   결과지 화면을 못 열면(결제 확인 · 재료를 못 받음) 그 화면의 「결과 보기」(다시 열기) 단추를 띄운다 — 끝인사 장면에 갇히지 않게
  if (window.BGENTRY) {
    skipZone(false);
    await openPaid();
    if (!$("paid").classList.contains("on")) { $("pname").textContent = M.name; $("ptitle").textContent = M.title; $("paid").classList.add("on"); $("pgate").classList.remove("gone"); 막이("paid"); window.BGAFTER?.shown?.(); }
    return;
  }
  let fm = null, err = null;
  try { fm = await 결과기다리기(freeP); } catch (e) { err = e.message; }
  await revealFree(() => (fm ? renderFree(fm) : renderErr(err)));
  if (fm && ["test.egen", "test.attach", "test.hsp", "test.ennea"].includes(M.engineId)) await openPaid();
}

async function runDaily() {
  const req = { ...person(input.me, input.meTime, input.sex === "남성" ? "male" : "female"), referenceDate: todayKst() };
  const result = askEngine("daily-fortune", req).then((value) => ({ value }), (error) => ({ error }));
  skipZone(true);   // 10/8 Skip — 오늘의 운세는 입력 뒤 말이 엔딩
  bgm.scene("c09");
  await play(M.flow.result, { next: M.flow.close });
  const { value, error } = await 결과기다리기(result);
  if (value) await play(M.flow.close);
  if (value) globalThis.BGEV?.("free_result", { q: M.engineId });   // 10/22 손님 흐름 단계 — 오늘의 운세 결과
  await revealFree(() => {
    const { date, topics } = 오늘날짜주제(value);
    $("vpanel").innerHTML = `<div class="vtag"><i></i><span>오늘의 운세</span></div>
      <h1 class="vname">${esc(date || "운세를 불러오지 못했어요")}</h1>
      ${value ? `${input.meGuess ? '<p class="vnote">추정한 태어난 시간으로 본 운세예요.</p>' : ""}${value.summary ? `<section class="vsec wrt"><h3>하루 요약</h3><p class="alead">${esc(value.summary)}</p></section>` : ""}${topics.map((t) => `<section class="vsec wrt"><h3>${esc(t.label)}</h3><p class="alead">${esc(t.conclusion)}</p><p class="ac">${esc(t.recommendedAction)}</p><p class="ac">${esc(t.avoidAction)}</p></section>`).join("")}` : `<p class="vline" role="alert">${esc(error?.message || "잠시 뒤에 다시 시도해 주세요.")}</p><button type="button" class="pay" id="dailyRetry">다시 시도</button>`}
      <button type="button" class="pay" id="dailyHome">홈으로</button>`;
    $("dailyHome").onclick = goHome;
    const 공유몸 = 오늘공유몸(value, date, topics);
    // 10/15 리뷰 — 공유 단추는 새 결과지에 붙인다. 아래 옛 판에는 새 결과지를 못 띄웠을 때만(두 번 붙이지 않게)
    const 옛판공유 = () => import(new URL("/app/share-card.js", location.origin).href).then(({ mountShare }) => mountShare($("vpanel"), 공유몸, { before: $("dailyHome") })).catch(() => toast("공유를 준비하지 못했어요. 다시 시도해 주세요."));
    // 10/14 밤 사장님 「mbti,시뮬레이션 제외 모두 새로운 디자인을 사용해야해」 — 오늘의 운세도 새 결과지(해 높이 · 하루 여섯 해)를 화면 전체에 띄운다. 못 불러오면 위 결과 판 그대로
    const 본인 = { ...person(input.me, input.meTime, input.sex === "남성" ? "male" : "female"), ...(input.meGuess ? { guess: true } : {}) };   // 10/21 매일 운세 알림에 저장할 운세 정보
    if (value) 오늘결과지(value, date, input.meGuess, 공유몸, 본인).catch(옛판공유);
    if ($("dailyRetry")) $("dailyRetry").onclick = () => { $("verdict").classList.remove("on", "enter"); runDaily(); };
  });
}
// 오늘의 운세 답 → 결과지 날짜 글 · 주제. 10/8 감시 점검 — 답에 날짜 · 주제가 빠지면 Intl 이 던져 결과 판이 안 뜨고 화면이 멈췄다. 날짜는 못 쓰면 비우고, 주제는 있는 것만 그린다
function 오늘날짜주제(value) {
  const dateLocale = window.BGLANG?.locale || "ko-KR", shortDate = /^en(?:-|$)/i.test(dateLocale);
  let date = "";
  try { if (/^\d{4}-\d{2}-\d{2}$/.test(value?.date || "")) date = new Intl.DateTimeFormat(dateLocale, { timeZone: "Asia/Seoul", month: shortDate ? "short" : "long", day: "numeric", weekday: shortDate ? "short" : "long" }).format(new Date(`${value.date}T12:00:00+09:00`)); } catch { date = ""; }
  const topics = value?.topics && typeof value.topics === "object" ? Object.values(value.topics).filter((t) => t && typeof t === "object") : [];
  return { date, topics };
}
const 오늘공유몸 = (value, date, topics) => ({
  no: 52, theme: "sunrise", locale: window.BGLANG?.locale || "ko", title: window.BGLANG?.t?.(M.title) || M.title, who: window.BGLANG?.t?.(M.name) || M.name, img: new URL(M.end, location.origin + "/app/").pathname,
  big: value?.summary || date, cardTitle: date, cardText: value?.summary || "",
  cells: topics.map(t => ({ t: t.label, a: t.conclusion })),
  chapters: topics.map(t => ({ t: t.label, big: t.conclusion, cards: [t.recommendedAction, t.avoidAction].filter(Boolean) }))
});
// 10/14 밤 사장님 「mbti,시뮬레이션 제외 모두 새로운 디자인을 사용해야해」 — 오늘의 운세도 새 결과지(해 높이 · 하루 여섯 해)를 화면 전체에 띄운다.
// 10/21 — 무비 끝(runDaily)과 매일 운세 알림으로 연 화면(runDailyAlarm)이 같이 쓴다. 본인 = 알림에 저장할 운세 정보(03-input.js person + guess)
function 오늘결과지(value, date, guess, 공유몸, 본인) {
  return import(new URL("/app/result-kit/sheet.js", location.origin).href).then(async ({ openSheet, dailySheet }) => {
    const view = await openSheet(dailySheet(value, { who: 공유몸.who, date, note: guess ? "추정한 태어난 시간으로 본 운세예요." : "" }), { onBack: () => goHome() });
    const home = document.createElement("button"); home.type = "button"; home.className = "m-btn"; home.textContent = "홈으로"; home.onclick = goHome;
    view.acts.append(home);
    // 10/21 매일 운세 알림(토스 · 안드로이드 앱에서만 보인다) — 공유 · 저장 줄이 붙은 다음에 붙여 단추 순서가 늘 같게(공유 · 저장 → 알림 → 홈으로)
    import(new URL("/app/share-card.js", location.origin).href).then(({ mountShare }) => mountShare(view.acts, 공유몸, { before: home })).catch(() => {})
      .then(() => import(new URL("/app/daily-alarm.js", location.origin).href)).then(({ mountDailyAlarm }) => mountDailyAlarm(view.acts, { before: home, profile: 본인 })).catch(() => {});
  });
}
// 10/21 사장님 「오늘의 운세가 도착했어요라고 하고 들어가면 오늘의 운세를 전부 볼 수 있어야지」 — 알림을 눌러 들어오면(?alarm=1, 09-boot.js)
//   서버에 저장된 운세 정보(public/app/daily-alarm.js alarmProfile)로 시작 단추 · 영상 · 입력 없이 오늘의 운세 결과지를 바로 연다. 못 받으면 false(평소 흐름)
async function runDailyAlarm() {
  로딩(true, "free");   // 10/21 코드 리뷰 — 저장된 정보 · 엔진 답을 기다리는 동안 빈 화면 대신 로고 로딩
  try {
    const { alarmProfile } = await import(new URL("/app/daily-alarm.js", location.origin).href);
    const saved = await alarmProfile();
    if (!saved?.profile) return false;
    const { guess, ...p } = saved.profile;
    const value = await askEngine("daily-fortune", { ...p, referenceDate: todayKst() });
    if (!value) return false;
    const { date, topics } = 오늘날짜주제(value);
    await 오늘결과지(value, date, guess, 오늘공유몸(value, date, topics), saved.profile);
    return true;
  } finally { 로딩(false); }
}
/* ── 유료 ── */
let CH = [], MAT = null, matP = null, moving = false;
/* 10/2 유료 결과에서는 결제 전에 제외된 장(풀 수 없는 장 — 값 없이 뺀 까닭만 있는 장)과 안 산 장을 건너뛴다(결과지 쪽도 같다 — result-kit/sheet.js sajuSheet).
   무료 목차의 풀 수 없는 장 안내는 05-free.js. 장 번호(idx)는 엔진 순서 그대로라 글이 제자리에 붙는다. t · a — 장 이름 · 엔진 값(공유 요약 — 07-share) */
function buildCH(mat) {
  return (mat.유료 || []).map((c, idx) => ({ c, idx })).filter(({ c }) => !c.잠김 && !(c.값 == null && c.뺀까닭))
    .map(({ c, idx }) => ({ idx, t: c.제목, a: String(c.값 ?? "") }));   // 10/27 점검 — 값이 null 이면 「null」이 보였다
}
let paidGo = false;   // 10/2 점검 — 유료를 이미 시작했다(뒤로 가기로 무료 결과에 갔다가 「결과보기」로 다시 들어오면 화면만 바꾼다 — 재료 · 글쓰기 · 영상은 이미 돌고 있다)
// 10/14 사장님 「결제를 하면 … 로딩이 진행되겠지? 완료가 되면 자동으로 보관함 결과지로 이동」 — 결제가 끝나면(coin.js) 「유료 결과 확인하기」를 누르지 않아도 바로 연다(openPaid)
async function startPaid() {
  const ok = await paidSetup();
  if (ok && !moving) setTimeout(() => openPaid(true), 0);   // 방금 준비했다 — openPaid 가 결제 확인(BGPAY.paint)을 다시 하지 않는다
  return ok;
}
async function paidSetup() {
  SFX.wake();
  const menu = await window.BGPAY?.paint();
  if (!menu || menu.탈) { toast(menu?.탈 || "결제 정보를 확인하지 못했어요"); return false; }
  if (menu.mode !== "off" && !menu.샀나) { if ($("payBtn")) paidBack(); else toast("결제 정보를 확인하지 못했어요"); return false; }   // 10/22 — 무료 결과 판을 그리지 않은 진행(결제 뒤 바로 결과지)은 돌아갈 판이 없다 — 이 화면에 남는다
  로딩(true, "paid", true);   // 10/28 — 무료 결과판을 걷기 전에 로딩 덮개부터(그 사이 인물 얼굴이 비쳤다)
  $("verdict").classList.remove("on", "enter"); $("reveal").classList.remove("on", "hit");
  $("paid").classList.add("on"); 막이("paid");
  if (paidGo) return true;
  paidGo = true;
  try { vaultKey().catch(() => {}); } catch { /* 10/27 리뷰 — 동기로 던지면 paidGo 만 켜진 채 askMat 이 안 불려 다음 누름에서 갇혔다 */ }   // 10/2 — 보관함 칸 이름(입력이 다 정해진 지금 한 번 — 아래 saveVault 보다 먼저)
  askMat();                                               // 결제한 순간 바로 부른다 — 「유료 결과 확인하기」를 누를 때는 이미 와 있다(사장님 9/26 「결과지가 너무 늦게 올라온다」)
  // 결제한 순간 유료 장 전부를 한꺼번에 쓰기 시작한다. 이 화면에서 이미 받은 장은 다시 쓰지 않고, 재료가 오면 빠진 장만 쓴다(askMat → fillMissing)
  if (!Object.keys(WR.ch).length && !WR.all) startPaidWrite();
  else if (!WR.conclusion && !WR.all) startPaidWrite([]);
  $("pname").textContent = M.name; $("ptitle").textContent = M.title;
  return true;
}
let matBad = false;   // 10/1 코드 점검 — 유료 재료를 못 받았으면 「유료 결과 확인하기」를 다시 누를 때 새로 묻는다(openPaid)
function askMat() {
  const p = (matP = askEngine("question-material", engineReq())); matBad = false;
  // 9/27 사장님 「유료결제한 사주 결과가 보관함에 나와야하잖아」 — 「유료 결과 확인하기」를 누르기 전에 나가도 남게, 결제 재료가 오는 즉시 보관함에 둔다.
  p.then((m) => { if (!MAT) MAT = m; saveVault(); fillMissing(); 로딩갱신(); }, () => { if (matP === p) matBad = true; }).catch(() => {});
  return p;
}
/* 10/28 사장님 「1개라도 완성되면 바로 보여주는 식」 · 「다음 버튼을 눌러야 가지는걸로」 · 「다음페이지에서 로딩창이 보이게 … 풀이를 작성중」 · 「지금 결과지를 잘르면 되잖아」 —
   결제 뒤 결과지는 공용 결과지(result-kit/sheet.js sajuSheet — 보관함과 같은 꼴)를 항목별 쪽으로 자른 층이다. 장이 하나 준비되면 바로 열고, 나머지 쪽은 글이 오는 대로 그 쪽만 채운다(결과지갱신).
   글이 아직인 쪽은 「풀이를 쓰고 있어요」(10/28 사장님 「로딩창이 뜨게 한다고 했잖아」 — 흐름이 끊겨도 실패 칸 없이, 화면이 알아서 다시 받는다 — 04-writing rewriteLater · 돌아오면 바로).
   서버가 글쓰기를 거절했을 때만(4xx — 다시 받아도 같다) 그 쪽에 「다시 시도」(10/28 사장님 「결제 확인이 끝내 거절되는 경우? 다시시도로 바꿔」). 끝 쪽 「홈으로」 · 뒤로 가기(01-common 막이 "result")는 홈 */
let 결과지 = null, 결과지판 = null;   // 연 결과지 층(openSheet) · 결과지 모듈(sheet.js)
// 쪽 상태 — 없음(보인다) · "wait"(쓰는 중) · "fail"(거절됨 — 「다시 시도」). 장은 큰 답과 첫 문단이 오면(readable) 바로 보이고 나머지 문단은 이어서 온다
function 상태(k) {
  const 빈쪽 = 거절됨() ? "fail" : "wait";
  if (k === "free") return WR.free || !window.BGENTRY ? undefined : 빈쪽;   // 무료 결과를 거쳐 온 손님은 1번 항목 글을 이미 받았다. 결제 뒤 바로 온 손님(BGENTRY)은 유료 글쓰기로 같이 온다
  if (k === "end") return WR.conclusion ? undefined : 빈쪽;
  return WR.ch[k] || readable(k) ? undefined : 빈쪽;
}
// 10/28 사장님 「풀이 항목이 하나가 완성되면 바로 보여주기로 했는데 왜 6개가 전부 다 완성되어야」 — 결과지가 첫 쪽이 다 써질 때까지 기다려 늦게 열렸다 — 어느 쪽이든 하나 보이면 연다
// 10/29 사장님 「로그인이 왜 첫번째 항목부터 뜨는거야 · 다음으로 어떻게 넘어가?」 — 최종 결론(끝 쪽)이 먼저 써지면 결과지가 끝 쪽으로 열려 「다음」 없이 「홈으로」 · 로그인 · 공유부터 보였다.
//   1번 항목이나 장이 하나 보이면 연다(끝 쪽으로는 먼저 열지 않는다 — 장이 없는 결과지도 1번 항목 쪽으로 연다)
const 하나라도보임 = () => 상태("free") !== "wait" || CH.some((c) => 상태(c.idx) !== "wait");
// 결과지에 싣는 결과 — 보관함에 남기는 결과(08-resume 결과몸)에 쓰는 중인 장의 앞부분을 더한다
function 결과지몸() {
  const r = 결과몸(); r.writ.ch = { ...WR.partial, ...WR.ch };
  const s = 결과지판.sajuSheet(r, { state: 상태 });
  for (const c of s.chapters) if (!WR.ch[c.key] && !c.state) c.tail = ["나머지 풀이를 작성하고 있어요."];
  return s;
}
// 글이 올 때마다(04-writing) — 글이 바뀐 쪽만 다시 그린다(sheet.js update)
function 결과지갱신() { if (!결과지) return; 결과지.update(결과지몸()); 메일자리(); }
// 10/29 사장님 「로그인과 이메일 둘 다 마지막 항목으로」 — 이메일 칸(메일칸)은 쓰는 동안(다시 받기를 기다리는 쪽이 남은 동안도) 끝 쪽 맨 아래에 두고, 다 쓰면 원래 자리(로딩 덮개)로
let 메일집 = null;
function 메일자리() {
  const f = $("wmail"); if (!f || !결과지) return;
  메일집 ||= f.parentNode;
  // 10/29 코드 리뷰 — 흐름이 잠깐 끊겨(WR.live 0) 다시 받기를 기다리는 쪽이 남아도 칸을 거두지 않는다(적던 주소가 사라졌다)
  const 끝 = 결과지.root.querySelectorAll(".m-pg").length - 1, 자리 = WR.live || 결과지.root.querySelector(".m-wait") ? 결과지.slot(끝) : 메일집;
  if (자리 && f.parentNode !== 자리) 자리.append(f);
}
async function 결과지열기() {
  결과지판 = await import(new URL("/app/result-kit/sheet.js", location.origin).href);
  const 몸 = 결과지몸();
  결과지 = await 결과지판.openSheet(몸, { paged: true, endLabel: "홈으로", onEnd: 나가기, onBack: 나가기, onRetry: 다시쓰기, onPage: 메일자리 });
  const 첫보임 = 몸.pages.slice(0, -1).findIndex((p) => p.state !== "wait");   // 1번 항목이 아직이면 먼저 써진 장부터 보인다(첫 쪽은 목차로 돌아가 본다 · 끝 쪽은 고르지 않는다)
  if (첫보임 > 0) 결과지.go(첫보임);
  막이("result"); 메일자리();
  쉼();   // 결과지가 무대를 다 덮는다 — 대기 영상 · 로고 그림을 멈춘다(배경음악은 그대로 — ♪ 단추는 층 위, play.html)
  import(new URL("/app/share-card.js", location.origin).href).then(({ mountShare }) => mountShare(결과지.acts, 공유몸)).catch(() => {}).then(비회원칸);
}
function 나가기() { 적은것맡기기(); goHome(); }
// 「다시 시도」 — 그 쪽만 다시 받는다(1번 항목 · 최종 결론은 같은 결제 작업이 쓴다 — 빠진 장 없이 parts []). 시작하면 거절 표시가 지워져 그 쪽은 「쓰는 중」
function 다시쓰기(k) { startPaidWrite(k === "free" || k === "end" ? [] : [k]); 결과지갱신(); }
// 10/28 사장님 「친절이 너무 부족해」 — 비회원(이 기기에만 남는다)은 끝 쪽에 보관함 결과지(src/Result.jsx)와 같은 「로그인하면 보관함에 1년 동안 남아요」와 보관함 로그인 단추. 앱 · 토스는 그 계정이라 두지 않는다
function 비회원칸() {
  if (!결과지 || window.BGTOSS || /BamgwabiApp\//.test(navigator.userAgent)) return;
  Promise.resolve(window.BGME?.when?.() ?? window.BGME?.owner?.()).catch(() => null).then((who) => {
    if (who) return;
    const tr = (s) => window.BGLANG?.t?.(s) ?? s, d = document.createElement("div");
    d.className = "rv-keep";
    d.innerHTML = `<p>${esc(tr("이 결과는 지금 이 기기에만 있어요. 로그인하면 보관함에 1년 동안 남아요."))}</p><button class="m-btn" type="button">${esc(tr("로그인"))}</button>`;
    d.querySelector("button").onclick = () => { 적은것맡기기(); flushVault(true); location.assign(window.BGLANG?.link?.("/#vault") || "/#vault"); };
    결과지.acts.append(d);
  });
}
async function openPaid(준비됨) {   // 준비됨 — startPaid 가 막 paidSetup 을 마쳤다(「결과 보기」 단추 · 다른 곳에서 부르면 다시 준비한다)
  if (moving || 결과지) return; moving = true; SFX.wake();
  // 10/8 감시 점검 — startPaid 가 던지면 moving 이 true 로 남아 「결과 보기」가 영영 안 눌렸다. 알리고 단추를 되살린다
  let ok = false;
  try { ok = 준비됨 === true || (await paidSetup()); } catch (e) { toast(e?.message || "결과를 불러오지 못했어요"); }
  // 10/29 리뷰 — 영상 뒤 결제 직후(BGAFTER.cover 로 큰 로딩을 덮어 둠) 확인이 실패하면 로딩이 「결과 보기」 단추를 덮은 채 남았다. 걷고 단추를 되살린다
  if (!ok) { 로딩(false); $("pgate").classList.remove("gone"); moving = false; return; }
  globalThis.BGEV?.("result_open", { q: M.engineId });   // 10/22 손님 흐름 단계 — 산 결과지를 연다
  $("pgate").classList.add("gone"); $("home").style.display = "none";
  if (matBad) askMat();                                   // 10/1 코드 점검 — 앞서 못 받은 재료는 다시 묻는다
  await entering;
  let err = null;
  const mp = matP.then((m) => { MAT = m; CH = buildCH(MAT); saveVault(); }, (e) => { err = e.message; });
  로딩(true, "paid"); 메일칸();
  window.BGAFTER?.shown?.();   // 10/22 — 결과지 화면(풀이를 쓰는 동안의 로딩)이 떴다: 결제 뒤 덮어 둔 구매 화면을 걷는다(after-video.js)
  await mp;
  // 10/1 코드 점검 — 못 받으면 알리고 「결과 보기」 · 홈 단추를 되살린다(다시 누르면 새로 묻는다). 전엔 글만 남고 누를 곳이 없어 갇혔다
  const 못열음 = (글) => { 로딩(false); toast(글); $("pgate").classList.remove("gone"); $("home").style.display = ""; moving = false; };
  if (!CH.length) return 못열음(err || "결과를 불러오지 못했어요");
  await 글기다리기(() => 하나라도보임() || 쓰기멈춤());   // 어느 쪽이든 하나 보이면 연다 — 무료 결과를 거쳐 온 손님은 바로. 나머지 쪽은 열린 뒤에 채운다
  try { await 결과지열기(); } catch { return 못열음("결과지를 열지 못했어요. 다시 눌러 주세요"); }
  로딩(false); moving = false;
}
$("pgo").onclick = openPaid;
// 10/14 사장님 「비회원은 이메일 적는 칸을 넣자 그리고 결과지를 이메일로도 쏴주는거야」 · 10/20 「1번으로 해 회원도 메일 보내게 해」 — 결제 뒤 로딩 동안(10/28 토스판도) 이메일 칸을 띄우고,
//   적은 주소를 그 결제 작업에 맡긴다(deploy/result-mail.js — 산 풀이만 · 한 번만). 다 쓰면 서버가 보낸다 — 화면을 닫아도(예전에는 화면이 다 받은 뒤에 보내 그 전에 닫으면 안 갔다).
//   계정 이메일이 있는 회원(구글)은 서버가 그 주소로 보내니 칸을 띄우지 않는다
// 10/14 코드 리뷰 — 주소 모양은 서버(deploy/result-mail.js)가 정한다. 여기서는 바로 알려 줄 만큼만(@ 와 점) 본다
const 메일모양 = (v) => v.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
const 적은주소 = () => { const v = $("wmailIn")?.value.trim() || ""; return 메일모양(v) ? v : ""; };   // 받기를 누르지 않아도 칸에 적어 둔 주소
let 메일물음 = false, 맡긴주소 = "";
// 주소를 결제 작업에 맡긴다(주소 없이 부르면 이미 맡긴 주소가 있는지만 — { mail })
const 맡기기 = (email) => fetch("/api/result-mail", { method: "POST", headers: { "Content-Type": "application/json", ...(window.BGPAY?.head() || {}) }, body: JSON.stringify({ ...(email ? { email } : {}), req: engineReq() }), keepalive: true })
  .then(async (r) => { const j = await r.json().catch(() => ({})); if (!r.ok) throw Error(j.error || "응답이 늦어지고 있어요. 잠시 뒤에 다시 시도해 주세요"); return j; }, () => { throw Error("인터넷 연결이 끊겼어요. 연결을 확인하고 다시 눌러 주세요"); });
// 받기를 누르지 않고 칸에 적어 둔 주소도 화면을 옮기기 전에 맡긴다
function 적은것맡기기() { const v = 적은주소(); if (v && v !== 맡긴주소) { 맡긴주소 = v; 맡기기(v).catch(() => {}); } }
addEventListener("pagehide", 적은것맡기기);   // 10/28 — 결과지를 띄운 채 화면을 닫아도 적어 둔 주소로 보낸다
function 메일칸() {   // 결제 뒤 풀이를 쓰는 동안 뜨는 로딩마다 부른다(04-writing 로딩)
  const f = $("wmail"); if (!f || 메일물음 || !f.hidden) return;   // 10/28 사장님 「토스 결과지 로딩에 왜 이메일로 받기가 없는거야」 — 토스판에도 띄운다
  메일물음 = true;
  const tr = (s) => window.BGLANG?.t?.(s) ?? s, inp = $("wmailIn"), msg = $("wmailMsg");
  맡기기().catch(() => null).then((j) => {
    if (j?.mail) return;   // 계정 이메일(구글 회원)로 이미 보내게 돼 있다
    f.hidden = false;
    f.onsubmit = (e) => {
      e.preventDefault();
      const v = inp.value.trim();
      if (!메일모양(v)) { msg.textContent = tr("이메일 주소를 다시 확인해 주세요"); msg.className = "bad"; return; }
      맡긴주소 = v;
      맡기기(v).then(() => { msg.textContent = tr("풀이가 끝나면 이 주소로 보내 드릴게요"); msg.className = ""; inp.blur(); },
        (err) => { 맡긴주소 = ""; msg.textContent = tr(err.message); msg.className = "bad"; });
    };
  });
}
// 「결과 보기」 화면에서 뒤로 — 무료 결과로(그 판의 단추는 이미 샀으니 「결과보기」 — 누르면 startPaid 가 다시 이 화면으로)
function paidBack() {
  $("paid").classList.remove("on"); $("reveal").classList.add("on");
  const v = $("verdict"); v.classList.remove("enter"); v.classList.add("on");
}
/* 10/2 점검 — 요약 값이 엔진 값 그대로였다(「할 것과 하지 말 것: 아니요」 · 큰 답 「이미 열려 있다」 · 한 낱말 「사람」 · 열두 달 목록 한 칸).
   그 장의 풀이 글 큰 답(한 문장)을 먼저 쓰고, 없을 때만 엔진 값 — 날짜 목록은 앞 둘 + 「외 N개」 */
const 짧게 = (v) => { const s = String(v ?? ""), xs = s.split(/\s*·\s*/); return xs.length > 2 && xs.every((x) => /\d{4}년/.test(x)) ? `${xs.slice(0, 2).join(" · ")} 외 ${xs.length - 2}개` : s; };
const 요약값 = (c) => (WR.ch[c.idx]?.answer ? tidy(WR.ch[c.idx].answer) : 짧게(c.a));
function 요약() {
  const fa = MAT?.무료?.무료축, free = fa?.type?.name || (fa?.both ? [fa.both.second?.type?.name, fa.both.third?.type?.name].filter(Boolean).join(" · ") : null);
  const cells = CH.map((c) => ({ t: c.t, a: 요약값(c) }));
  if (free) cells.push({ t: fa?.axis || M.free?.axis || "갈래", a: free });
  return { big: WR.conclusion?.answer ? tidy(WR.conclusion.answer) : "", cells };
}
/* 10/2 사장님 「결과지 링크 해결해」 · 「요약뿐만 아니라 전체 글도 나와야지」 — 공유 주소는 받은 사람이 이 결과지를 보는 /r/{id}(deploy/share.js).
   결과지 요약 · 무료 풀이 · 장마다 풀이 글 전부를 서버에 남긴다(생년월일 · 명식은 싣지 않는다). 공유를 누를 때만 만들고 공유한 날부터 1년 둔다.
   공유 카드 미리보기에서 주소와 이미지를 준비한 뒤 사용자의 다음 클릭으로 공유창을 연다. */
function 공유몸() {
  const tr = s => window.BGLANG?.t?.(s) ?? s;
  const { big, cells } = 요약(), fa = MAT?.무료?.무료축 || {};
  const names = fa.both ? [["첫 번째 사람과", fa.both.second], ["두 번째 사람과", fa.both.third]].filter(([, b]) => b?.type?.name).map(([lab, b]) => `${tr(lab)} ${tr(b.type.name)}`) : [fa.type?.name].filter(Boolean).map(tr);   // 10/27 점검 — 이름표와 이름을 따로 옮긴 뒤 붙인다
  const 글 = (w) => ({ cards: (w?.cards || []).map(tidy), advice: w?.advice ? tidy(w.advice) : "" });
  return {
    locale: window.BGLANG?.locale || "ko", no: M.no, questionId: M.engineId, title: tr(M.title), who: tr(M.name), img: new URL(M.end, location.origin + "/app/").pathname, big, cells: cells.map((c) => ({ t: tr(c.t), a: tr(c.a), ...(c.x ? { x: true } : {}) })),
    free: { axis: tr(fa.axis || M.free?.axis || ""), names, answer: WR.free?.answer ? tidy(WR.free.answer) : "", ...글(WR.free) },   // 1번 항목(갈래 · 그 풀이 글) — 결과지 1번 쪽과 같게
    chapters: CH.map((c) => ({ t: tr(c.t), big: WR.ch[c.idx]?.answer ? tidy(WR.ch[c.idx].answer) : 짧게(c.a), ...글(WR.ch[c.idx]) })),
  };
}
/* ── 보관함: 결과지를 받으면 엔진이 준 풀이 전부를 남긴다(src/vault.js 와 같은 자리 · 같은 꼴, 결과 판 2)
   사장님 9/26 「결과지 마지막은 요약된 정보만 나오잖아 보관함에서 볼 때는 풀이한 모든 글자들이 전부 보여야해」 — 보관함 화면은 src/Result.jsx ── */
/* 10/2 사장님 — 같은 질문을 두 번 사면(궁합을 다른 사람과 또 봄) 보관함의 앞 풀이를 덮어썼다(칸 이름이 질문 이름 하나였다). 산 풀이마다 따로 남긴다.
   칸 이름 = `${질문}~${k}` — k 는 이번 입력(engineReq 에서 질문을 뺀 것 — 기준일 · 사람들 · 헤어진 날 · 고른 답)을 JSON 으로 적은 글의 SHA-256 앞 8자(16진).
   유료로 들어갈 때(입력이 다 정해진 뒤 — startPaid) 한 번 잰다. 안전한 출처가 아니라 crypto.subtle 이 없으면 같은 글에 늘 같은 32비트 셈(FNV-1a)으로.
   예전 칸(질문 이름만)은 그대로 둔다(옮기지 않는다). 서버(deploy/me.js) · 보관함(src/vault.js)과 같은 약속 — 질문이 필요한 곳(후기 · 이어 보기)은 그대로 M.engineId. */
let VAULT_ID = null, VAULT_P = null;
function vaultKey() {
  if (VAULT_P) return VAULT_P;
  const r = { ...engineReq() }; delete r.questionId;
  const s = JSON.stringify(r), q = M.engineId;
  const fnv = () => { let h = 0x811c9dc5; for (const b of new TextEncoder().encode(s)) { h ^= b; h = Math.imul(h, 0x01000193); } return (h >>> 0).toString(16).padStart(8, "0"); };
  return (VAULT_P = (async () => {
    let k;
    try { k = [...new Uint8Array(await crypto.subtle.digest("SHA-256", new TextEncoder().encode(s)))].slice(0, 4).map((b) => b.toString(16).padStart(2, "0")).join(""); }
    catch { k = fnv(); }
    return (VAULT_ID = `${q}~${k}`);
  })());
}
// 10/28 — 보관함에 남기는 결과(결과 판 2)와 결제 뒤 결과지 층(06-paid 결과지몸 — sheet.js sajuSheet)이 같은 모양을 쓴다
function 결과몸() {
  const { 근거ID, 글쓰기약속, ...mat } = MAT;
  // at — 이 결과지를 남긴 때(ms). 보관함(src/vault.js)이 서버 것과 이 기기 것 가운데 새것을 고를 때 본다(10/1 코드 점검)
  return { v: 2, locale: window.BGLANG?.locale || "ko", at: Date.now(), no: M.no, name: M.name, title: M.title, room: M.room, img: new URL(M.end, location.origin + "/app/").pathname, chapters: M.paid.chapters, mat, writ: { free: WR.free, ch: WR.ch, conclusion: WR.conclusion } };
}
function saveVault() {
  if (!MAT) return;
  if (!VAULT_ID) { try { vaultKey().then(() => saveVault(), () => {}); } catch { /* 10/8 — 입력이 비면 칸 이름을 못 만든다 */ } return; }   // 칸 이름을 아직 재는 중 — 다 재면(바로) 남긴다
  const KEY = "bambee.vault.v1", now = new Date().toISOString();
  const result = 결과몸();
  try {
    let raw = [];
    try { raw = JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { if (!(e instanceof SyntaxError)) throw e; }   // 10/1 코드 점검 — 깨진 값이면 새로 쓴다(전엔 저장이 늘 막혔다)
    const list = Array.isArray(raw) ? raw.filter((e) => e && typeof e.id === "string") : [];
    const old = list.find((e) => e.id === VAULT_ID);   // 10/2 — 이번 풀이 칸만 바꾼다(같은 질문의 다른 풀이는 그대로)
    const owner = window.BGME?.owner?.() || null;   // 10/1 — 로그인한 채로 남기면 주인 표를 붙인다(me.js owner · src/vault.js). 비회원 것은 표 없이 — 계정으로 옮기지 않는다(10/8 사장님)
    const 남길 = [{ id: VAULT_ID, openedAt: old?.openedAt ?? now, result, resultAt: now, ...(owner ? { owner } : { tab: window.BGME?.tab?.() ?? null }) }, ...list.filter((e) => e.id !== VAULT_ID)];   // 10/28 비회원 칸은 이 탭 표(me.js tab — 로그인하면 이 탭 것만 넘겨받는다)
    // 10/27 점검 — 비회원 결과지는 이 기기에만 쌓여 저장 공간이 차면 이번 결과지도 못 남겼다. 가득 차면 가장 오래된 것(목록 맨 뒤)부터 지우고 다시 남긴다
    for (;;) {
      try { localStorage.setItem(KEY, JSON.stringify(남길)); break; }
      catch (e) { if (남길.length <= 1 || !/quota/i.test(`${e?.name} ${e?.message}`)) throw e; 남길.pop(); }
    }
  } catch { /* 사파리 비공개 모드 등에서는 저장이 막힌다. 화면은 그대로 돈다. */ }
  // 9/30 로그인한 회원은 서버에도 남긴다(1년, 다른 기기 보관함에서도 보인다 — me.js vaultSave · deploy/me.js). 글이 다 오기 전이면 다 온 뒤 다시 부른다(덮어쓴다).
  // 10/1 코드 점검 — 이 기기 저장이 막혀도 서버에는 보낸다(따로 둔다). 1.5초 안에 화면을 벗어나면 그때 바로 보낸다(flushVault — 전엔 빨리 나가면 사라졌다).
  saveVault.r = result; saveVault.id = VAULT_ID; clearTimeout(saveVault.t); saveVault.t = setTimeout(flushVault, 1500);
}
function 이번칸주인(id, who, result) {
  if (!who || !id) return;
  try {
    const KEY = "bambee.vault.v1", list = JSON.parse(localStorage.getItem(KEY) || "[]");
    const row = Array.isArray(list) ? list.find((e) => e?.id === id) : null;
    if (!row || row.owner || JSON.stringify(row.result) !== JSON.stringify(result)) return;
    row.owner = who;
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch { /* 표만 못 남김. 서버 저장은 claim 으로 따로 간다 */ }
}
function flushVault(keep) {   // keep — 화면을 닫는 중에도 끝까지 보낸다(keepalive, me.js). 이 기기 저장이 막혀도 확인된 이번 결과는 서버에 보낸다.
  clearTimeout(saveVault.t);
  const r = saveVault.r, id = saveVault.id;
  saveVault.r = null;
  if (!r || !id) return;
  const send = (who) => { try { window.BGME?.vaultSave?.(id, r, { ...(keep === true ? { keepalive: true } : {}), claim: who }); } catch { /* 서버 보관 없이 */ } };
  const wait = window.BGME?.when?.(), gen = window.BGME?.gen?.();
  if (!wait) { const who = window.BGME?.owner?.() || null; if (who) { 이번칸주인(id, who, r); send(who); } return; }
  wait.then((who) => {
    if (!who || (gen != null && window.BGME?.gen?.() !== gen)) return;
    이번칸주인(id, who, r);
    send(who);
  }).catch(() => { /* 로그인 확인이 실패하면 이 기기에만 둔다 */ });
}

let started = false;
const started바꿈 = (값) => (started = 값);
/* 10/20 — 아이폰(사파리)은 손님이 누른 그 순간에 한 번 튼 요소만 나중에 스스로 튼다(소리 나는 대사 요소 — 저전력 모드에서는 소리 없는 대기 · 회상 영상도).
   그래서 푸는 일은 손님의 실제 누름(isTrusted) 안에서만 한다 — 「시작」 누름 · 자료가 오기 전에 일찍 누름(미리) · 동의 창 누름(service-agreement.js 가 대사 요소 · 효과음을 풀고 bg:agreement-prepare 를 보낸다).
   예전엔 누름 밖에서도 도는 runFree(일찍 누른 뒤 준비가 끝나 시작할 때 · 동의를 저장한 뒤 다시 누를 때)가 다시 풀어, 누름 밖에서 만든 새 대사 요소가 맨 먼저 쓰여
   아이폰에서 대사가 한 줄 건너 소리 없이 틀어졌고, 동의 창 · 일찍 누른 길은 대기 · 회상 영상을 누름 밖에서 처음 틀었다 */
function 영상풀기() { idle.play().catch(() => {}); idle.pause(); window.BGMEMORY?.unlock(); }
function 누름풀기() { unlock(8); if (typeof SFX !== "undefined") SFX.wake(); 영상풀기(); }
addEventListener("bg:agreement-prepare", 영상풀기);
// 「소리 켜고 시작」. 10/1 코드 점검 — 두 번 눌러도(설명 판 단추 · 빠른 두 번 누름) 한 번만 시작한다(전엔 무비가 둘 겹쳐 돌았다)
function startTap(e) {
  if (started) return;
  media();                                                                // 10/2 — 영상을 아직 안 걸었으면(설명 판 그림을 기다리는 중) 지금 건다
  started바꿈(true);
  globalThis.BGEV?.("movie_start", { q: M.engineId });                       // 10/22 손님 흐름 단계(public/app/funnel.js)
  if (e?.isTrusted) 누름풀기();                                            // 일찍 누른 뒤 준비가 끝나 시작할 때(boot) · 동의 창이 다시 누를 때(합성 클릭)는 그 누름에서 이미 풀었다
  idle.preload = "auto"; idle.play().catch(() => {});
  runFree();
}

/* ── 시작 ── */
/* 10/2 점검 — 홈에서 뺀 옛 질문(?c=05 등)도 주소로 들어오면 열려 옛 인물이 반말로 말했다. 홈 목록(data/home.json)에 없는 질문이면 아무것도 띄우기 전에 홈으로 보낸다.
   가름은 홈(src/data.js)과 같다 — ready 가 false 가 아닌 카드, 이 맥(localhost)에서는 localReady 카드도(심리 테스트). 목록을 못 받으면 막지 않는다. */
function onHome() {
  const 로컬 = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
  return fetch("data/home.json", { cache: "no-cache" }).then((r) => (r.ok ? r.json() : null)).then((h) => {
    if (!Array.isArray(h?.items)) return true;
    return h.items.some((x) => x && Number(x.no) === Number(C) && (x.ready !== false || (로컬 && x.localReady)));
  }).catch(() => true);
}
(async function boot() {
  // 10/13 사장님 「다음영상이 바로바로 재생되는지 … 체크해」 점검 — 「시작」은 화면이 열리자마자 보이는데 누름은 자료(인물 · 홈 목록 · 묶음)를 다 받은 뒤에야 받았다.
  //   그 사이(느린 통신이면 몇 초) 누르면 아무 일도 없었다(30초 넘게 그대로). 일찍 누르면 그 순간 소리만 풀어 두고 준비가 끝나면 바로 시작한다
  let 일찍 = false;
  const 미리 = (e) => { if (일찍 || started) return; 일찍 = true; if (e.isTrusted) 누름풀기(); bgm.start(M?.no ?? C, M?.room, { later: true }); };
  $("startBtn").addEventListener("click", 미리);
  const homeP = onHome();
  let none = false;
  const speechP = fetch("data/speech.json?v=20261018-liveaction", { cache: "no-cache" }).then((r) => r.ok ? r.json() : null).catch(() => null);
  try { M바꿈(await fetch(`data/${C}.json`, { cache: "no-cache" }).then((r) => { if (!r.ok) throw new Error(); noteClock(r); return r.json(); }));
    const timings = (await speechP)?.[C];
    for (const [k, t] of Object.entries(timings || {})) if (M.lines[k]) [M.lines[k].aa, M.lines[k].ab, M.lines[k].va] = t;
    for (const [k, frame] of Object.entries(window.BGVIDEOOPT?.idleReturns?.[C] || {})) if (M.lines[k]) M.lines[k].idleReturn = frame;
  }   // noteClock — 서버 시계(풀이 기준일, 10/1)
  catch { none = true; }
  if (!(await homeP)) { location.replace("/"); return; }
  // 10/8 애플 기준 — 빈 화면에는 다음 할 일과 단추(3-화면글-점검 23): 탭 제목 「준비 중 | 밤과비」 · 시작 단추 자리에 「홈으로」
  if (none) {
    document.title = "준비 중 | 밤과비"; $("startBtn").insertAdjacentHTML("beforebegin", "<h1>준비 중인 운세예요</h1>"); $("startBtn").style.display = "none";
    $("startBtn").insertAdjacentHTML("afterend", '<button type="button" class="cta" id="noneHome">홈으로</button>'); $("noneHome").onclick = goHome;
    return;
  }
  document.documentElement.dataset.room = M.room;
  document.documentElement.dataset.readingNo = M.no;
  window.BGMEMORY?.setup(M, stage, SFX);
  // 10/7 사장님 「형식 맞춰서」 · 「전부 고쳐」 — 탭 제목은 「질문 | 이름」. 영어 · 일본어는 서버가 보낸 제목을 두고, 한국어도 같은 꼴로
  if (!window.BGLANG?.locale || window.BGLANG.locale === "ko") document.title = `${M.title} | 밤과비`;
  // 10/21 매일 운세 알림을 눌러 들어오면(?alarm=1) 저장된 운세 정보로 오늘의 운세 결과지를 바로 연다(05-free.js runDailyAlarm) — 기다리는 동안 시작 단추는 감추고, 못 열면 평소대로
  if (M.mode === "daily" && new URLSearchParams(location.search).get("alarm") === "1") {
    $("gate").style.visibility = "hidden";
    if (await runDailyAlarm().catch(() => false)) { $("startBtn").removeEventListener("click", 미리); return; }
    $("gate").style.visibility = "";
  }
  $("gate").style.backgroundImage = `url(${M.front})`;
  globalThis.BGEV?.("page", { q: M.engineId });                              // 10/22 손님 흐름 단계 — 알림으로 바로 연 결과지는 빼고
  {                                                                       // 이어 틀기 — 이 인물의 묶음이 있으면(reel.json) 재생기 둘을 건다
    // 10/2 점검 — 묶음이 없는 인물은 서버가 404 대신 200 {"off":1} 로 답한다(콘솔에 404 가 쌓이지 않게). off 는 404 와 같이 「묶음 없음」(예전 길로 줄 파일을 연다)
    // 10/9 묶음은 한국어 길이로 이어 붙였다 — 더빙하는 외국어 화면은 묶음을 쓰지 않고 줄마다 튼다(더빙이 길면 그 줄 끝 자세로 기다린다 — 02-stage endPose)
    const dubbing = !!window.BGDUB?.on;
    const j = dubbing ? null : await fetch(`${M.media}reel.json`, { cache: "no-cache" }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
    // 10/13 — 일찍 누른 때는 묶음 재생기를 만들지 않는다(누른 순간 풀린 요소가 아니라 아이폰에서 대사 소리가 꺼진다). 풀어 둔 요소로 줄마다 튼다
    if (j && !j.off && j.sets?.free && !일찍) {
      RL.sets = j.sets;
      M.idle = `${M.media}${j.idle || "idle-reel.mp4"}`;
      for (let i = 0; i < 2; i++) {                                     // 재생기 둘 — 첫째는 첫 줄 자리를 미리 받아 두고, 둘째는 틀 때 받는다. 고장 나면 남은 줄은 예전 길로
        const v = mk(); v._k = null; v._set = "free"; v.preload = i ? "metadata" : "auto";   // 묶음 주소는 media() 가 건다
        v.addEventListener("error", () => { RL.broken = true; }); RL.lanes.push(v);
      }
    }
  }
  fetch(window.BGVIDEOOPT?.poses?.[C] || `data/pose/${C}.json`).then((r) => (r.ok ? r.json() : null)).then((j) => { POSE바꿈(j); }).catch(() => {});   // 얼굴 자리 표(없으면 맞춤 없이 겹친다)
  media();
  $("startBtn").removeEventListener("click", 미리);
  $("startBtn").onclick = startTap;
  if (일찍) startTap();
})();
// 영상 걸기 — 대기 영상 · 이어 틀기 묶음 · 첫 줄. 한 번만(boot · startTap)
let mediaOn = false;
function media() {
  if (mediaOn || !M) return; mediaOn = true;
  if (RL.lanes.length) { const free = loadSet("free"); RL.lanes.forEach((v) => { v.src = free; }); }
  idle.preload = "metadata"; idle.src = M.idle;
  idleB.preload = "none"; idleB.src = M.idle;                            // 10/2 점검 — 둘째 대기 영상은 처음 겹칠 때 받는다(loopBack)
  preload(M.flow.intro[0] || M.flow.inputs[0] || "C02");
}
// 줄 k 를 끝까지 받은 뒤 fn(이어 틀기 묶음 · 없는 줄은 바로)
function afterFull(k, fn) { const v = pool.get(k); if (!v || lane(v)) { fn(); return; } ready(v).then(fn); }
})();
